/** English source text to Armenian. The live UI looks these up; English and Russian keep the source. */
export const hyPhrases: Readonly<Record<string, string>> = {
  '(required)': '(պարտադիր)',
  'Reference:': 'Հղում՝',
  'Something went wrong on our side.': 'Մեր կողմում սխալ առաջացավ։',
  'Something went wrong on our side. Please try again later.':
    'Մեր կողմում սխալ առաջացավ։ Խնդրում ենք փորձել ավելի ուշ։',
  'Something went wrong. Please try again.': 'Ինչ-որ բան սխալ ընթացավ։ Խնդրում ենք կրկին փորձել։',
  'Too many attempts. Please wait a few minutes and try again.':
    'Չափազանց շատ փորձեր։ Խնդրում ենք սպասել մի քանի րոպե և կրկին փորձել։',
  'The server could not be reached. Check your connection and try again.':
    'Սերվերը հասանելի չէ։ Ստուգեք կապը և կրկին փորձեք։',
  'The server sent an unexpected response. Please try again later.':
    'Սերվերը անսպասելի պատասխան ուղարկեց։ Խնդրում ենք փորձել ավելի ուշ։',
  'This record was changed by someone else. Reload and try again.':
    'Այս գրառումը փոխվել է մեկ ուրիշի կողմից։ Թարմացրեք էջը և կրկին փորձեք։',
  'Please retry shortly.': 'Խնդրում ենք շուտով կրկին փորձել։',
  'Verification is temporarily unavailable. Please retry shortly.':
    'Ստուգումը ժամանակավորապես անհասանելի է։ Խնդրում ենք շուտով կրկին փորձել։',
  'The invitation e-mail could not be sent, so the invitation was not saved. Try again shortly.':
    'Հրավերի նամակը չհաջողվեց ուղարկել, ուստի հրավերը չի պահպանվել։ Փորձեք կրկին մի փոքր ուշ։',
  '“Not counted” never assumes a vote.': '«Չհաշվված» կարգավիճակը երբեք չի ենթադրում քվե։',
  '0 turns reminders off.': '0 արժեքն անջատում է հիշեցումները։',
  '0–30 days': '0–30 օր',
  '1 unit of': '1 միավոր',
  '31–60 days': '31–60 օր',
  '6-digit code from your authenticator app, or a recovery code.':
    'Նույնականացման հավելվածի 6-նիշանոց կոդը կամ վերականգնման կոդ։',
  '61–90 days': '61–90 օր',
  'A blocker waits for me': 'Արգելափակումը սպասում է ինձ',
  'A cancelled task stops counting as open or overdue. It stays visible in the history and on its decision.':
    'Չեղարկված առաջադրանքն այլևս չի հաշվվում որպես բաց կամ ժամկետանց։ Այն տեսանելի է մնում պատմության մեջ և իր որոշման էջում։',
  'a corrected entry': 'ուղղված գրառում',
  'A critical topic is opened': 'Բացվել է կրիտիկական թեմա',
  'A debt between two founders that did not come from a payment — for example an agreed correction. It needs evidence and a reason, and can be reversed but never edited.':
    'Երկու հիմնադիրների միջև պարտք, որը չի առաջացել վճարումից — օրինակ՝ համաձայնեցված ուղղում։ Այն պահանջում է ապացույց և պատճառ, կարող է հակադարձվել, բայց երբեք չի խմբագրվում։',
  'A decision is finalized': 'Որոշումը վերջնականացվել է',
  'A document, pull request or file that shows the result.':
    'Փաստաթուղթ, pull request կամ ֆայլ, որը ցույց է տալիս արդյունքը։',
  'A finalized decision that approved this change. Either this or a reference is required.':
    'Վերջնական որոշում, որը հաստատել է այս փոփոխությունը։ Պարտադիր է սա կամ հղումը։',
  'A founder cannot submit while a required section is empty.':
    'Հիմնադիրը չի կարող ուղարկել, քանի դեռ պարտադիր բաժինը դատարկ է։',
  'A funding call is due': 'Ֆինանսավորման կանչի ժամկետը լրանում է',
  'A measurable result, e.g. “Reach 100 paying customers”.':
    'Չափելի արդյունք, օրինակ՝ «Հասնել 100 վճարող հաճախորդի»։',
  'A meeting I take part in changes': 'Փոփոխվել է հանդիպում, որին մասնակցում եմ',
  'A proposal has no effect until a manager approves it with the founders’ decision and an effective date.':
    'Առաջարկն ուժ չունի, քանի դեռ կառավարիչը չի հաստատել այն հիմնադիրների որոշմամբ և ուժի մեջ մտնելու ամսաթվով։',
  'A proposal records the calculation and each founder’s share. Nothing is owed or paid until a manager approves it with a finalized founder decision, and payments are then recorded one by one.':
    'Առաջարկը գրանցում է հաշվարկը և յուրաքանչյուր հիմնադրի մասնաբաժինը։ Ոչինչ պարտք չէ և չի վճարվում, քանի դեռ կառավարիչը չի հաստատել այն հիմնադիրների վերջնականացված որոշմամբ, որից հետո վճարումները գրանցվում են մեկ առ մեկ։',
  'A recalculation reuses the book figures of the original snapshot. Override one only to correct it, with the reason — the books themselves are not changed.':
    'Վերահաշվարկը կրկին օգտագործում է սկզբնական պատկերի հաշվապահական թվերը։ Փոխարինեք թիվը միայն այն ուղղելու համար՝ նշելով պատճառը — հաշվապահական գրքերն իրենք չեն փոփոխվում։',
  'A recorded decision settles the item. Choose the decision.':
    'Կետը լուծվում է գրանցված որոշմամբ։ Ընտրեք որոշումը։',
  'A short digest of the submitted updates for this period. It describes work, not people, and never ranks founders.':
    'Այս ժամանակահատվածի ուղարկված թարմացումների համառոտ ամփոփում։ Այն նկարագրում է աշխատանքը, ոչ թե մարդկանց, և երբեք չի դասակարգում հիմնադիրներին։',
  'A suggested decision record built from this topic. It only becomes a decision if you open it in the decision form, check it and save it.':
    'Այս թեմայից կազմված որոշման առաջարկվող գրառում։ Այն որոշում է դառնում միայն այն դեպքում, եթե բացեք այն որոշման ձևում, ստուգեք և պահեք։',
  'A summary of the discussion with open questions and the options on the table. It is shared with everyone who can see this topic.':
    'Քննարկման ամփոփում՝ բաց հարցերով և քննարկվող տարբերակներով։ Այն հասանելի է բոլորին, ովքեր կարող են տեսնել այս թեման։',
  'A task is assigned to me': 'Ինձ հանձնարարվել է առաջադրանք',
  'A write-off or other treatment must be approved by a finalized founder decision.':
    'Դուրսգրումը կամ այլ մշակումը պետք է հաստատվի հիմնադիրների վերջնական որոշմամբ։',
  Absent: 'Բացակա',
  Abstain: 'Ձեռնպահ մնալ',
  'Abstain after deadline': 'Ձեռնպահ վերջնաժամկետից հետո',
  'Abstentions count toward quorum': 'Ձեռնպահ քվեները հաշվվում են քվորումի մեջ',
  'Accept late updates for (hours)': 'Ընդունել ուշացած թարմացումները (ժամ)',
  'Accept until finalization': 'Ընդունել մինչև վերջնականացում',
  'Acceptance criteria': 'Ընդունման չափանիշներ',
  Accepted: 'Ընդունված',
  'Accepted until': 'Ընդունվում է մինչև',
  'Access only': 'Միայն մուտք',
  'Access only (can read)': 'Միայն հասանելիություն (կարող է կարդալ)',
  Account: 'Հաշիվ',
  'Accountable owner:': 'Պատասխանատու սեփականատեր:',
  'Accounting result (context only)': 'Հաշվապահական արդյունք (միայն համատեքստի համար)',
  'Accounting system': 'Հաշվապահական համակարգ',
  'Accounts and exchange rates': 'Հաշիվներ և փոխարժեքներ',
  'Accounts could not be loaded': 'Չհաջողվեց բեռնել հաշիվները',
  Achieved: 'Ձեռք բերված',
  Action: 'Գործողություն',
  'Action items': 'Գործողության կետեր',
  'Action items were agreed. Create at least one task first.':
    'Գործողությունները համաձայնեցված են։ Նախ ստեղծեք առնվազն մեկ առաջադրանք։',
  Actions: 'Գործողություններ',
  'Actions can be created once the decision is finalized.':
    'Գործողությունները կարելի է ստեղծել որոշումը վերջնականացնելուց հետո։',
  'Actions from this decision': 'Այս որոշումից բխող գործողություններ',
  Active: 'Ակտիվ',
  'Active founders': 'Ակտիվ հիմնադիրներ',
  'Active founders and granted members': 'Ակտիվ հիմնադիրներ և իրավունք ստացած անդամներ',
  Add: 'Ավելացնել',
  'Add a category': 'Ավելացնել կատեգորիա',
  'Add a comment': 'Ավելացնել մեկնաբանություն',
  'Add a company account': 'Ավելացնել ընկերության հաշիվ',
  'Add a custom item': 'Ավելացնել հատուկ կետ',
  'Add a key result': 'Ավելացնել հիմնական արդյունք',
  'Add a key result…': 'Ավելացնել հիմնական արդյունք…',
  'Add a note or dispute': 'Ավելացնել նշում կամ վիճարկում',
  'Add a person': 'Ավելացնել անձ',
  'Add a prerequisite': 'Ավելացնել նախապայման',
  'Add a waiting item': 'Ավելացնել սպասող կետ',
  'Add a waiting item from the queue': 'Ավելացնել սպասող կետ հերթից',
  'Add account': 'Ավելացնել հաշիվ',
  'Add account…': 'Ավելացնել հաշիվ…',
  'Add action item…': 'Ավելացնել գործողության կետ…',
  'Add another action': 'Ավելացնել ևս մեկ գործողություն',
  'Add evidence': 'Ավելացնել ապացույց',
  'Add evidence link': 'Ավելացնել ապացույցի հղում',
  'Add exchange rates': 'Ավելացնել փոխարժեքներ',
  'Add item': 'Ավելացնել կետ',
  'Add link': 'Ավելացնել հղում',
  'Add prerequisite': 'Ավելացնել նախապայման',
  'Add responsibility': 'Ավելացնել պատասխանատվություն',
  'Add this account?': 'Ավելացնե՞լ այս հաշիվը',
  'Add to agenda': 'Ավելացնել օրակարգում',
  'Adds the highest-ranked waiting items until the time budget is used. Restricted topics that some participants may not see are skipped.':
    'Ավելացնում է ամենաբարձր դասակարգված սպասող կետերը, մինչև ժամանակի սահմանաչափը սպառվի։ Սահմանափակ մուտքով թեմաները, որոնք որոշ մասնակիցներ կարող են չտեսնել, բաց են թողնվում։',
  Adjustment: 'Ճշգրտում',
  Adjustments: 'Ճշգրտումներ',
  Advance: 'Կանխավճար',
  'Advance to the company': 'Կանխավճար ընկերությանը',
  Against: 'Դեմ',
  Agenda: 'Օրակարգ',
  'Agenda from the queue': 'Օրակարգ հերթից',
  'Agenda items to add': 'Ավելացվող օրակարգային կետեր',
  'Agenda, in order': 'Օրակարգ՝ ըստ հերթականության',
  Ai: 'AI',
  'AI assistant': 'AI օգնական',
  'Ai draft confirmed': 'AI սևագիրը հաստատված է',
  'Ai unavailable': 'AI-ն հասանելի չէ',
  All: 'Բոլորը',
  'All accounts': 'Բոլոր հաշիվները',
  'All blockers': 'Բոլոր արգելափակումները',
  'All calls': 'Բոլոր կանչերը',
  'All debts': 'Բոլոր պարտքերը',
  'All distributions': 'Բոլոր բաշխումները',
  'All eligible': 'Բոլոր իրավասուները',
  'All funding calls': 'Ֆինանսավորման բոլոր կանչերը',
  'All kinds': 'Բոլոր տեսակները',
  'All overdue tasks': 'Բոլոր ժամկետանց առաջադրանքները',
  'All square': 'Փոխադարձ պարտքեր չկան',
  'All tasks': 'Բոլոր առաջադրանքները',
  'All visible': 'Բոլոր տեսանելիները',
  'Alphabetical. What someone owes and what they are owed stay separate.':
    'Այբբենական կարգով։ Այն, ինչ մեկը պարտք է, և այն, ինչ իրեն են պարտք, ցուցադրվում են առանձին։',
  'Always on': 'Միշտ միացված',
  Amend: 'Փոփոխել',
  Amends: 'Փոփոխում է',
  Amount: 'Գումար',
  'Amount each founder commits': 'Յուրաքանչյուր հիմնադրի պարտավորվող գումարը',
  'An obligation is due': 'Պարտավորության ժամկետը լրանում է',
  'and follow the link we email you.': 'և անցեք այն հղումով, որը մենք կուղարկենք ձեր էլ. փոստին։',
  Annual: 'Տարեկան',
  Any: 'Ցանկացած',
  'Any account': 'Ցանկացած հաշիվ',
  'Any category': 'Ցանկացած կատեգորիա',
  Anyone: 'Ցանկացած անձ',
  'Anything that could go wrong soon.': 'Այն ամենը, ինչը մոտ ապագայում կարող է սխալ ընթանալ։',
  Applied: 'Կիրառված',
  'Applied to': 'Կիրառված է',
  'Applied to shares': 'Կիրառված է բաժնեմասերի նկատմամբ',
  Apply: 'Կիրառել',
  'Apply filters': 'Կիրառել զտիչները',
  'Apply the payment to': 'Ուղղել վճարումը',
  Approval: 'Հաստատում',
  'Approval (can also be given when approving)': 'Հավանություն (կարող է տրվել նաև հաստատելիս)',
  'Approval fraction': 'Հաստատման մասնաբաժին',
  'Approval is binding governance configuration and is audited. You may be asked to confirm your identity again.':
    'Հաստատումը կառավարման պարտադիր կարգավորում է և ենթարկվում է աուդիտի։ Ձեզանից կարող է պահանջվել կրկին հաստատել ձեր ինքնությունը։',
  'Approval reference': 'Հաստատման հղում',
  'Approval rule': 'Հաստատման կանոն',
  'Approval threshold': 'Հաստատման շեմ',
  Approve: 'Հաստատել',
  'Approve / reject': 'Հաստատել / մերժել',
  'Approve version': 'Հաստատել տարբերակը',
  'Approve, reject, abstain or ask for more discussion.':
    'Հաստատեք, մերժեք, ձեռնպահ մնացեք կամ խնդրեք լրացուցիչ քննարկում։',
  'Approve…': 'Հաստատել…',
  Approved: 'Հաստատված',
  'Approved at': 'Հաստատման ժամանակը',
  'Approved budget': 'Հաստատված բյուջե',
  'Approved by': 'Հաստատող',
  'Approved only if nobody rejects and nobody asks for more discussion.':
    'Հաստատվում է միայն, եթե ոչ ոք չի մերժում և ոչ ոք լրացուցիչ քննարկում չի խնդրում։',
  'Approving decision': 'Հաստատող որոշում',
  'Approving decision ID': 'Հաստատող որոշման ID',
  Archive: 'Արխիվացնել',
  'Archive task': 'Արխիվացնել առաջադրանքը',
  Archived: 'Արխիվացված',
  'Archived (not available for new entries)': 'Արխիվացված (հասանելի չէ նոր գրառումների համար)',
  'Archived tasks are hidden from default lists but kept with their full history.':
    'Արխիվացված առաջադրանքները թաքցված են լռելյայն ցանկերից, բայց պահպանվում են իրենց ամբողջական պատմությամբ։',
  Area: 'Ոլորտ',
  'Arr multiple': 'ARR բազմապատիկ',
  'ARR multiple': 'ARR բազմապատկիչ',
  As: 'Որպես',
  'As of': 'Առ',
  'Ask a question about the workspace': 'Հարց տվեք աշխատատիրույթի մասին',
  'Ask a question to search.': 'Որոնելու համար հարց տվեք։',
  'Ask for a topic or question to be discussed at the next meeting. Organizers see the request in the queue.':
    'Խնդրեք, որ թեման կամ հարցը քննարկվի հաջորդ հանդիպմանը։ Կազմակերպիչները հարցումը տեսնում են հերթում։',
  'Ask the person who invited you to send a new invitation.':
    'Խնդրեք ձեզ հրավիրած անձին ուղարկել նոր հրավեր։',
  'Assumed length of items without a requested time (minutes)':
    'Առանց պահանջված ժամանակի կետերի ենթադրյալ տևողությունը (րոպե)',
  Assumption: 'Ենթադրություն',
  Assumptions: 'Ենթադրություններ',
  'Assumptions in this scenario': 'Այս սցենարի ենթադրությունները',
  'Assumptions of the valuation': 'Գնահատման ենթադրությունները',
  'At most 2 decimals.': 'Առավելագույնը 2 տասնորդական նիշ։',
  'At risk': 'Ռիսկի տակ',
  'Attach a link': 'Կցել հղում',
  Attachments: 'Կցորդներ',
  'Attendance saved.': 'Մասնակցությունը պահված է։',
  Attended: 'Մասնակցել է',
  Authenticated: 'Նույնականացված',
  'Authentication code': 'Նույնականացման կոդ',
  Author: 'Հեղինակ',
  Auto: 'Ավտո',
  Automatic: 'Ավտոմատ',
  'Average monthly expenses': 'Միջին ամսական ծախսեր',
  'Averaged over (complete months)': 'Միջինացման ժամանակահատված (ամբողջական ամիսներ)',
  'Awaiting classification': 'Սպասում է դասակարգման',
  'Awaiting vote': 'Սպասում է քվեի',
  'Awaiting your input': 'Սպասում է ձեր մասնակցությանը',
  'Away from zero': 'Զրոյից հեռու',
  Back: 'Հետ',
  'Back to goals': 'Վերադառնալ նպատակներին',
  'Back to meetings': 'Վերադառնալ հանդիպումներին',
  'Back to sign in': 'Վերադառնալ մուտքի էջ',
  'Background and facts. Required to publish.':
    'Նախապատմություն և փաստեր։ Պարտադիր է հրապարակելու համար։',
  Backlog: 'Սպասման ցուցակ',
  'Bad request': 'Սխալ հարցում',
  Balance: 'Մնացորդ',
  'Balance after': 'Մնացորդը հետո',
  'Balance sheet': 'Հաշվեկշիռ',
  'Ballot options': 'Քվեաթերթիկի տարբերակներ',
  Bank: 'Բանկ',
  'Bank movements': 'Բանկային շարժեր',
  'Bank movements could not be loaded': 'Չհաջողվեց բեռնել բանկային շարժերը',
  'Bank reconciliation': 'Բանկային համաձայնեցում',
  'Bank reports stay in each currency':
    'Բանկային հաշվետվությունները մնում են յուրաքանչյուր արժույթով',
  'Bank transfer': 'Բանկային փոխանցում',
  'Bank transfer reference, if any.': 'Բանկային փոխանցման հղումը, եթե կա։',
  'Bank transfer, card…': 'Բանկային փոխանցում, քարտ…',
  'Bank-reported': 'Ըստ բանկի տվյալների',
  Base: 'Բազային',
  'Base multiple': 'Բազային մուլտիպլիկատոր',
  'Between founders, and between a founder and the company. A debt stays with the founder when ownership changes.':
    'Հիմնադիրների միջև, ինչպես նաև հիմնադրի և ընկերության միջև։ Սեփականության փոփոխության դեպքում պարտքը մնում է հիմնադրի վրա։',
  Billing: 'Հաշվարկային վճարումներ',
  Binary: 'Երկընտրանքային',
  Biweekly: 'Երկշաբաթյա',
  Blocked: 'Արգելափակված',
  'Blocked today': 'Այսօր արգելափակված',
  Blocker: 'Արգելափակում',
  'Blocker aging': 'Արգելափակումների տևողություն',
  'Blocker resolved': 'Արգելափակումը լուծված է',
  'Blocker views': 'Արգելափակումների դիտումներ',
  'Blocker waiting': 'Արգելափակումը սպասում է',
  Blockers: 'Արգելափակումներ',
  'Blockers waiting on me': 'Ինձնից սպասող արգելափակումներ',
  Blocking: 'Արգելափակող',
  Blocks: 'Արգելափակում է',
  'Book balance': 'Հաշվապահական մնացորդ',
  'Book bank difference': 'Հաշվապահական և բանկային տարբերություն',
  'Book figures corrected': 'Հաշվապահական թվերն ուղղված են',
  Booked: 'Գրանցված',
  Books: 'Հաշվապահական գրանցումներ',
  'Bridge item missing': 'Կապող տարրը բացակայում է',
  'Burn and runway': 'Ծախս և գործունեության պաշար',
  'Burn and runway by currency': 'Ծախս և գործունեության պաշար՝ ըստ արժույթի',
  'Burn window (complete months)': 'Ծախսի ժամանակահատված (ամբողջական ամիսներ)',
  Burning: 'Միջոցների ծախսում',
  'Burning cash': 'Դրամական միջոցների այրում',
  'Business model': 'Բիզնես մոդել',
  Cadence: 'Պարբերականություն',
  'Calculate and save': 'Հաշվարկել և պահել',
  'Calculation lines': 'Հաշվարկի տողեր',
  'Calculation stored with the proposal': 'Առաջարկի հետ պահված հաշվարկը',
  Call: 'Կանչ',
  'Call cancelled — not owed': 'Կանչը չեղարկված է — պարտք չկա',
  'Call totals': 'Կանչի ընդհանուր գումարներ',
  'Calls being collected': 'Հավաքագրվող կանչեր',
  Cancel: 'Չեղարկել',
  'Cancel blocker': 'Չեղարկել արգելափակումը',
  'Cancel call': 'Չեղարկել կանչը',
  'Cancel call…': 'Չեղարկել կանչը…',
  'Cancel distribution': 'Չեղարկել բաշխումը',
  'Cancel distribution…': 'Չեղարկել բաշխումը…',
  'Cancel meeting': 'Չեղարկել հանդիպումը',
  'Cancel meeting…': 'Չեղարկել հանդիպումը…',
  'Cancel round': 'Չեղարկել փուլը',
  'Cancel task': 'Չեղարկել առաջադրանքը',
  'Cancel task…': 'Չեղարկել առաջադրանքը…',
  'Cancel this blocker?': 'Չեղարկե՞լ այս արգելափակումը',
  'Cancel this funding call?': 'Չեղարկե՞լ ֆինանսավորման այս կանչը',
  'Cancel this meeting?': 'Չեղարկե՞լ այս հանդիպումը',
  Cancelled: 'Չեղարկված',
  'Cannot be computed': 'Հնարավոր չէ հաշվարկել',
  'Cap table draft pending': 'Բաժնեմասերի աղյուսակի սևագիրը սպասում է',
  'Cap table versions': 'Բաժնեմասերի աղյուսակի տարբերակներ',
  'Capital contribution': 'Կապիտալի ներդրում',
  'Carried as debt': 'Հաշվառված որպես պարտք',
  'Carried as debts': 'Փոխանցված որպես պարտքեր',
  'Carried as debts (closed calls)': 'Փոխանցված որպես պարտքեր (փակված կանչեր)',
  Cash: 'Կանխիկ միջոցներ',
  'Cash at start': 'Դրամական միջոցները սկզբում',
  'Cash by currency': 'Դրամական միջոցներ՝ ըստ արժույթի',
  'Cash now (book)': 'Ներկայիս դրամական միջոցներ (հաշվապահական)',
  'Cash payment': 'Կանխիկ վճարում',
  'Cash position': 'Դրամական դիրք',
  'Cash set aside': 'Առանձնացված դրամական միջոցներ',
  'Cast binding vote': 'Տալ պարտադիր քվե',
  'Cast your vote': 'Տվեք ձեր քվեն',
  Categories: 'Կատեգորիաներ',
  'Categories could not be loaded': 'Չհաջողվեց բեռնել կատեգորիաները',
  Category: 'Կատեգորիա',
  'Category policies': 'Կատեգորիաների քաղաքականություններ',
  Caveats: 'Վերապահումներ',
  Celebrate: 'Տոնել',
  'Central Bank of Armenia': 'Հայաստանի Կենտրոնական բանկ',
  Ceo: 'Գործադիր տնօրեն',
  Change: 'Փոխել',
  'Change a category policy': 'Փոխել կատեգորիայի քաղաքականությունը',
  'Change owner': 'Փոխել սեփականատիրոջը',
  'Change owner…': 'Փոխել սեփականատիրոջը…',
  'Change responsibility status?': 'Փոխե՞լ պատասխանատվության կարգավիճակը',
  'Change status': 'Փոխել կարգավիճակը',
  'Change status…': 'Փոխել կարգավիճակը…',
  'Change the category policy?': 'Փոխե՞լ կատեգորիայի քաղաքականությունը',
  'Change the finance reporting rules?': 'Փոխե՞լ ֆինանսական հաշվետվության կանոնները',
  'Change the goal status': 'Փոխել նպատակի կարգավիճակը',
  'Change topic status': 'Փոխել թեմայի կարգավիճակը',
  Changed: 'Փոխված է',
  Channels: 'Ալիքներ',
  'Checking your invitation…': 'Ձեր հրավերը ստուգվում է…',
  Checklist: 'Ստուգաթերթ',
  Choice: 'Ընտրություն',
  'Choose a category': 'Ընտրեք կատեգորիա',
  'Choose a category.': 'Ընտրեք կատեգորիա։',
  'Choose a member': 'Ընտրեք անդամ',
  'Choose a new password': 'Ընտրեք նոր գաղտնաբառ',
  'Choose a permission': 'Ընտրեք թույլտվություն',
  'Choose a priority.': 'Ընտրեք առաջնահերթություն։',
  'Choose a purpose': 'Ընտրեք նպատակակետ',
  'Choose a rule': 'Ընտրեք կանոն',
  'Choose a start date.': 'Ընտրեք մեկնարկի ամսաթիվ։',
  'Choose a task or goal': 'Ընտրեք առաջադրանք կամ նպատակ',
  'Choose a workspace': 'Ընտրեք աշխատատիրույթ',
  'Choose an owner or leave it unassigned.': 'Ընտրեք սեփականատեր կամ թողեք չնշանակված։',
  'Choose at least one required section.': 'Ընտրեք առնվազն մեկ պարտադիր բաժին։',
  'Choose either a due date or “No deadline”.': 'Ընտրեք կա՛մ ժամկետ, կա՛մ «Առանց ժամկետի»։',
  'Choose from the queue': 'Ընտրեք հերթից',
  'Choose how you hear about each kind of event. Governance-critical notifications (votes, critical topics, finalized decisions) cannot be switched off completely.':
    'Ընտրեք, թե ինչպես տեղեկանալ յուրաքանչյուր տեսակի իրադարձության մասին։ Կառավարման համար կրիտիկական ծանուցումները (քվեներ, կրիտիկական թեմաներ, վերջնականացված որոշումներ) հնարավոր չէ ամբողջությամբ անջատել։',
  'Choose one accountable owner.': 'Ընտրեք մեկ պատասխանատու սեփականատեր։',
  'Choose one option from a ballot of at least two proposals.':
    'Ընտրեք մեկ տարբերակ առնվազն երկու առաջարկ պարունակող քվեաթերթիկից։',
  'Choose the account': 'Ընտրեք հաշիվը',
  'Choose the company account': 'Ընտրեք ընկերության հաշիվը',
  'Choose the company account.': 'Ընտրեք ընկերության հաշիվը։',
  'Choose the currency': 'Ընտրեք արժույթը',
  'Choose the date the money moved (not in the future).':
    'Ընտրեք գումարի փոխանցման ամսաթիվը (ոչ ապագայում)։',
  'Choose the due date.': 'Ընտրեք ժամկետը։',
  'Choose the first month of the fiscal year.': 'Ընտրեք ֆինանսական տարվա առաջին ամիսը։',
  'Choose the founder': 'Ընտրեք հիմնադրին',
  'Choose the founder who paid.': 'Ընտրեք վճարած հիմնադրին։',
  'Choose the method': 'Ընտրեք եղանակը',
  'Choose the month': 'Ընտրեք ամիսը',
  'Choose the owner': 'Ընտրեք սեփականատիրոջը',
  'Choose the owner.': 'Ընտրեք սեփականատիրոջը։',
  'Cite the decision if the founders agreed the treatment.':
    'Հղում կատարեք որոշմանը, եթե հիմնադիրները համաձայնել են այս մոտեցմանը։',
  'Cite the decision if the founders approved this adjustment.':
    'Հղում կատարեք որոշմանը, եթե հիմնադիրները հաստատել են այս ճշգրտումը։',
  'Cite the decision, or give a written approval reference below.':
    'Հղում կատարեք որոշմանը կամ ստորև նշեք գրավոր հաստատման հղումը։',
  'Cite the finalized decision, or give a written approval reference below.':
    'Հղում կատարեք վերջնականացված որոշմանը կամ ստորև նշեք գրավոր հաստատման հղումը։',
  'Classify…': 'Դասակարգել…',
  'Clear the AI draft': 'Մաքրել AI սևագիրը',
  'Clear the suggestions': 'Մաքրել առաջարկները',
  Close: 'Փակել',
  'Close call…': 'Փակել կանչը…',
  'Close this account': 'Փակել այս հաշիվը',
  Closed: 'Փակ',
  'Closed blockers': 'Փակված արգելափակումներ',
  Code: 'Կոդ',
  'Code from the app': 'Հավելվածի կոդը',
  Collaborator: 'Համագործակից',
  'Collaborator (can move the task)': 'Համագործակից (կարող է տեղափոխել առաջադրանքը)',
  'Collaborators and watchers': 'Համագործակիցներ և դիտորդներ',
  'Collect weekly updates': 'Հավաքել շաբաթական թարմացումները',
  'Combination of the above': 'Վերոնշյալի համակցություն',
  comment: 'մեկնաբանություն',
  Comment: 'Մեկնաբանություն',
  'Comment (optional)': 'Մեկնաբանություն (ըստ ցանկության)',
  'Comment deleted.': 'Մեկնաբանությունը ջնջված է։',
  'Comment on your vote': 'Մեկնաբանեք ձեր քվեն',
  'Commenting is closed for this topic or not available to you.':
    'Այս թեմայի մեկնաբանումը փակ է կամ հասանելի չէ ձեզ։',
  Comments: 'Մեկնաբանություններ',
  'Comments could not be loaded': 'Չհաջողվեց բեռնել մեկնաբանությունները',
  'Comments, oldest first': 'Մեկնաբանություններ՝ սկզբից ամենահները',
  Commitment: 'Պարտավորվածություն',
  'Committed last period': 'Նախորդ ժամանակահատվածում ստանձնած',
  'Committed vs reported': 'Ստանձնած և հաղորդված',
  Company: 'Ընկերություն',
  'Company account': 'Ընկերության հաշիվ',
  'Company accounts': 'Ընկերության հաշիվներ',
  'Company bank and cash accounts': 'Ընկերության բանկային և դրամարկղային հաշիվներ',
  'Company figures are not part of your access.':
    'Ընկերության ցուցանիշները ձեր հասանելիության մեջ չեն։',
  'Company finance': 'Ընկերության ֆինանսներ',
  'Company owes founders': 'Ընկերությունը պարտք է հիմնադիրներին',
  'Company owes them': 'Ընկերությունը պարտք է նրանց',
  'Company valuation': 'Ընկերության գնահատում',
  'Comparable multiples': 'Համադրելի բազմապատկիչներ',
  'Comparable multiples could not be loaded': 'Չհաջողվեց բեռնել համադրելի բազմապատկիչները',
  'Competing options': 'Մրցակցող տարբերակներ',
  'Complete meeting': 'Ավարտել հանդիպումը',
  'Complete meeting…': 'Ավարտել հանդիպումը…',
  'Complete the meeting?': 'Ավարտե՞լ հանդիպումը',
  Completed: 'Ավարտված',
  'Completed in window': 'Ավարտված ժամանակահատվածում',
  'Completion is recorded with the time and the outcome below. It can be reopened later with a reason.':
    'Ավարտը գրանցվում է ժամանակով և ստորև նշված արդյունքով։ Հետագայում այն կարելի է վերաբացել՝ նշելով պատճառը։',
  'Conclusions, decisions and agreed actions':
    'Եզրակացություններ, որոշումներ և համաձայնեցված գործողություններ',
  Confidence: 'Վստահություն',
  'Confidence describes how complete, recent and applicable the data is — not a model’s certainty.':
    'Վստահությունը նկարագրում է, թե որքան ամբողջական, թարմ և կիրառելի են տվյալները — ոչ թե մոդելի համոզվածությունը։',
  'Confirm it’s you': 'Հաստատեք, որ դուք եք',
  'Confirm new password': 'Հաստատեք նոր գաղտնաբառը',
  'Confirm password': 'Հաստատեք գաղտնաբառը',
  'Confirm with': 'Հաստատել միջոցով՝',
  Conflict: 'Հակասություն',
  Connected: 'Միացված է',
  Cons: 'Դեմ փաստարկներ',
  Consensus: 'Համաձայնություն',
  'Consensus (vote)': 'Կոնսենսուս (քվե)',
  'Consolidated totals are converted into this currency with the recorded rate for each date. Empty = no consolidation.':
    'Համախմբված հանրագումարները փոխարկվում են այս արժույթի՝ յուրաքանչյուր ամսաթվի համար գրանցված փոխարժեքով։ Դատարկ = առանց համախմբման։',
  'Contact phone': 'Կոնտակտային հեռախոս',
  'Contact phone saved.': 'Կոնտակտային հեռախոսը պահված է։',
  Context: 'Համատեքստ',
  'Continues in': 'Շարունակվում է՝',
  Contracts: 'Պայմանագրեր',
  'Contracts and pipeline': 'Պայմանագրեր և վաճառքի խողովակաշար',
  'Contractual liability': 'Պայմանագրային պարտավորություն',
  'Contributed in total': 'Ընդհանուր ներդրված',
  Contribution: 'Ներդրում',
  'Contribution history': 'Ներդրումների պատմություն',
  'Copy all codes': 'Պատճենել բոլոր կոդերը',
  'Copy key': 'Պատճենել բանալին',
  'Copy the multiples from a published, dated source (report, database extract or list of transactions). They cannot be used until the founders approve them.':
    'Պատճենեք բազմապատկիչները հրապարակված, ամսաթվված աղբյուրից (հաշվետվություն, տվյալների բազայի քաղվածք կամ գործարքների ցանկ)։ Դրանք չեն կարող օգտագործվել, քանի դեռ հիմնադիրները չեն հաստատել։',
  'Correct a figure from the books (optional)':
    'Ուղղել հաշվապահական գրանցումների ցուցանիշը (ըստ ցանկության)',
  'Correct…': 'Ուղղել…',
  Corrected: 'Ուղղված',
  'Corrected value': 'Ուղղված արժեք',
  Correction: 'Ուղղում',
  'Corrects an approved version': 'Ուղղում է հաստատված տարբերակը',
  'Costs cash': 'Պահանջում է դրամական միջոցներ',
  'Costs, burn and cash': 'Ծախսեր, այրում և դրամական միջոցներ',
  Count: 'Քանակ',
  'Counts as the founder’s payment towards an open funding call.':
    'Հաշվվում է որպես հիմնադրի վճարում բաց ֆինանսավորման կանչի դիմաց։',
  'Counts towards a funding-call share': 'Հաշվվում է ֆինանսավորման կանչի բաժնի դիմաց',
  'Cover provided': 'Ծածկումը տրամադրված է',
  'Cover received': 'Ծածկումը ստացված է',
  'Covered another founder': 'Ծածկել է այլ հիմնադրի մասը',
  'Covered by another founder': 'Ծածկված է մեկ այլ հիմնադրի կողմից',
  'Covered by others': 'Ծածկված է ուրիշների կողմից',
  'Create a founder profile': 'Ստեղծել հիմնադրի պրոֆիլ',
  'Create actions': 'Ստեղծել գործողություններ',
  'Create draft version': 'Ստեղծել սևագիր տարբերակ',
  'Create one in a new tab': 'Ստեղծել նոր ներդիրում',
  'Create your account': 'Ստեղծեք ձեր հաշիվը',
  Created: 'Ստեղծված',
  'Creates a task linked to this meeting and agenda item. The owner is notified.':
    'Ստեղծում է այս հանդիպմանը և օրակարգի կետին կապված առաջադրանք։ Սեփականատերը ծանուցվում է։',
  Credit: 'Կրեդիտ',
  'Credit owed to the payer': 'Վճարողին հասանելիք կրեդիտ',
  'Credit to payer': 'Կրեդիտ վճարողին',
  Critical: 'Կրիտիկական',
  'Critical topic': 'Կրիտիկական թեմա',
  Crm: 'CRM',
  'Csrf token invalid': 'CSRF տոկենն անվավեր է',
  Currency: 'Արժույթ',
  'Currency of the minimum': 'Նվազագույնի արժույթը',
  Current: 'Ընթացիկ',
  'Current password': 'Ընթացիկ գաղտնաբառ',
  'Current value': 'Ընթացիկ արժեք',
  Custom: 'Հատուկ',
  'Custom amounts': 'Հատուկ գումարներ',
  'Custom commitments': 'Հատուկ պարտավորություններ',
  'Custom period': 'Անհատական ժամանակահատված',
  'Customer concentration': 'Հաճախորդների կենտրոնացում',
  'Customer success': 'Հաճախորդների հաջողություն',
  Customers: 'Հաճախորդներ',
  Daily: 'Օրական',
  'Data as of': 'Տվյալները՝ առ',
  'Data sources': 'Տվյալների աղբյուրներ',
  'Data-quality warnings': 'Տվյալների որակի նախազգուշացումներ',
  Date: 'Ամսաթիվ',
  'Date the money arrived': 'Գումարի մուտքի ամսաթիվը',
  'Date the money moved': 'Գումարի տեղափոխման ամսաթիվը',
  'Date the money was sent': 'Գումարի ուղարկման ամսաթիվը',
  'Days 0 30': '0–30 օր',
  'Days 31 60': '31–60 օր',
  'Days 61 90': '61–90 օր',
  'Days over 90': '90 օրից ավելի',
  Deactivated: 'Ապաակտիվացված',
  Deadline: 'Վերջնաժամկետ',
  'Deadline passed': 'Վերջնաժամկետն անցել է',
  Debit: 'Դեբետ',
  debt: 'պարտք',
  Debt: 'Պարտք',
  'Debt actions': 'Պարտքի գործողություններ',
  'Debt amounts': 'Պարտքի գումարներ',
  'Debt and balance sheet': 'Պարտք և հաշվեկշիռ',
  'Debt incurred': 'Պարտք է առաջացել',
  'Debt settled': 'Պարտքը մարված է',
  'Debts and credits': 'Պարտքեր և կրեդիտներ',
  'Debts and credits from this payment': 'Այս վճարումից առաջացած պարտքեր և կրեդիտներ',
  'Debts due on': 'Պարտքերի մարման ժամկետը՝',
  'Debts from this call': 'Այս կանչից առաջացած պարտքեր',
  Decided: 'Որոշված',
  'Decimal between 0 and 1, e.g. 0.5.': 'Տասնորդական թիվ 0-ից 1, օրինակ՝ 0.5։',
  'Decimal between 0 and 1, e.g. 0.666667.': 'Տասնորդական թիվ 0-ից 1, օրինակ՝ 0.666667։',
  Decision: 'Որոշում',
  'Decision deadline': 'Որոշման վերջնաժամկետ',
  'Decision draft': 'Որոշման սևագիր',
  'Decision draft pending': 'Որոշման սևագիրը սպասում է',
  'Decision finalized': 'Որոշումը վերջնականացված է',
  'Decision ID': 'Որոշման ID',
  'Decision owned': 'Պատասխանատու որոշում',
  'Decision owner': 'Որոշման սեփականատեր',
  'decision register': 'որոշումների ռեեստր',
  'Decision statement': 'Որոշման ձևակերպում',
  'Decision type': 'Որոշման տեսակ',
  Decisions: 'Որոշումներ',
  'Decisions awaiting me': 'Ինձ սպասող որոշումներ',
  Declared: 'Հայտարարված',
  'Declared distributions not yet paid': 'Հայտարարված, բայց դեռ չվճարված բաշխումներ',
  Default: 'Լռելյայն',
  'Default (standard policy)': 'Լռելյայն (ստանդարտ քաղաքականություն)',
  'Default for this topic’s category': 'Լռելյայն այս թեմայի կատեգորիայի համար',
  Deferred: 'Հետաձգված',
  Delete: 'Ջնջել',
  'Delete comment': 'Ջնջել մեկնաբանությունը',
  'Delete this comment?': 'Ջնջե՞լ այս մեկնաբանությունը',
  Departed: 'Հեռացած',
  'Departed on': 'Հեռացել է՝',
  Dependencies: 'Կախվածություններ',
  'Dependent tasks': 'Կախյալ առաջադրանքներ',
  Derived: 'Ածանցյալ',
  'Describe the commitment (3–2000 characters).': 'Նկարագրեք պարտավորությունը (3–2000 նիշ)։',
  'Describe the option (1–10000 characters).': 'Նկարագրեք տարբերակը (1–10000 նիշ)։',
  Description: 'Նկարագրություն',
  'Desired outcome': 'Ցանկալի արդյունք',
  Detach: 'Անջատել',
  'Detach this attachment?': 'Անջատե՞լ այս կցորդը',
  Details: 'Մանրամասներ',
  'Details (optional)': 'Մանրամասներ (ըստ ցանկության)',
  Device: 'Սարք',
  Digest: 'Ամփոփագիր',
  'Direct expense payment': 'Ծախսի ուղղակի վճարում',
  Disabled: 'Անջատված',
  Discard: 'Հրաժարվել',
  'Discard changes': 'Հրաժարվել փոփոխություններից',
  'Discard draft': 'Հրաժարվել սևագրից',
  Discarded: 'Մերժված է և հեռացված',
  Discount: 'Զեղչ',
  'Discount on equity value (percent)': 'Բաժնեմասի արժեքի զեղչ (տոկոս)',
  Discussed: 'Քննարկված',
  Discussing: 'Քննարկվում է',
  Discussion: 'Քննարկում',
  'Discussion summary': 'Քննարկման ամփոփում',
  Dismiss: 'Մերժել',
  'Dismiss this AI output?': 'Մերժե՞լ AI-ի այս արդյունքը',
  Dispute: 'Վեճ',
  Disputed: 'Վիճարկված',
  Distributable: 'Բաշխելի',
  'Distributable cash': 'Բաշխելի դրամական միջոցներ',
  Distribution: 'Բաշխում',
  'Distribution actions': 'Բաշխման գործողություններ',
  'Distribution allocated': 'Բաշխումը հատկացված է',
  'Distribution history': 'Բաշխումների պատմություն',
  'Distribution paid': 'Բաշխումը վճարված է',
  'Distribution proposals, newest first': 'Բաշխման առաջարկներ՝ սկզբից ամենանորերը',
  'Distribution scenario calculator': 'Բաշխման սցենարների հաշվիչ',
  'Distribution totals': 'Բաշխումների հանրագումարներ',
  Distributions: 'Բաշխումներ',
  'Distributions are declared only by a finalized founder decision.':
    'Բաշխումները հայտարարվում են միայն հիմնադիրների վերջնականացված որոշմամբ։',
  'Distributions could not be loaded': 'Չհաջողվեց բեռնել բաշխումները',
  'Distributions to the founder': 'Բաշխումներ հիմնադրին',
  'Documented defaults in effect': 'Գործող փաստաթղթավորված լռելյայն կարգավորումներ',
  Done: 'Կատարված',
  'Done when:': 'Կատարված է, երբ՝',
  Draft: 'Սևագիր',
  'Draft created. It takes effect only after approval.':
    'Սևագիրը ստեղծված է։ Այն ուժի մեջ է մտնում միայն հաստատումից հետո։',
  'Draft entries': 'Սևագիր գրառումներ',
  'Draft transactions': 'Սևագիր գործարքներ',
  'Draft transactions excluded': 'Սևագիր գործարքները բացառված են',
  Due: 'Ժամկետ',
  'Due date': 'Ժամկետի ամսաթիվ',
  'Due day of month': 'Ամսվա ժամկետային օր',
  'Due day offset (days from the last day of the period)':
    'Ժամկետային օրվա շեղում (օրեր՝ ժամանակահատվածի վերջին օրվանից)',
  'Due on': 'Ժամկետը՝',
  'Due time': 'Ժամկետային ժամ',
  'Due weekday': 'Ժամկետային շաբաթվա օր',
  'Due within 7 days': 'Ժամկետը՝ 7 օրվա ընթացքում',
  Duplicate: 'Կրկնօրինակել',
  'E-mail': 'Էլ. փոստ',
  'E.g. 20 for 20 %.': 'Օրինակ՝ 20՝ 20 %-ի համար։',
  'E.g. 3 or 4.5.': 'Օրինակ՝ 3 կամ 4.5։',
  'E.g. B2B SaaS, subscription, < 10 M ARR.': 'Օրինակ՝ B2B SaaS, բաժանորդագրություն, < 10 M ARR։',
  'E.g. Billing export 1 Oct 2026.': 'Օր.՝ Հաշվարկների արտահանում, 1 հոկտ. 2026։',
  'E.g. corrected churn from the billing export. Stored with the new snapshot and in the audit log.':
    'Օր.՝ ուղղված արտահոսքը հաշվարկների արտահանումից։ Պահվում է նոր պատկերի հետ և աուդիտի մատյանում։',
  'e.g. customers, AMD, %': 'օր.՝ հաճախորդներ, AMD, %',
  'E.g. EU B2B SaaS 2026.': 'Օր.՝ ԵՄ B2B SaaS 2026։',
  'E.g. EU, US, CIS.': 'Օր.՝ ԵՄ, ԱՄՆ, ԱՊՀ։',
  'E.g. for illiquidity of a private company. Empty = none.':
    'Օր.՝ մասնավոր ընկերության ոչ իրացվելիության համար։ Դատարկ = չկա։',
  'E.g. Q3 2026 distribution.': 'Օր.՝ 2026 թ. 3-րդ եռամսյակի բաշխում։',
  'E.g. Q4 VAT payment. Recorded in the audit log.':
    'Օր.՝ 4-րդ եռամսյակի ԱԱՀ վճարում։ Գրանցվում է աուդիտի մատյանում։',
  'E.g. signed board resolution number.': 'Օր.՝ ստորագրված խորհրդի որոշման համարը։',
  'E.g. signed minutes of 12 Oct 2026, if no decision is recorded in MFOS.':
    'Օր.՝ 12 հոկտ. 2026-ի ստորագրված արձանագրությունը, եթե MFOS-ում որոշում գրանցված չէ։',
  'E.g. signed minutes, if no decision is recorded in MFOS.':
    'Օր.՝ ստորագրված արձանագրությունը, եթե MFOS-ում որոշում գրանցված չէ։',
  'E.g. USD.': 'Օր.՝ USD։',
  'E.g. USD. Other currencies are converted with the latest recorded rate.':
    'Օր.՝ USD։ Մյուս արժույթները փոխարկվում են վերջին գրանցված փոխարժեքով։',
  'e.g. VAT 20 % included': 'օր.՝ ներառյալ ԱԱՀ 20 %',
  'Each code works once if you lose access to your authenticator app. They are shown only this time — store them in a password manager or print them.':
    'Յուրաքանչյուր կոդ գործում է մեկ անգամ, եթե կորցնեք մուտքը նույնականացման հավելվածին։ Դրանք ցուցադրվում են միայն այս անգամ — պահեք գաղտնաբառերի կառավարիչում կամ տպեք։',
  'Each founder’s share': 'Յուրաքանչյուր հիմնադրի մասնաբաժինը',
  'Each founder’s share of the call': 'Յուրաքանչյուր հիմնադրի մասնաբաժինը կանչում',
  'Each founder’s share of the distribution': 'Յուրաքանչյուր հիմնադրի մասնաբաժինը բաշխումում',
  'Each founder’s share of the pool': 'Յուրաքանչյուր հիմնադրի մասնաբաժինը ֆոնդում',
  'Each method multiplies one figure by an approved comparable multiple set (low, base and high). A method that cannot be applied — e.g. no ARR, or a negative operating result — is explained in the result.':
    'Յուրաքանչյուր մեթոդ մեկ թիվը բազմապատկում է համադրելի բազմապատկիչների հաստատված հավաքածուով (ցածր, բազային և բարձր)։ Այն մեթոդը, որը հնարավոր չէ կիրառել — օր.՝ ARR չկա կամ գործառնական արդյունքը բացասական է —, բացատրվում է արդյունքում։',
  'Each unpaid share becomes the founder’s debt to the company:':
    'Յուրաքանչյուր չվճարված մասնաբաժին դառնում է հիմնադրի պարտքն ընկերությանը՝',
  'Ebitda multiple': 'EBITDA բազմապատիկ',
  'EBITDA multiple (operating result)': 'EBITDA բազմապատկիչ (գործառնական արդյունք)',
  Edit: 'Խմբագրել',
  'Edit comment': 'Խմբագրել մեկնաբանությունը',
  'Edit details': 'Խմբագրել մանրամասները',
  'Edit details…': 'Խմբագրել մանրամասները…',
  'Edit draft': 'Խմբագրել սևագիրը',
  'Edit draft funding call': 'Խմբագրել ֆինանսավորման կանչի սևագիրը',
  'Edit goal': 'Խմբագրել նպատակը',
  'Edit goal…': 'Խմբագրել նպատակը…',
  'Edit history': 'Խմբագրումների պատմություն',
  'Edit meeting details': 'Խմբագրել հանդիպման մանրամասները',
  'Edit option': 'Խմբագրել տարբերակը',
  'Edit or close': 'Խմբագրել կամ փակել',
  'Edit task details': 'Խմբագրել առաջադրանքի մանրամասները',
  'Edit topic': 'Խմբագրել թեման',
  Effect: 'Ազդեցություն',
  'Effective date': 'Ուժի մեջ մտնելու ամսաթիվ',
  'Effective from': 'Ուժի մեջ է՝ սկսած',
  'Either a decision ID or a reference is required.': 'Պահանջվում է որոշման ID կամ հղում։',
  'Eligible voters': 'Քվեարկելու իրավունք ունեցողներ',
  'Eligible voters and their votes': 'Քվեարկելու իրավունք ունեցողները և նրանց քվեները',
  Email: 'Էլ. փոստ',
  Emergency: 'Արտակարգ',
  'Empty = last 28 days.': 'Դատարկ = վերջին 28 օրը։',
  En: 'Անգլերեն',
  Ends: 'Ավարտվում է',
  'Ends on': 'Ավարտվում է՝',
  Engineering: 'Ինժեներիա',
  English: 'Անգլերեն',
  'Enter a 3-letter currency code, e.g. USD.': 'Մուտքագրեք 3 տառանոց արժույթի կոդ, օրինակ՝ USD։',
  'Enter a full https:// link, or leave it empty.':
    'Մուտքագրեք ամբողջական https:// հղում կամ թողեք դատարկ։',
  'Enter a name of 2–100 characters.': 'Մուտքագրեք 2–100 նիշից բաղկացած անուն։',
  'Enter a number with at most 4 decimals.': 'Մուտքագրեք թիվ՝ առավելագույնը 4 տասնորդական նիշով։',
  'Enter a title (1–200 characters).': 'Մուտքագրեք վերնագիր (1–200 նիշ)։',
  'Enter a title of 3–200 characters.': 'Մուտքագրեք 3–200 նիշից բաղկացած վերնագիր։',
  'Enter a whole number from −6 to 14.': 'Մուտքագրեք ամբողջ թիվ −6-ից 14։',
  'Enter a whole number from 0 to 168.': 'Մուտքագրեք ամբողջ թիվ 0-ից 168։',
  'Enter a whole number from 0 to 336.': 'Մուտքագրեք ամբողջ թիվ 0-ից 336։',
  'Enter a whole number of months from 1 to 12.': 'Մուտքագրեք ամիսների ամբողջ թիվ 1-ից 12։',
  'Enter an amount greater than zero with at most 4 decimals. Write 12500 or 12.5 rather than 12,500, which could mean either.':
    'Մուտքագրեք զրոյից մեծ գումար՝ առավելագույնը 4 տասնորդական նիշով։ Գրեք 12500 կամ 12.5, այլ ոչ թե 12,500, որը կարող է նշանակել երկուսն էլ։',
  'Enter an http(s) link.': 'Մուտքագրեք http(s) հղում։',
  'Enter this key in your authenticator app (choose “enter a setup key”, time-based):':
    'Մուտքագրեք այս բանալին նույնականացման հավելվածում (ընտրեք «մուտքագրել կարգավորման բանալի», ժամանակի վրա հիմնված)՝',
  'Enter whole minutes from 5 to 240, or leave it empty.':
    'Մուտքագրեք րոպեների ամբողջ թիվ 5-ից 240 կամ թողեք դատարկ։',
  'Enter your account email and we will send you a link to set a new password.':
    'Մուտքագրեք ձեր հաշվի էլ. փոստը, և մենք կուղարկենք նոր գաղտնաբառ սահմանելու հղում։',
  'Entered by a person': 'Մուտքագրված է անձի կողմից',
  'Entered in this app': 'Մուտքագրված է այս հավելվածում',
  'Enterprise value': 'Ձեռնարկության արժեք',
  'Enterprise value:': 'Ձեռնարկության արժեք՝',
  Entries: 'Գրառումներ',
  'Entries and actions': 'Գրառումներ և գործողություններ',
  'Entries could not be loaded': 'Չհաջողվեց բեռնել գրառումները',
  Entry: 'Գրառում',
  'Entry actions': 'Գրառման գործողություններ',
  Equity: 'Բաժնեմաս',
  'Equity bridge': 'Արժեքից բաժնեմասի անցում',
  'Equity history': 'Բաժնեմասի պատմություն',
  'Equity percentage': 'Բաժնեմասի տոկոս',
  'Equity value': 'Բաժնեմասի արժեք',
  'Equity value before discount': 'Բաժնեմասի արժեքը մինչև զեղչը',
  'Equity value range': 'Բաժնեմասի արժեքի միջակայք',
  'Escalate to meeting': 'Փոխանցել հանդիպման',
  Escalation: 'Էսկալացիա',
  'Escalations also notify the workspace owner':
    'Էսկալացիաների մասին ծանուցվում է նաև աշխատատիրույթի սեփականատերը',
  Estimated: 'Գնահատված',
  'Estimated input': 'Գնահատված մուտքային տվյալ',
  Event: 'Իրադարձություն',
  'Every active member already has a founder profile.':
    'Յուրաքանչյուր ակտիվ անդամ արդեն ունի հիմնադրի պրոֆիլ։',
  'Every agenda item leaves the meeting with exactly one outcome. It cannot be changed afterwards.':
    'Օրակարգի յուրաքանչյուր կետ հանդիպումից դուրս է գալիս ճիշտ մեկ արդյունքով։ Այն հետագայում հնարավոր չէ փոխել։',
  'Every agenda item must have an outcome (decision, task, deferred, no action or follow-up topic). Deferred items return to the queue.':
    'Օրակարգի յուրաքանչյուր կետ պետք է ունենա արդյունք (որոշում, առաջադրանք, հետաձգված, առանց գործողության կամ հետագա թեմա)։ Հետաձգված կետերը վերադառնում են հերթ։',
  'Every figure is converted into this currency. Changing it reloads the figures and clears the form.':
    'Բոլոր թվերը փոխարկվում են այս արժույթով։ Այն փոխելիս թվերը վերաբեռնվում են, և ձևը մաքրվում է։',
  'Every figure with its quality and source, as used in this snapshot.':
    'Յուրաքանչյուր թիվ՝ իր որակով և աղբյուրով, ինչպես օգտագործվել է այս պատկերում։',
  'Every share is paid.': 'Բոլոր մասնաբաժինները վճարված են։',
  'Every voter sees the rule (quorum, threshold, deadline) before voting.':
    'Յուրաքանչյուր քվեարկող տեսնում է կանոնը (քվորում, շեմ, վերջնաժամկետ) մինչև քվեարկելը։',
  'Everyone invited is notified. A restricted topic can only be on the agenda when every participant may see it.':
    'Բոլոր հրավիրվածները ծանուցվում են։ Սահմանափակ թեման կարող է լինել օրակարգում միայն այն դեպքում, երբ յուրաքանչյուր մասնակից կարող է այն տեսնել։',
  Evidence: 'Ապացույց',
  'Evidence and links': 'Ապացույցներ և հղումներ',
  'Evidence description': 'Ապացույցի նկարագրություն',
  'Evidence link': 'Ապացույցի հղում',
  'Evidence link (optional)': 'Ապացույցի հղում (ըստ ցանկության)',
  'Evidence of work: completed tasks, submitted updates, responsibility periods, decisions and resolved blockers. There is no score — read the items themselves.':
    'Աշխատանքի ապացույց՝ կատարված առաջադրանքներ, ներկայացված թարմացումներ, պատասխանատվության ժամանակահատվածներ, որոշումներ և լուծված արգելափակումներ։ Գնահատական չկա — կարդացեք հենց տարրերը։',
  'Evidence title': 'Ապացույցի վերնագիր',
  Exact: 'Ճշգրիտ',
  'Exact figures before rounding': 'Ճշգրիտ թվերը մինչև կլորացումը',
  'Exact share': 'Ճշգրիտ մասնաբաժին',
  'Exchange rate recorded.': 'Փոխարժեքը գրանցվեց։',
  'Exchange rates': 'Փոխարժեքներ',
  Exclude: 'Բացառել',
  'Exclude this movement?': 'Բացառե՞լ այս շարժը',
  Excluded: 'Բացառված',
  Excuse: 'Ազատել',
  'Excuse from period': 'Ազատել ժամանակաշրջանից',
  'Excuse period': 'Ազատման ժամանակաշրջան',
  'Excuse this period': 'Ազատել այս ժամանակաշրջանից',
  'Excuse this period?': 'Ազատե՞լ այս ժամանակաշրջանից',
  Excused: 'Ազատված',
  Execution: 'Կատարում',
  Executive: 'Ղեկավար',
  'Expected reporters, alphabetical, with their update state':
    'Սպասվող հաշվետուները՝ այբբենական կարգով, իրենց թարմացման վիճակով',
  Expense: 'Ծախս',
  'Expense paid personally': 'Անձնապես վճարված ծախս',
  Expenses: 'Ծախսեր',
  'Expenses paid personally — awaiting classification':
    'Անձնապես վճարված ծախսեր — սպասում են դասակարգման',
  Expired: 'Ժամկետանց',
  Expires: 'Լրանում է',
  'Explain this month': 'Բացատրել այս ամիսը',
  Explanation: 'Բացատրություն',
  'Export CSV': 'Արտահանել CSV',
  'Extend the voting deadline': 'Երկարաձգել քվեարկության վերջնաժամկետը',
  'Extra cash to set aside': 'Լրացուցիչ դրամական միջոցներ՝ առանձնացնելու համար',
  Eyes: 'Աչքեր',
  'Facts (computed by the system, not by AI)': 'Փաստեր (հաշվարկված համակարգի, ոչ թե AI-ի կողմից)',
  Failed: 'Ձախողված',
  'Figures as they were when this explanation was generated.':
    'Թվերը, ինչպես դրանք էին այս բացատրությունը ստեղծելիս։',
  'Figures changed — recalculate': 'Թվերը փոխվել են — վերահաշվարկել',
  'Figures entered': 'Մուտքագրված թվեր',
  'Figures read from the system': 'Համակարգից կարդացված թվեր',
  'Figures the books do not hold': 'Թվեր, որոնք հաշվապահական գրանցամատյաններում չկան',
  File: 'Ֆայլ',
  'File upload is not available yet — attach a link to the document (e.g. a shared drive) instead.':
    'Ֆայլի վերբեռնումը դեռ հասանելի չէ — փոխարենը կցեք փաստաթղթի հղումը (օր.՝ ընդհանուր սկավառակ)։',
  'Fill from the queue…': 'Լրացնել հերթից…',
  'Fill in at least two of the components below and choose how they combine.':
    'Լրացրեք ստորև բաղադրիչներից առնվազն երկուսը և ընտրեք, թե ինչպես են դրանք համակցվում։',
  'Fill the agenda from the queue': 'Լրացնել օրակարգը հերթից',
  'Filter bank movements': 'Զտել բանկային շարժերը',
  'Filter contributions': 'Զտել ներդրումները',
  'Filter income and expenses': 'Զտել եկամուտներն ու ծախսերը',
  'Final minutes become part of the permanent record and can no longer be edited. Participants are notified.':
    'Վերջնական արձանագրությունը դառնում է մշտական գրառման մաս և այլևս չի կարող խմբագրվել։ Մասնակիցները ծանուցվում են։',
  'Finalize automatically when the round closes': 'Ավտոմատ վերջնականացնել փուլի փակվելիս',
  'Finalize decision': 'Վերջնականացնել որոշումը',
  'Finalize minutes': 'Վերջնականացնել արձանագրությունը',
  'Finalize minutes…': 'Վերջնականացնել արձանագրությունը…',
  'Finalize result': 'Վերջնականացնել արդյունքը',
  'Finalize the minutes?': 'Վերջնականացնե՞լ արձանագրությունը',
  Finalized: 'Վերջնականացված',
  Finance: 'Ֆինանսներ',
  'Finance categories': 'Ֆինանսական կատեգորիաներ',
  'Finance data sources': 'Ֆինանսական տվյալների աղբյուրներ',
  'Finance explanation': 'Ֆինանսական բացատրություն',
  'Finance settings saved.': 'Ֆինանսական կարգավորումները պահվեցին։',
  'First period starts on': 'Առաջին ժամանակաշրջանը սկսվում է՝',
  'First submitted': 'Առաջին անգամ ներկայացվել է',
  'first.': 'նախ։',
  'Fiscal year starts in': 'Ֆինանսական տարին սկսվում է՝',
  'Fixed amount': 'Ֆիքսված գումար',
  'Fixed minimum': 'Ֆիքսված նվազագույն',
  'Fixed minimum amount': 'Ֆիքսված նվազագույն գումար',
  'Follow up topic': 'Հետագա թեմա',
  'Follow-up actions suggested from this decision. Tasks are only created when a member loads them into the form, checks the owners and dates, and confirms.':
    'Այս որոշումից առաջարկված հետագա գործողություններ։ Առաջադրանքները ստեղծվում են միայն այն ժամանակ, երբ անդամը բեռնում է դրանք ձևի մեջ, ստուգում է պատասխանատուներին ու ամսաթվերը և հաստատում։',
  'Follow-up topic': 'Հետագա թեմա',
  For: 'Կողմ',
  'For example 1250.50 or 12 500,50 — up to 4 decimals.':
    'Օրինակ՝ 1250.50 կամ 12 500,50 — մինչև 4 տասնորդական նիշ։',
  'For example: “decisions about pricing last month” or “tasks owned by Anna this week”.':
    'Օրինակ՝ «գնագոյացման վերաբերյալ որոշումներ անցյալ ամսին» կամ «Աննայի առաջադրանքները այս շաբաթ»։',
  'For sensitive cases. The running tally is hidden too.':
    'Զգայուն դեպքերի համար։ Ընթացիկ հաշվարկը նույնպես թաքցված է։',
  Forbidden: 'Արգելված',
  Formula: 'Բանաձև',
  Founder: 'Հիմնադիր',
  'Founder advance': 'Հիմնադրի կանխավճար',
  'Founder balances': 'Հիմնադիրների մնացորդներ',
  'Founder balances and aging': 'Հիմնադիրների մնացորդներ և ժամկետայնություն',
  'Founder balances, alphabetical': 'Հիմնադիրների մնացորդներ՝ այբբենական կարգով',
  'Founder contribution': 'Հիմնադրի ներդրում',
  'Founder could not be loaded': 'Չհաջողվեց բեռնել հիմնադրին',
  'Founder debt': 'Հիմնադրի պարտք',
  'Founder debt and credit': 'Հիմնադրի պարտք և պահանջ',
  'Founder debts not netted': 'Հիմնադիրների պարտքերը չեն հաշվանցվել',
  'Founder decision (optional)': 'Հիմնադիրների որոշում (ըստ ցանկության)',
  'Founder decision approving the call': 'Կանչը հաստատող հիմնադիրների որոշում',
  'Founder decision approving the policy': 'Քաղաքականությունը հաստատող հիմնադիրների որոշում',
  'Founder decision approving the set': 'Հավաքածուն հաստատող հիմնադիրների որոշում',
  'Founder decision authorizing it': 'Այն լիազորող հիմնադիրների որոշում',
  'Founder decision declaring the distribution': 'Բաշխումը հայտարարող հիմնադիրների որոշում',
  'Founder funding': 'Հիմնադիրների ֆինանսավորում',
  'Founder funding could not be loaded': 'Չհաջողվեց բեռնել հիմնադիրների ֆինանսավորումը',
  'Founder loan': 'Հիմնադրի վարկ',
  'Founder obligations': 'Հիմնադիրների պարտավորություններ',
  'Founder paid expense': 'Հիմնադրի վճարած ծախս',
  'Founder paid pending': 'Հիմնադրի վճարումը սպասում է',
  'Founder profile missing': 'Հիմնադրի պրոֆիլը բացակայում է',
  'Founder profiles': 'Հիմնադիրների պրոֆիլներ',
  'Founder records': 'Հիմնադիրների գրառումներ',
  'Founder shares': 'Հիմնադիրների մասնաբաժիններ',
  'Founder since': 'Հիմնադիր է՝ սկսած',
  'Founder status updated.': 'Հիմնադրի կարգավիճակը թարմացվեց։',
  'Founder status:': 'Հիմնադրի կարգավիճակ՝',
  'Founder who paid': 'Վճարած հիմնադիրը',
  'Founder-paid expenses awaiting classification':
    'Հիմնադրի վճարած ծախսեր, որոնք սպասում են դասակարգման',
  Founders: 'Հիմնադիրներ',
  'Founders will be expected to report on this schedule and will receive reminders. The change is audited.':
    'Հիմնադիրներից կսպասվի հաշվետվություն ներկայացնել այս ժամանակացույցով, և նրանք կստանան հիշեցումներ։ Փոփոխությունը աուդիտի է ենթարկվում։',
  'Fraction of cast': 'Տրված քվեների մասնաբաժին',
  'Fraction of eligible': 'Իրավասուների մասնաբաժին',
  From: 'Սկսած',
  'From account': 'Հաշվից',
  'From enterprise value to equity value': 'Ձեռնարկության արժեքից բաժնեմասի արժեք',
  'Full update': 'Ամբողջական թարմացում',
  Funded: 'Ֆինանսավորված',
  'Funding call': 'Ֆինանսավորման կանչ',
  'Funding call actions': 'Ֆինանսավորման կանչի գործողություններ',
  'Funding call allocation': 'Ֆինանսավորման կանչի բաշխում',
  'Funding call cover': 'Ֆինանսավորման կանչի ծածկում',
  'Funding call due': 'Ֆինանսավորման կանչի ժամկետ',
  'Funding call payment': 'Ֆինանսավորման կանչի վճարում',
  'Funding call share': 'Ֆինանսավորման կանչի բաժին',
  'Funding call shortfall': 'Ֆինանսավորման կանչի պակասորդ',
  'Funding contribution due': 'Ֆինանսավորման ներդրման ժամկետ',
  'Funding share': 'Ֆինանսավորման բաժին',
  'Funding shares to pay': 'Վճարման ենթակա ֆինանսավորման մասնաբաժիններ',
  'Funding-call payment': 'Ֆինանսավորման կանչի վճարում',
  Fundraising: 'Ներդրումների ներգրավում',
  'Generate new codes': 'Ստեղծել նոր կոդեր',
  'Generate new recovery codes': 'Ստեղծել վերականգնման նոր կոդեր',
  'Generate new recovery codes?': 'Ստեղծե՞լ վերականգնման նոր կոդեր',
  Generated: 'Ստեղծված',
  Geography: 'Աշխարհագրություն',
  Get: 'GET',
  'Go to the current period': 'Անցնել ընթացիկ ժամանակաշրջանին',
  'Go to your home page': 'Անցնել ձեր գլխավոր էջ',
  'Go to your workspaces': 'Անցնել ձեր աշխատատիրույթներ',
  Goal: 'Նպատակ',
  'Goal details': 'Նպատակի մանրամասներ',
  'Goal not available': 'Նպատակը հասանելի չէ',
  'Goal progress': 'Նպատակի առաջընթաց',
  'Goal timeline, newest first': 'Նպատակի ժամանակագրություն՝ սկզբում նորերը',
  Goals: 'Նպատակներ',
  'Governance-critical': 'Կառավարման համար կարևոր',
  'Grace ends': 'Արտոնյալ ժամկետն ավարտվում է',
  'Grace period': 'Արտոնյալ ժամկետ',
  'Grace period (hours)': 'Արտոնյալ ժամկետ (ժամ)',
  'Grant a permission': 'Տրամադրել թույլտվություն',
  'Grant permission': 'Տրամադրել թույլտվություն',
  'Grant this permission?': 'Տրամադրե՞լ այս թույլտվությունը',
  Granted: 'Տրամադրված',
  Grants: 'Տրամադրումներ',
  'Grants extend a member’s role with one explicit permission. Granting and revoking need recent identity confirmation and are audited.':
    'Տրամադրումները ընդլայնում են անդամի դերը մեկ հստակ թույլտվությամբ։ Տրամադրելն ու հետ կանչելը պահանջում են ինքնության վերջերս կատարված հաստատում և աուդիտի են ենթարկվում։',
  'Greater of': 'Առավելագույնը',
  'Growth scenario spread (percentage points)': 'Աճի սցենարների տարբերություն (տոկոսային կետեր)',
  'Growth scenarios': 'Աճի սցենարներ',
  'Half even': 'Կլորացում դեպի զույգ',
  'Half up': 'Կլորացում դեպի վեր',
  Heart: 'Սիրտ',
  'Hidden until close': 'Թաքնված մինչև փակումը',
  'Hide individual votes until the round closes': 'Թաքցնել անհատական քվեները մինչև փուլի փակվելը',
  High: 'Բարձր',
  'High multiple': 'Բարձր բազմապատկիչ',
  Highlights: 'Կարևորագույններ',
  'Historical rates with their source. A recorded rate is never changed: a correction is recorded from a distinct source, and reports always name the rate they used.':
    'Պատմական փոխարժեքներ՝ իրենց աղբյուրով։ Գրանցված փոխարժեքը երբեք չի փոփոխվում. ուղղումը գրանցվում է այլ աղբյուրից, և հաշվետվությունները միշտ նշում են օգտագործված փոխարժեքը։',
  History: 'Պատմություն',
  'Hold back e-mail during quiet hours': 'Չուղարկել էլ. նամակներ հանգստի ժամերին',
  Horizon: 'Հորիզոն',
  'How everyone will know the task is done.': 'Ինչպես բոլորը կիմանան, որ առաջադրանքը կատարված է։',
  'How it was settled': 'Ինչպես է այն մարվել',
  'How the components combine': 'Ինչպես են բաղադրիչները համակցվում',
  'How the question was read': 'Ինչպես է հարցը մեկնաբանվել',
  'How the rule was applied': 'Ինչպես է կանոնը կիրառվել',
  'How the shares were calculated': 'Ինչպես են մասնաբաժինները հաշվարկվել',
  'How the total is split': 'Ինչպես է ընդհանուր գումարը բաշխվում',
  Hy: 'Հայերեն',
  Hybrid: 'Հիբրիդ',
  'I am mentioned': 'Ինձ նշել են',
  'I have saved these codes': 'Ես պահել եմ այս կոդերը',
  'I owe': 'Ես պարտք եմ',
  'If an account exists for that address, we sent a link to choose a new password.':
    'Եթե այդ հասցեով հաշիվ գոյություն ունի, մենք ուղարկել ենք նոր գաղտնաբառ ընտրելու հղում։',
  'If an account exists for that address, we sent a sign-in link. It expires soon and works once.':
    'Եթե այդ հասցեով հաշիվ գոյություն ունի, մենք ուղարկել ենք մուտքի հղում։ Այն շուտով կլրանա և գործում է մեկ անգամ։',
  'If evaluated now:': 'Եթե գնահատվի հիմա՝',
  'If the end is earlier than the start, quiet hours run overnight.':
    'Եթե ավարտը սկզբից շուտ է, հանգստի ժամերը շարունակվում են գիշերվա ընթացքում։',
  'Ignored when the topic’s category is mapped to a policy — the mapping always wins.':
    'Անտեսվում է, երբ թեմայի կատեգորիան կապված է քաղաքականության հետ — կապը միշտ գերակայում է։',
  'Immutable record': 'Անփոփոխ գրառում',
  'Impediments that need a response. Each one names who is expected to unblock the work and by when.':
    'Արգելափակումներ, որոնք պատասխան են պահանջում։ Յուրաքանչյուրում նշված է, թե ով և մինչև երբ պետք է ապաարգելափակի աշխատանքը։',
  'Import a bank statement': 'Ներմուծել բանկային քաղվածք',
  'Import a bank statement (CSV)': 'Ներմուծել բանկային քաղվածք (CSV)',
  'In app': 'Հավելվածում',
  'In currency': 'Արժույթով',
  'In effect from': 'Գործում է սկսած',
  'In force today': 'Այսօր գործող',
  'In progress': 'Ընթացքում',
  'In review': 'Վերանայման մեջ',
  'In the app': 'Հավելվածում',
  Inactive: 'Ոչ ակտիվ',
  Included: 'Ներառված',
  Income: 'Եկամուտ',
  'Income and expense entries': 'Եկամուտների և ծախսերի գրառումներ',
  'Income and expenses': 'Եկամուտներ և ծախսեր',
  'Income and expenses by currency': 'Եկամուտներ և ծախսեր ըստ արժույթի',
  'Income is always received by a company account.': 'Եկամուտը միշտ ստացվում է ընկերության հաշվին։',
  'Incurred on': 'Կատարման ամսաթիվ',
  'Indicative value': 'Ցուցանշային արժեք',
  'Indicative value per founder': 'Ցուցանշային արժեք յուրաքանչյուր հիմնադրի համար',
  'Individual votes are hidden until the round closes.':
    'Անհատական քվեները թաքցված են մինչև փուլի փակումը։',
  Inflow: 'Մուտք',
  Info: 'Տեղեկություն',
  Informational: 'Տեղեկատվական',
  'Inputs behind these figures': 'Այս թվերի հիմքում ընկած մուտքային տվյալները',
  'instead.': 'փոխարենը։',
  'Instruction like source': 'Հրահանգանման աղբյուր',
  'Insufficient data': 'Անբավարար տվյալներ',
  Integration: 'Ինտեգրում',
  'Internal error': 'Ներքին սխալ',
  'Interpretation (AI)': 'Մեկնաբանություն (AI)',
  'Invalid response': 'Անվավեր պատասխան',
  'Invalid state transition': 'Կարգավիճակի անվավեր անցում',
  'Invariant violation': 'Ինվարիանտի խախտում',
  'Invitation pending': 'Հրավերը սպասում է',
  Invitations: 'Հրավերներ',
  'Invite at least one participant.': 'Հրավիրեք առնվազն մեկ մասնակցի։',
  'Invite someone': 'Հրավիրել որևէ մեկին',
  'Invited by': 'Հրավիրել է',
  'Invited email': 'Հրավիրված էլ. հասցե',
  'Invoice 2026-114': 'Հաշիվ-ապրանքագիր 2026-114',
  'Invoice number': 'Հաշիվ-ապրանքագրի համար',
  'IP address': 'IP հասցե',
  'Is owed': 'Պարտք ունեն իրեն',
  'It is added to both founders’ statements and can only be undone by a reversal.':
    'Այն ավելացվում է երկու հիմնադիրների քաղվածքներում և կարող է չեղարկվել միայն հակադարձ գրառմամբ։',
  'It stays in the history but can no longer be used as a draft. You can generate a new one.':
    'Այն մնում է պատմության մեջ, բայց այլևս չի կարող օգտագործվել որպես սևագիր։ Կարող եք ստեղծել նորը։',
  'Items needing a decision': 'Որոշում պահանջող կետեր',
  'its topic': 'դրա թեման',
  'Join a workspace': 'Միանալ աշխատատիրույթին',
  'Join the call': 'Միանալ զանգին',
  Joined: 'Միացել է',
  Journal: 'Մատյան',
  'Keep blocker': 'Պահպանել արգելափակումը',
  'Keep call': 'Պահպանել կանչը',
  'Keep distribution': 'Պահպանել բաշխումը',
  'Keep meeting': 'Պահպանել հանդիպումը',
  'Keep round': 'Պահպանել փուլը',
  'Keep task': 'Պահպանել առաջադրանքը',
  'Keep the greatest of the components': 'Պահել բաղադրիչներից ամենամեծը',
  'Keep the sum of the components': 'Պահել բաղադրիչների գումարը',
  'Kept in the audit log.': 'Պահպանվում է աուդիտի մատյանում։',
  'Key argument': 'Հիմնական փաստարկ',
  'Key arguments': 'Հիմնական փաստարկներ',
  'Key points': 'Հիմնական կետեր',
  'Key result': 'Հիմնական արդյունք',
  'Key results': 'Հիմնական արդյունքներ',
  Kind: 'Տեսակ',
  'Kind of change': 'Փոփոխության տեսակ',
  Kinds: 'Տեսակներ',
  'Largest pool that can be proposed (whole cents)':
    'Առաջարկվող առավելագույն ֆոնդ (ամբողջ ցենտերով)',
  'Largest remainder': 'Ամենամեծ մնացորդ',
  Last: 'Վերջին',
  'Last 12 months': 'Վերջին 12 ամիսները',
  'Last active': 'Վերջին ակտիվություն',
  'Last digits of the account number': 'Հաշվեհամարի վերջին թվանշանները',
  Late: 'Ուշացած',
  'Late updates are marked as late. 0 = none.':
    'Ուշացած թարմացումները նշվում են որպես ուշացած։ 0 = չկա։',
  'Late votes': 'Ուշացած քվեներ',
  'Latest valuation': 'Վերջին գնահատումը',
  'Leave a founder’s percentage empty to exclude them from this version.':
    'Թողեք հիմնադրի տոկոսը դատարկ՝ նրան այս տարբերակից բացառելու համար։',
  'Leave all empty for equal weights. A weight of 0 leaves a method out of the blend.':
    'Թողեք բոլորը դատարկ՝ հավասար կշիռների համար։ 0 կշիռը մեթոդը բացառում է համակցությունից։',
  'Leave empty for today. The version in effect is the approved one with the latest effective date on or before this day.':
    'Թողեք դատարկ՝ այսօրվա համար։ Գործող տարբերակն այն հաստատվածն է, որի ուժի մեջ մտնելու ամսաթիվը ամենաուշն է այս օրը կամ դրանից առաջ։',
  'Leave empty to remove it.': 'Թողեք դատարկ՝ այն հեռացնելու համար։',
  'Leave empty to remove the title.': 'Թողեք դատարկ՝ վերնագիրը հեռացնելու համար։',
  'Leave empty to use the workspace default.':
    'Թողեք դատարկ՝ աշխատատիրույթի լռելյայն արժեքն օգտագործելու համար։',
  'Legal admin': 'Իրավական և վարչական',
  'Legal name': 'Իրավաբանական անվանում',
  'Less: cash set aside (restrictions)': 'Հանած՝ առանձնացված դրամական միջոցներ (սահմանափակումներ)',
  'Less: declared distributions not yet paid': 'Հանած՝ հայտարարված, բայց դեռ չվճարված բաշխումներ',
  Line: 'Տող',
  Link: 'Հղում',
  'Link a topic, decision or task': 'Կապել թեմա, որոշում կամ առաջադրանք',
  'Link attached.': 'Հղումը կցված է։',
  'Link one of my open tasks or an active goal':
    'Կապել իմ բաց առաջադրանքներից մեկը կամ ակտիվ նպատակ',
  'Link or citation, so anyone can check the figures.':
    'Հղում կամ աղբյուր, որպեսզի յուրաքանչյուրը կարողանա ստուգել թվերը։',
  'Link the agreement, minutes or message that supports the adjustment. Required.':
    'Կցեք ճշգրտումը հիմնավորող պայմանագրի, արձանագրության կամ հաղորդագրության հղումը։ Պարտադիր է։',
  'Link the bank confirmation of the transfer. Required.':
    'Կցեք փոխանցման բանկային հաստատման հղումը։ Պարտադիր է։',
  'Link the bank confirmation or receipt (e.g. on a shared drive). Required.':
    'Կցեք բանկային հաստատման կամ անդորրագրի հղումը (օր.՝ ընդհանուր սկավառակում)։ Պարտադիր է։',
  'Link the bank confirmation or receipt of the repayment (e.g. on a shared drive). Required.':
    'Կցեք մարման բանկային հաստատման կամ անդորրագրի հղումը (օր.՝ ընդհանուր սկավառակում)։ Պարտադիր է։',
  'Link title': 'Հղման վերնագիր',
  'Link URL': 'Հղման URL',
  'Linked items': 'Կապված տարրեր',
  'Linked work': 'Կապված աշխատանք',
  'Listed alphabetically. Drafts stay private until submitted.':
    'Դասավորված է այբբենական կարգով։ Սևագրերը մնում են գաղտնի մինչև ներկայացնելը։',
  'Load into the action form': 'Բեռնել գործողության ձևաթղթում',
  'Loading accounts…': 'Հաշիվները բեռնվում են…',
  'Loading bank movements…': 'Բանկային շարժերը բեռնվում են…',
  'Loading blockers…': 'Արգելափակումները բեռնվում են…',
  'Loading cap table…': 'Բաժնեմասերը բեռնվում են…',
  'Loading categories…': 'Կատեգորիաները բեռնվում են…',
  'Loading company accounts…': 'Ընկերության հաշիվները բեռնվում են…',
  'Loading company cash…': 'Ընկերության դրամական միջոցները բեռնվում են…',
  'Loading comparable multiples…': 'Համադրելի մուլտիպլիկատորները բեռնվում են…',
  'Loading contribution history…': 'Ներդրումների պատմությունը բեռնվում է…',
  'Loading data sources…': 'Տվյալների աղբյուրները բեռնվում են…',
  'Loading debts…': 'Պարտքերը բեռնվում են…',
  'Loading decision…': 'Որոշումը բեռնվում է…',
  'Loading decisions…': 'Որոշումները բեռնվում են…',
  'Loading digest…': 'Ամփոփագիրը բեռնվում է…',
  'Loading discussion…': 'Քննարկումը բեռնվում է…',
  'Loading distributions…': 'Բաշխումները բեռնվում են…',
  'Loading entries…': 'Գրառումները բեռնվում են…',
  'Loading exchange rates…': 'Փոխարժեքները բեռնվում են…',
  'Loading finalized decisions…': 'Վերջնականացված որոշումները բեռնվում են…',
  'Loading finance settings…': 'Ֆինանսական կարգավորումները բեռնվում են…',
  'Loading founder funding…': 'Հիմնադիրների ֆինանսավորումը բեռնվում է…',
  'Loading founder…': 'Հիմնադիրը բեռնվում է…',
  'Loading founders…': 'Հիմնադիրները բեռնվում են…',
  'Loading funding calls…': 'Ֆինանսավորման կանչերը բեռնվում են…',
  'Loading goal…': 'Նպատակը բեռնվում է…',
  'Loading governance policies…': 'Կառավարման քաղաքականությունները բեռնվում են…',
  'Loading grants…': 'Շնորհումները բեռնվում են…',
  'Loading history…': 'Պատմությունը բեռնվում է…',
  'Loading invitations…': 'Հրավերները բեռնվում են…',
  'Loading meeting…': 'Հանդիպումը բեռնվում է…',
  'Loading members…': 'Անդամները բեռնվում են…',
  'Loading page…': 'Էջը բեռնվում է…',
  'Loading period…': 'Ժամանակաշրջանը բեռնվում է…',
  'Loading periods…': 'Ժամանակաշրջանները բեռնվում են…',
  'Loading personal finances…': 'Անձնական ֆինանսները բեռնվում են…',
  'Loading reporting settings…': 'Հաշվետվությունների կարգավորումները բեռնվում են…',
  'Loading reserve and distributions…': 'Պահուստը և բաշխումները բեռնվում են…',
  'Loading reserve policies…': 'Պահուստի քաղաքականությունները բեռնվում են…',
  'Loading responsibilities…': 'Պատասխանատվությունները բեռնվում են…',
  'Loading restrictions…': 'Սահմանափակումները բեռնվում են…',
  'Loading revision…': 'Խմբագրությունը բեռնվում է…',
  'Loading security settings…': 'Անվտանգության կարգավորումները բեռնվում են…',
  'Loading sessions…': 'Սեսիաները բեռնվում են…',
  'Loading snapshots…': 'Պատկերները բեռնվում են…',
  'Loading task settings…': 'Առաջադրանքների կարգավորումները բեռնվում են…',
  'Loading task…': 'Առաջադրանքը բեռնվում է…',
  'Loading the AI draft…': 'AI սևագիրը բեռնվում է…',
  'Loading the assistant…': 'Օգնականը բեռնվում է…',
  'Loading the debt…': 'Պարտքը բեռնվում է…',
  'Loading the decision to supersede…': 'Փոխարինվող որոշումը բեռնվում է…',
  'Loading the distribution…': 'Բաշխումը բեռնվում է…',
  'Loading the entry…': 'Գրառումը բեռնվում է…',
  'Loading the funding call…': 'Ֆինանսավորման կանչը բեռնվում է…',
  'Loading the movements…': 'Շարժերը բեռնվում են…',
  'Loading the P&amp;L…': 'P&amp;L-ը բեռնվում է…',
  'Loading the payment…': 'Վճարումը բեռնվում է…',
  'Loading the statement…': 'Քաղվածքը բեռնվում է…',
  'Loading the valuation…': 'Գնահատումը բեռնվում է…',
  'Loading topic…': 'Թեման բեռնվում է…',
  'Loading update…': 'Թարմացումը բեռնվում է…',
  'Loading valuations…': 'Գնահատումները բեռնվում են…',
  'Loading voting rounds…': 'Քվեարկության փուլերը բեռնվում են…',
  'Loading workspace…': 'Աշխատատիրույթը բեռնվում է…',
  'Loading your settings…': 'Ձեր կարգավորումները բեռնվում են…',
  'Loading your update…': 'Ձեր թարմացումը բեռնվում է…',
  'Loading your workspaces…': 'Ձեր աշխատատիրույթները բեռնվում են…',
  'Loading…': 'Բեռնվում է…',
  'Loan to the company': 'Փոխառություն ընկերությանը',
  Location: 'Վայր',
  'Locked — on a ballot': 'Կողպված է — ներառված է քվեաթերթիկում',
  'Longest waiting': 'Ամենաերկար սպասողները',
  'Looking for matching entries…': 'Համապատասխան գրառումների որոնում…',
  'Lost your device? Enter one of your recovery codes instead.':
    'Կորցրե՞լ եք սարքը։ Փոխարենը մուտքագրեք վերականգնման կոդերից մեկը։',
  Low: 'Ցածր',
  'Low multiple': 'Ցածր մուլտիպլիկատոր',
  'Low recurring share': 'Կրկնվող եկամտի ցածր բաժին',
  'Magic link': 'Մուտքի հղում',
  'Majority of cast': 'Տրված քվեների մեծամասնություն',
  'Majority of eligible': 'Իրավասուների մեծամասնություն',
  Manage: 'Կառավարել',
  'Manage integrations': 'Կառավարել ինտեգրումները',
  'Manage participants': 'Կառավարել մասնակիցներին',
  Manual: 'Ձեռքով',
  'Manual adjustment': 'Ձեռքով ճշգրտում',
  'Manual entries are attributed to you and to the manual data source. Once recorded, an entry is posted to the journal and can only be voided or corrected by reversal.':
    'Ձեռքով գրառումները վերագրվում են ձեզ և ձեռքով տվյալների աղբյուրին։ Գրանցվելուց հետո գրառումը ձևակերպվում է մատյանում և կարող է միայն չեղարկվել կամ ուղղվել հակադարձմամբ։',
  'Manual entry': 'Ձեռքով մուտքագրում',
  Margins: 'Մարժաներ',
  'Mark as done': 'Նշել որպես կատարված',
  'Mark as done…': 'Նշել որպես կատարված…',
  'Mark as read': 'Նշել որպես կարդացված',
  Match: 'Համապատասխանեցնել',
  'Match to a recorded entry': 'Համապատասխանեցնել գրանցված գրառմանը',
  Matched: 'Համընկած',
  'Matched bank movements': 'Համապատասխանեցված բանկային շարժեր',
  'Matched entry': 'Համապատասխանեցված գրառում',
  Medium: 'Միջին',
  Meeting: 'Հանդիպում',
  'Meeting agenda changed': 'Հանդիպման օրակարգը փոխվել է',
  'Meeting details': 'Հանդիպման մանրամասներ',
  'Meeting not available': 'Հանդիպումը հասանելի չէ',
  'Meeting required': 'Պահանջվում է հանդիպում',
  Meetings: 'Հանդիպումներ',
  Member: 'Անդամ',
  Members: 'Անդամներ',
  'Members could not be loaded': 'Չհաջողվեց բեռնել անդամներին',
  'Members to mention': 'Նշվող անդամներ',
  Mention: 'Հիշատակում',
  'Mentioned in updates': 'Նշված է թարմացումներում',
  Method: 'Մեթոդ',
  'Method excluded': 'Մեթոդը բացառված է',
  'Method weights (percent)': 'Մեթոդների կշիռներ (տոկոս)',
  Methods: 'Մեթոդներ',
  'Methods disagree': 'Մեթոդները չեն համընկնում',
  Metric: 'Ցուցանիշ',
  Metrics: 'Ցուցանիշներ',
  'Mfa enrollment required': 'Պահանջվում է MFA-ի միացում',
  'Mfa recommended': 'MFA-ն խորհուրդ է տրվում',
  'Mfa required': 'MFA-ն պարտադիր է',
  'Min participants': 'Նվազագույն մասնակիցներ',
  Mine: 'Իմը',
  'Minimum participating voters': 'Մասնակցող քվեարկողների նվազագույն թիվ',
  'Minimum to keep': 'Պահպանվող նվազագույնը',
  Minutes: 'Արձանագրություն',
  'Minutes can be finalized after the meeting is completed.':
    'Արձանագրությունը կարող է վերջնականացվել հանդիպման ավարտից հետո։',
  'Minutes final': 'Արձանագրությունը վերջնական է',
  'Minutes saved.': 'Արձանագրությունը պահված է։',
  Missed: 'Բաց թողնված',
  'Missed periods': 'Բաց թողնված ժամանակաշրջաններ',
  Missing: 'Բացակայում է',
  'Missing — not deducted': 'Բացակայում է — չի նվազեցվել',
  'Missing data and warnings': 'Բացակայող տվյալներ և զգուշացումներ',
  'Missing fx rate': 'Փոխարժեքը բացակայում է',
  'Missing fx rates': 'Փոխարժեքները բացակայում են',
  'Missing input': 'Մուտքային տվյալը բացակայում է',
  'Mobile push': 'Բջջային ծանուցում',
  'Mobile push and Telegram are prepared but not connected yet, so they cannot be switched on here.':
    'Բջջային push ծանուցումները և Telegram-ը պատրաստված են, բայց դեռ միացված չեն, ուստի դրանք այստեղ հնարավոր չէ ակտիվացնել։',
  Money: 'Գումար',
  'Money in': 'Մուտքեր',
  'Money out': 'Ելքեր',
  Month: 'Ամիս',
  Monthly: 'Ամսական',
  'Monthly net burn': 'Ամսական զուտ ծախսում',
  'Monthly revenue, expenses and result': 'Ամսական եկամուտ, ծախսեր և արդյունք',
  Months: 'Ամիսներ',
  'Months of average expenses': 'Միջին ծախսերի ամիսներ',
  'Months of expenses': 'Ծախսերի ամիսներ',
  'Months of expenses to keep': 'Պահվող ծախսերի ամիսներ',
  'Move down': 'Տեղափոխել ներքև',
  'Move up': 'Տեղափոխել վերև',
  Movement: 'Շարժ',
  Multiple: 'Բազմապատկիչ',
  'Multiple choice': 'Բազմակի ընտրություն',
  'Multiple choice (vote)': 'Բազմակի ընտրություն (քվե)',
  'my comment': 'իմ մեկնաբանությունը',
  'My distributions': 'Իմ բաշխումները',
  'My finances': 'Իմ ֆինանսները',
  'My overdue tasks': 'Իմ ժամկետանց առաջադրանքները',
  'My task is due soon': 'Իմ առաջադրանքի ժամկետը մոտենում է',
  'My task is overdue': 'Իմ առաջադրանքը ժամկետանց է',
  'My update': 'Իմ թարմացումը',
  'My vote is requested': 'Իմ քվեն պահանջվում է',
  'My weekly update': 'Իմ շաբաթական թարմացումը',
  'My weekly update is due': 'Իմ շաբաթական թարմացման ժամկետը լրանում է',
  Name: 'Անվանում',
  'Need decision': 'Անհրաժեշտ է որոշում',
  'Need discussion': 'Անհրաժեշտ է քննարկում',
  'Needed by': 'Անհրաժեշտ է մինչև',
  'Needs an outcome': 'Անհրաժեշտ է արդյունք',
  'Needs attention': 'Պահանջում է ուշադրություն',
  'Negative cash': 'Բացասական դրամական մնացորդ',
  'Negative equity': 'Բացասական բաժնեմաս',
  'Negative for an overdraft, e.g. -120.50.': 'Բացասական՝ օվերդրաֆտի դեպքում, օրինակ՝ -120.50։',
  Net: 'Զուտ',
  'Netted against a distribution': 'Հաշվանցված բաշխման դիմաց',
  'Netting against distribution': 'Հաշվանցում բաշխման դիմաց',
  'Network error': 'Ցանցային սխալ',
  'New checklist item': 'Ստուգաթերթի նոր կետ',
  'New deadline': 'Նոր վերջնաժամկետ',
  'New distribution': 'Նոր բաշխում',
  'New distribution proposal': 'Բաշխման նոր առաջարկ',
  'New draft cap table version': 'Բաժնեմասի աղյուսակի նոր սևագիր տարբերակ',
  'New funding call': 'Նոր ֆինանսավորման կանչ',
  'New goal': 'Նոր նպատակ',
  'New income or expense': 'Նոր եկամուտ կամ ծախս',
  'New intervals apply to the next reminder run. The change is audited.':
    'Նոր ընդմիջումները կկիրառվեն հիշեցումների հաջորդ գործարկման ժամանակ։ Փոփոխությունը գրանցվում է աուդիտի մատյանում։',
  'New meeting': 'Նոր հանդիպում',
  'New owner': 'Նոր սեփականատեր',
  'New password': 'Նոր գաղտնաբառ',
  'New status': 'Նոր կարգավիճակ',
  'New task': 'Նոր առաջադրանք',
  'New topic': 'Նոր թեմա',
  'new valuation': 'նոր գնահատում',
  'New valuation': 'Նոր գնահատում',
  'Newly invited participants are notified.': 'Նոր հրավիրված մասնակիցները ծանուցվում են։',
  Next: 'Հաջորդը',
  'Next due': 'Հաջորդ ժամկետը',
  'Next month': 'Հաջորդ ամիս',
  'Next-12-month revenue': 'Հաջորդ 12 ամսվա եկամուտ',
  'No — this is a new change': 'Ոչ — սա նոր փոփոխություն է',
  'No “Next” text was written.': '«Հաջորդը» տեքստ չի գրվել։',
  'No accounts or entries yet.': 'Հաշիվներ կամ գրառումներ դեռ չկան։',
  'No action': 'Առանց գործողության',
  'No actions have been created from this decision yet.':
    'Այս որոշումից դեռ գործողություններ չեն ստեղծվել։',
  'No active members to choose from.': 'Ընտրելու համար ակտիվ անդամներ չկան։',
  'No approved cap table includes you yet.':
    'Ձեզ դեռ չի ներառում բաժնեմասի որևէ հաստատված աղյուսակ։',
  'No approved version is in effect. Rounds cannot open under this policy.':
    'Հաստատված տարբերակ ուժի մեջ չէ։ Այս քաղաքականության համաձայն փուլերը չեն կարող բացվել։',
  'No attachments yet.': 'Կցորդներ դեռ չկան։',
  'No balances yet.': 'Մնացորդներ դեռ չկան։',
  'No blockers were reported.': 'Արգելափակումներ չեն հաղորդվել։',
  'No cap table': 'Բաժնեմասերի աղյուսակ չկա',
  'No cap table versions yet. Create the first draft above.':
    'Բաժնեմասի աղյուսակի տարբերակներ դեռ չկան։ Ստեղծեք առաջին սևագիրը վերևում։',
  'No categories yet.': 'Կատեգորիաներ դեռ չկան։',
  'No category': 'Առանց կատեգորիայի',
  'No checklist items.': 'Ստուգաթերթի կետեր չկան։',
  'No collaborators or watchers.': 'Համագործակիցներ կամ դիտորդներ չկան։',
  'No comments yet.': 'Մեկնաբանություններ դեռ չկան։',
  'No comments yet. Start the discussion below.':
    'Մեկնաբանություններ դեռ չկան։ Սկսեք քննարկումը ներքևում։',
  'No company accounts yet.': 'Ընկերության հաշիվներ դեռ չկան։',
  'No comparable multiples are approved, so no valuation method can be applied yet. MFOS has no built-in multiples (open founder decision 13): propose a set with its published source under':
    'Համադրելի բազմապատկիչներ հաստատված չեն, ուստի գնահատման ոչ մի մեթոդ դեռ չի կարող կիրառվել։ MFOS-ը ներկառուցված բազմապատկիչներ չունի (հիմնադիրների բաց որոշում 13). առաջարկեք հավաքածու՝ իր հրապարակված աղբյուրով, այստեղ՝',
  'No comparable multiples have been proposed.': 'Համեմատելի բազմապատկիչներ չեն առաջարկվել։',
  'No contributions recorded in this window.': 'Այս ժամանակահատվածում ներդրումներ չեն գրանցվել։',
  'No data-quality warnings.': 'Տվյալների որակի վերաբերյալ զգուշացումներ չկան։',
  'No deadline': 'Առանց վերջնաժամկետի',
  'No debts.': 'Պարտքեր չկան։',
  'No decision has been recorded for this topic yet.': 'Այս թեմայի համար դեռ որոշում չի գրանցվել։',
  'No decision return to discussion': 'Որոշում չկա, վերադարձ քննարկման',
  'No distribution has been declared for you.': 'Ձեզ համար բաշխում չի հայտարարվել։',
  'No distribution has been proposed.': 'Բաշխում չի առաջարկվել։',
  'No distributions declared.': 'Հայտարարված բաշխումներ չկան։',
  'No distributions proposed.': 'Առաջարկված բաշխումներ չկան։',
  'No entries': 'Գրառումներ չկան',
  'No entries for this period.': 'Այս ժամանակաշրջանի համար գրառումներ չկան։',
  'No entries yet.': 'Գրառումներ դեռ չկան։',
  'No equity history is visible to you.': 'Բաժնեմասի պատմությունը ձեզ տեսանելի չէ։',
  'No evidence attached yet.': 'Ապացույց դեռ կցված չէ։',
  'No exchange rates recorded.': 'Փոխարժեքներ չեն գրանցվել։',
  'No expense data': 'Ծախսերի տվյալներ չկան',
  'No founder debt or credit is open.': 'Հիմնադրի բաց պարտք կամ վարկ չկա։',
  'No founder profiles yet.': 'Հիմնադիրների պրոֆիլներ դեռ չկան։',
  'No founders on record.': 'Գրանցված հիմնադիրներ չկան։',
  'No funding call is open.': 'Բաց ֆինանսավորման կանչ չկա։',
  'No funding calls.': 'Ֆինանսավորման կանչեր չկան։',
  'No funding shares, debts or credits yet.':
    'Ֆինանսավորման մասնաբաժիններ, պարտքեր կամ վարկեր դեռ չկան։',
  'No further payments can be recorded towards the call.':
    'Այս կանչի համար այլևս վճարումներ չեն կարող գրանցվել։',
  'No income or expenses recorded in the last 12 months.':
    'Վերջին 12 ամսում եկամուտներ կամ ծախսեր չեն գրանցվել։',
  'No invitations yet.': 'Հրավերներ դեռ չկան։',
  'No items yet. You can also add or generate the agenda after creating the meeting.':
    'Կետեր դեռ չկան։ Օրակարգը կարող եք ավելացնել կամ ստեղծել նաև հանդիպումը ստեղծելուց հետո։',
  'No key results. A goal can stay directional without them.':
    'Հիմնական արդյունքներ չկան։ Նպատակը կարող է մնալ ուղղորդող՝ առանց դրանց։',
  'No linked items yet.': 'Կապված տարրեր դեռ չկան։',
  'No measurable progress yet': 'Չափելի առաջընթաց դեռ չկա',
  'No minutes were recorded.': 'Արձանագրություն չի կազմվել։',
  'No notes yet.': 'Նշումներ դեռ չկան։',
  'No one is expected to report for this period.':
    'Այս ժամանակաշրջանի համար ոչ ոքից հաշվետվություն չի սպասվում։',
  'No open blocker is visible to you.': 'Ձեզ տեսանելի բաց արգելափակում չկա։',
  'No operating accounts': 'Գործառնական հաշիվներ չկան',
  'No operating accounts yet.': 'Գործառնական հաշիվներ դեռ չկան։',
  'No options have been proposed yet.': 'Տարբերակներ դեռ չեն առաջարկվել։',
  'No owner': 'Առանց սեփականատիրոջ',
  'No ownership recorded on an approved cap table.':
    'Բաժնեմասի հաստատված աղյուսակում սեփականություն չի գրանցվել։',
  'No participants listed.': 'Մասնակիցներ նշված չեն։',
  'No payments recorded.': 'Վճարումներ չեն գրանցվել։',
  'No permission grants.': 'Թույլտվություններ տրված չեն։',
  'No recorded income or expenses in either month.':
    'Ոչ մի ամսում գրանցված եկամուտներ կամ ծախսեր չկան։',
  'No recorded income or expenses in this period.':
    'Այս ժամանակաշրջանում գրանցված եկամուտներ կամ ծախսեր չկան։',
  'No reporting periods in this window.': 'Այս ժամանակահատվածում հաշվետու ժամանակաշրջաններ չկան։',
  'No reporting periods yet. They appear once the reporting schedule is set and the first period starts.':
    'Հաշվետու ժամանակաշրջաններ դեռ չկան։ Դրանք կհայտնվեն հաշվետվությունների ժամանակացույցը սահմանելուց և առաջին ժամանակաշրջանը սկսվելուց հետո։',
  'No reserve policy': 'Պահուստի քաղաքականություն չկա',
  'No reserve policy applies.': 'Պահուստի քաղաքականություն չի կիրառվում։',
  'No reserve policy has been proposed. Distributions stay blocked until the founders approve one.':
    'Պահուստի քաղաքականություն չի առաջարկվել։ Բաշխումները արգելափակված են մնում, մինչև հիմնադիրները հաստատեն այն։',
  'No responsibility periods in the recent window.':
    'Վերջին ժամանակահատվածում պատասխանատվության ժամանակաշրջաններ չկան։',
  'No settlements recorded.': 'Մարումներ չեն գրանցվել։',
  'No share has anything outstanding.': 'Ոչ մի մասնաբաժին չմարված մնացորդ չունի։',
  'No shares calculated.': 'Մասնաբաժիններ չեն հաշվարկվել։',
  'No snapshots yet.': 'Պատկերներ դեռ չկան։',
  'No submitted update.': 'Ներկայացված թարմացում չկա։',
  'No valuation has been recorded yet.': 'Գնահատում դեռ չի գրանցվել։',
  'No visible tasks in this window.': 'Այս ժամանակահատվածում տեսանելի առաջադրանքներ չկան։',
  'No vote has been started on this topic.': 'Այս թեմայով քվեարկություն չի սկսվել։',
  'No workspace yet': 'Աշխատատիրույթ դեռ չկա',
  'Nobody in particular': 'Ոչ ոք մասնավորապես',
  'Nobody is expected to report for this period.':
    'Այս ժամանակաշրջանի համար ոչ ոքից հաշվետվություն չի սպասվում։',
  'Nobody is waiting for you right now.': 'Այս պահին ոչ ոք ձեզ չի սպասում։',
  'Non operating cash excluded': 'Ոչ գործառնական միջոցները բացառված են',
  None: 'Ոչ մեկը',
  'None (top level)': 'Ոչ մեկը (վերին մակարդակ)',
  'None added.': 'Ոչինչ ավելացված չէ։',
  'None.': 'Ոչ մեկը։',
  Normal: 'Սովորական',
  'Normalized inputs': 'Նորմալացված մուտքային տվյալներ',
  'Not a duplicate': 'Կրկնօրինակ չէ',
  'Not a formal valuation.': 'Պաշտոնական գնահատում չէ։',
  'Not allowed': 'Չի թույլատրվում',
  'Not applied': 'Կիրառված չէ',
  'Not applied to any funding-call share.':
    'Կիրառված չէ ֆինանսավորման կանչի որևէ մասնաբաժնի նկատմամբ։',
  'Not assigned': 'Նշանակված չէ',
  'Not available yet': 'Դեռ հասանելի չէ',
  'Not burning': 'Միջոցներ չեն ծախսվում',
  'Not burning cash': 'Դրամական միջոցներ չեն այրվում',
  'Not configured': 'Կարգավորված չէ',
  'Not connected': 'Միացված չէ',
  'Not counted': 'Չհաշված',
  'Not due': 'Ժամկետը չի լրացել',
  'Not due yet': 'Ժամկետը դեռ չի լրացել',
  'Not enough data': 'Տվյալները բավարար չեն',
  'Not expected': 'Չի սպասվում',
  'Not found': 'Չի գտնվել',
  'Not in effect today': 'Այսօր ուժի մեջ չէ',
  'Not included': 'Ներառված չէ',
  'Not invited': 'Հրավիրված չէ',
  'Not recorded': 'Գրանցված չէ',
  'Not reported': 'Հաշվետվություն չկա',
  'Not reported yet': 'Հաշվետվություն դեռ չկա',
  'Not required': 'Պարտադիր չէ',
  'Not started': 'Չսկսված',
  'Not yet approved': 'Դեռ հաստատված չէ',
  Note: 'Նշում',
  Notes: 'Նշումներ',
  'Notes and disputes': 'Նշումներ և վեճեր',
  'Nothing awaiting classification.': 'Դասակարգման սպասող տարրեր չկան։',
  'Nothing distributable': 'Բաշխելու ոչինչ չկա',
  'Nothing generated yet.': 'Դեռ ոչինչ չի ստեղծվել։',
  'Nothing has happened yet.': 'Դեռ ոչինչ տեղի չի ունեցել։',
  'Nothing is linked yet.': 'Դեռ ոչինչ կապված չէ։',
  'Nothing is overdue.': 'Ժամկետանց ոչինչ չկա։',
  'Nothing is set aside.': 'Ոչինչ առանձնացված չէ։',
  'Nothing needs to happen. Explain why.': 'Ոչինչ անելու կարիք չկա։ Բացատրեք՝ ինչու։',
  'Nothing open': 'Բաց ոչինչ չկա',
  'Nothing owed.': 'Պարտք չկա։',
  'Nothing reported.': 'Ոչինչ չի հաղորդվել։',
  'Nothing set aside.': 'Ոչինչ առանձնացված չէ։',
  'Nothing settled yet.': 'Դեռ ոչինչ մարված չէ։',
  'Nothing to pay.': 'Վճարելու ոչինչ չկա։',
  'Nothing to search for yet.': 'Դեռ որոնելու ոչինչ չկա։',
  'Nothing visible to you is overdue.': 'Ձեզ տեսանելի ժամկետանց ոչինչ չկա։',
  'Notification channels per event. Locked cells cannot be switched off.':
    'Ծանուցման ալիքներն ըստ իրադարձության։ Կողպված վանդակները հնարավոր չէ անջատել։',
  'Notification settings': 'Ծանուցումների կարգավորումներ',
  'Notification settings saved.': 'Ծանուցումների կարգավորումները պահվեցին։',
  Notifications: 'Ծանուցումներ',
  'Numbers worth sharing, with their source.': 'Կիսվելու արժանի թվեր՝ իրենց աղբյուրով։',
  Objective: 'Նպատակ',
  Obligation: 'Պարտավորություն',
  'Obligation counts': 'Պարտավորությունների քանակ',
  'Obligation due': 'Պարտավորության ժամկետը լրացել է',
  'Obligation due soon': 'Պարտավորության ժամկետը մոտենում է',
  'Obligation figures are not part of your access.':
    'Պարտավորությունների թվերը ձեր հասանելիության մեջ չեն մտնում։',
  'Obligation period': 'Պարտավորության ժամանակահատված',
  Obligations: 'Պարտավորություններ',
  Observed: 'Դիտարկված',
  Observer: 'Դիտող',
  of: 'ից',
  'of the filtered entries': 'զտված գրառումներից',
  'Of which late': 'Որից ուշացած',
  'Of which overdue': 'Որից ժամկետանց',
  'Of which paid for another founder': 'Որից վճարված այլ հիմնադրի փոխարեն',
  Off: 'Անջատված',
  'Off track': 'Շեղված',
  On: 'Միացված',
  'On track': 'Ըստ պլանի',
  'Once finalized, this decision becomes a permanent part of the register and cannot be edited or deleted. Later changes are only possible through a new decision that amends, reverses or replaces it.':
    'Վերջնականացվելուց հետո այս որոշումը դառնում է ռեեստրի մշտական մաս և չի կարող խմբագրվել կամ ջնջվել։ Հետագա փոփոխությունները հնարավոր են միայն նոր որոշման միջոցով, որը փոփոխում, չեղարկում կամ փոխարինում է այն։',
  'One account holds one currency.': 'Մեկ հաշիվը պարունակում է մեկ արժույթ։',
  'One owner, a period, and optional measurable key results.':
    'Մեկ սեփականատեր, ժամանակաշրջան և ըստ ցանկության՝ չափելի հիմնական արդյունքներ։',
  'One per member': 'Մեկ անդամին մեկ',
  'One time': 'Միանվագ',
  'Only for fixing an error in an approved version.':
    'Միայն հաստատված տարբերակում սխալ ուղղելու համար։',
  Open: 'Բաց',
  'Open blockers': 'Բաց արգելափակումներ',
  'Open blockers by age': 'Բաց արգելափակումներն ըստ տևողության',
  'Open distributions': 'Բաց բաշխումներ',
  'Open funding': 'Բաց ֆինանսավորում',
  'Open my finances': 'Բացել իմ ֆինանսները',
  'Open tasks': 'Բաց առաջադրանքներ',
  'Open the expense entry': 'Բացել ծախսի գրառումը',
  'Open the payment': 'Բացել վճարումը',
  'open the setup link directly': 'բացեք կարգավորման հղումն անմիջապես',
  'Open voting': 'Բացել քվեարկությունը',
  'Open voting now': 'Բացել քվեարկությունը հիմա',
  'Open your authenticator app and enter the current code for Mekum Founder OS.':
    'Բացեք ձեր նույնականացման հավելվածը և մուտքագրեք Mekum Founder OS-ի ընթացիկ կոդը։',
  Opened: 'Բացված',
  'Opening balance': 'Սկզբնական մնացորդ',
  'Opening balance (optional)': 'Սկզբնական մնացորդ (ըստ ցանկության)',
  'Opening fixes the eligible voter list now and asks the voters to vote.':
    'Բացելիս իրավասու քվեարկողների ցանկն ամրագրվում է հիմա, և քվեարկողներին խնդրում են քվեարկել։',
  'Opening fixes the eligible voter list now. Leave unchecked to save a draft round.':
    'Բացելիս իրավասու քվեարկողների ցանկն ամրագրվում է հիմա։ Թողեք չնշված՝ փուլը որպես սևագիր պահելու համար։',
  Operating: 'Գործառնական',
  'Operating account (counts towards burn and runway)':
    'Գործառնական հաշիվ (հաշվվում է ծախսման և ֆինանսական պաշարի մեջ)',
  'Operating accounts': 'Գործառնական հաշիվներ',
  'Operating cash': 'Գործառնական դրամական միջոցներ',
  'Operating cash (book balance of operating accounts)':
    'Գործառնական դրամական միջոցներ (գործառնական հաշիվների հաշվապահական մնացորդ)',
  'Operating cash instead of the book balance':
    'Գործառնական դրամական միջոցներ՝ հաշվապահական մնացորդի փոխարեն',
  Operations: 'Գործառնություններ',
  Option: 'Տարբերակ',
  'Option selected': 'Տարբերակն ընտրված է',
  'Option title': 'Տարբերակի անվանում',
  Optional: 'Ըստ ցանկության',
  'Optional for a draft. Approval needs either a decision or a written reference.':
    'Սևագրի համար՝ ըստ ցանկության։ Հաստատման համար անհրաժեշտ է որոշում կամ գրավոր հղում։',
  'Optional participant': 'Ոչ պարտադիր մասնակից',
  'Optional, e.g. after an expected payment.': 'Ըստ ցանկության, օրինակ՝ սպասվող վճարումից հետո։',
  'Optional, e.g. CTO.': 'Ըստ ցանկության, օրինակ՝ CTO։',
  'Optional, e.g. link to the report.': 'Ըստ ցանկության, օրինակ՝ հաշվետվության հղումը։',
  'Optional, e.g. the decision approving a budget.':
    'Ըստ ցանկության, օրինակ՝ բյուջեն հաստատող որոշումը։',
  'Optional: ID of the founder decision that approved this grant.':
    'Ըստ ցանկության՝ այս թույլտվությունը հաստատած հիմնադիրների որոշման ID-ն։',
  'Optional: the founder decision that assigned this responsibility.':
    'Ըստ ցանկության՝ այս պատասխանատվությունը սահմանած հիմնադիրների որոշումը։',
  'Optional.': 'Ըստ ցանկության։',
  'Optional. Dashboard visibility only.': 'Ըստ ցանկության։ Միայն վահանակում ցուցադրելու համար։',
  'Optional. Helps organizers fit the agenda.':
    'Ըստ ցանկության։ Օգնում է կազմակերպիչներին հարմարեցնել օրակարգը։',
  'Optional. Room or address.': 'Ըստ ցանկության։ Սենյակ կամ հասցե։',
  'Optional. Same time zone.': 'Ըստ ցանկության։ Նույն ժամային գոտին։',
  'Optional. The calendar date the decision takes effect.':
    'Ըստ ցանկության։ Օրացուցային ամսաթիվը, երբ որոշումն ուժի մեջ է մտնում։',
  'Optional. Visible with your vote.': 'Ըստ ցանկության։ Տեսանելի է ձեր քվեի հետ։',
  'Optional. Why the rules change.': 'Ըստ ցանկության։ Ինչու են կանոնները փոխվում։',
  'Optional. Why this decision was taken.': 'Ըստ ցանկության։ Ինչու է այս որոշումը կայացվել։',
  'Options and proposals': 'Տարբերակներ և առաջարկներ',
  or: 'կամ',
  'Or add a custom item': 'Կամ ավելացրեք անհատական կետ',
  'Or waiting for (team / outside party)': 'Կամ սպասում է (թիմին / արտաքին կողմին)',
  Organizer: 'Կազմակերպիչ',
  'Organizer (always invited)': 'Կազմակերպիչ (միշտ հրավիրված է)',
  Origin: 'Ծագում',
  'Original amount': 'Սկզբնական գումար',
  Other: 'Այլ',
  'Other approved': 'Այլ հաստատված',
  'Other approved treatment': 'Այլ հաստատված մոտեցում',
  'Other founders owe them': 'Այլ հիմնադիրները պարտք են նրան',
  'Other records': 'Այլ գրառումներ',
  'Other treatment (by decision)': 'Այլ մոտեցում (որոշմամբ)',
  'Other workspace updates': 'Աշխատատիրույթի այլ թարմացումներ',
  'Out of date': 'Հնացած',
  Outcome: 'Արդյունք',
  'Outcome (optional)': 'Արդյունք (ըստ ցանկության)',
  'Outcomes and action items can be recorded once the meeting is in progress.':
    'Արդյունքները և գործողության կետերը կարելի է գրանցել, երբ հանդիպումն սկսվի։',
  'Outcomes per agenda item are recorded on the agenda above.':
    'Օրակարգի յուրաքանչյուր կետի արդյունքները գրանցվում են վերևի օրակարգում։',
  Outflow: 'Ելք',
  Outstanding: 'Չմարված',
  'Outstanding on open calls': 'Չմարված՝ բաց կանչերով',
  'Over 90 days': 'Ավելի քան 90 օր',
  overdue: 'ժամկետանց',
  Overdue: 'Ժամկետանց',
  'Overdue on open calls': 'Ժամկետանց՝ բաց կանչերով',
  'Overdue or missing': 'Ժամկետանց կամ բացակայող',
  'Overdue shares': 'Ժամկետանց մասնաբաժիններ',
  'Overdue tasks': 'Ժամկետանց առաջադրանքներ',
  'Overpayment credit': 'Գերավճարի կրեդիտ',
  Overview: 'Ընդհանուր ակնարկ',
  Owed: 'Պարտք',
  'Owed by': 'Պարտապան',
  'Owed by founder': 'Հիմնադրի պարտքը',
  'Owed to': 'Պարտատեր',
  'Owed to founder': 'Պարտք հիմնադրին',
  Owes: 'Պարտք է',
  'Owes less': 'Ավելի քիչ է պարտք',
  'Owes more': 'Ավելի շատ է պարտք',
  'Owes other founders': 'Պարտք է այլ հիմնադիրներին',
  'Owes the company': 'Պարտք է ընկերությանը',
  Owner: 'Սեփականատեր',
  'Owner changes': 'Սեփականատիրոջ փոփոխություններ',
  'Owner decision': 'Սեփականատիրոջ որոշում',
  'Owner history': 'Սեփականատիրոջ պատմություն',
  Ownership: 'Սեփականություն',
  'Ownership %': 'Սեփականության %',
  'Ownership is taken from the cap table in force on this date.':
    'Սեփականությունը վերցվում է այս ամսաթվին գործող բաժնեմասից։',
  'Ownership percentage': 'Սեփականության տոկոս',
  'Ownership used': 'Կիրառված սեփականություն',
  'Page not found': 'Էջը չի գտնվել',
  Paid: 'Վճարված',
  'Paid by': 'Վճարող',
  'Paid by a founder': 'Վճարվել է հիմնադրի կողմից',
  'Paid by founders for their own shares': 'Վճարված հիմնադիրների կողմից իրենց մասնաբաժինների համար',
  'Paid by the founder': 'Վճարված հիմնադրի կողմից',
  'Paid for another founder': 'Վճարված այլ հիմնադրի փոխարեն',
  'Paid from': 'Վճարված է՝ հաշվից',
  'Paid in': 'Վճարված է',
  'Paid on': 'Վճարման ամսաթիվ',
  'Paid to founders': 'Վճարված հիմնադիրներին',
  'Paid via': 'Վճարման եղանակ',
  'Parent category': 'Ծնող կատեգորիա',
  'Part of a larger goal': 'Ավելի մեծ նպատակի մաս',
  Partial: 'Մասնակի',
  'Partially funded': 'Մասնակի ֆինանսավորված',
  'Partially paid': 'Մասնակի վճարված',
  'Partially settled': 'Մասնակի մարված',
  Participant: 'Մասնակից',
  Participants: 'Մասնակիցներ',
  'Participants are notified about the new time.': 'Մասնակիցները ծանուցվում են նոր ժամի մասին։',
  'Participating weight': 'Մասնակցող կշիռ',
  Partnerships: 'Գործընկերություններ',
  Password: 'Գաղտնաբառ',
  'Password changed. Your other sessions were signed out.':
    'Գաղտնաբառը փոխվեց։ Ձեր մյուս սեսիաներից դուրս եք եկել։',
  Past: 'Անցյալ',
  'Past due date': 'Ժամկետն անցել է',
  Patch: 'PATCH',
  Paused: 'Դադարեցված',
  'Pausing keeps all past periods and updates.':
    'Դադարեցումը պահպանում է բոլոր անցյալ ժամանակաշրջաններն ու թարմացումները։',
  'Payload too large': 'Տվյալների ծավալը չափազանց մեծ է',
  Payment: 'Վճարում',
  'Payment amounts': 'Վճարման գումարներ',
  'Payment method': 'Վճարման եղանակ',
  'Payment provider': 'Վճարային մատակարար',
  'Payment reference': 'Վճարման հղում',
  Payments: 'Վճարումներ',
  'Payments made to founders': 'Հիմնադիրներին կատարված վճարումներ',
  'Payments towards this call': 'Այս կանչի դիմաց վճարումներ',
  Payroll: 'Աշխատավարձ',
  Pending: 'Սպասում է',
  'Pending change — not yet approved.': 'Սպասվող փոփոխություն — դեռ հաստատված չէ։',
  'Pending classification': 'Սպասում է դասակարգման',
  People: 'Մարդիկ',
  Percent: 'Տոկոս',
  'Percentage of cash': 'Դրամական միջոցների տոկոս',
  'Percentage of operating cash': 'Գործառնական դրամական միջոցների տոկոս',
  'Percentage of operating cash to keep': 'Պահվող գործառնական դրամական միջոցների տոկոսը',
  Period: 'Ժամանակաշրջան',
  'Period ends': 'Ժամանակաշրջանի ավարտ',
  'Period from': 'Ժամանակաշրջան՝ սկսած',
  'Period starts': 'Ժամանակաշրջանի սկիզբ',
  'Period to': 'Ժամանակաշրջան՝ մինչև',
  'Period totals': 'Ժամանակաշրջանի ընդհանուր գումարներ',
  Periods: 'Ժամանակաշրջաններ',
  Permission: 'Թույլտվություն',
  'Permission granted.': 'Թույլտվությունը տրամադրվեց։',
  'Permission grants': 'Թույլտվությունների տրամադրումներ',
  Person: 'Անձ',
  'Personal finances could not be loaded': 'Անձնական ֆինանսները չհաջողվեց բեռնել',
  'Personal statement': 'Անձնական քաղվածք',
  'Pinned summary': 'Ամրացված ամփոփում',
  Planned: 'Պլանավորված',
  'Planned agenda time': 'Օրակարգի պլանավորված ժամանակ',
  'Planned in': 'Պլանավորված է',
  Plurality: 'Հարաբերական մեծամասնություն',
  'Points to settle before recording': 'Գրանցելուց առաջ լուծելի կետեր',
  'Policies could not be loaded': 'Քաղաքականությունները չհաջողվեց բեռնել',
  Policy: 'Քաղաքականություն',
  'Policy used by each topic category':
    'Յուրաքանչյուր թեմայի կատեգորիայի կիրառվող քաղաքականությունը',
  Pool: 'Ֆոնդ',
  'Pool exceeds distributable': 'Ֆոնդը գերազանցում է բաշխելին',
  'Pool to try': 'Փորձարկվող ֆոնդ',
  'Pool too small': 'Ֆոնդը չափազանց փոքր է',
  Post: 'POST',
  'Prerequisite tasks': 'Նախապայման առաջադրանքներ',
  Preview: 'Նախադիտում',
  'Preview — not owed yet': 'Նախադիտում — դեռ վճարման ենթակա չէ',
  'Previous commitments': 'Նախորդ պարտավորվածություններ',
  'Previous month': 'Նախորդ ամիս',
  Priority: 'Առաջնահերթություն',
  Product: 'Արտադրանք',
  Profile: 'Պրոֆիլ',
  Progress: 'Առաջընթաց',
  'Progress is the average of measurable key results. It describes the goal, never a person.':
    'Առաջընթացը չափելի հիմնական արդյունքների միջինն է։ Այն նկարագրում է նպատակը, երբեք՝ անձին։',
  'Propose a reserve policy': 'Առաջարկել պահուստի քաղաքականություն',
  'Propose a reserve policy…': 'Առաջարկել պահուստի քաղաքականություն…',
  'Propose a set…': 'Առաջարկել հավաքածու…',
  'Propose an option': 'Առաջարկել տարբերակ',
  'Propose at least two options in “Options and proposals” before starting a multiple-choice vote.':
    'Բազմընտրական քվեարկություն սկսելուց առաջ առաջարկեք առնվազն երկու տարբերակ «Տարբերակներ և առաջարկներ» բաժնում։',
  'Propose comparable multiples': 'Առաջարկել համեմատելի մուլտիպլիկատորներ',
  'Propose new version': 'Առաջարկել նոր տարբերակ',
  Proposed: 'Առաջարկված',
  'Proposed pool': 'Առաջարկվող ֆոնդ',
  Pros: 'Դրական կողմեր',
  'Protect your account with an authenticator app (for example 1Password, Google Authenticator or Microsoft Authenticator).':
    'Պաշտպանեք ձեր հաշիվը նույնականացման հավելվածով (օրինակ՝ 1Password, Google Authenticator կամ Microsoft Authenticator)։',
  Publish: 'Հրապարակել',
  'Publish to start the discussion, or save a private draft that only you can see.':
    'Հրապարակեք՝ քննարկումը սկսելու համար, կամ պահեք անձնական սևագիր, որը միայն դուք կտեսնեք։',
  'Publish topic': 'Հրապարակել թեման',
  'Publisher or database.': 'Հրատարակիչ կամ տվյալների բազա։',
  Purpose: 'Նպատակ',
  Push: 'Push ծանուցում',
  Put: 'PUT',
  Quality: 'Որակ',
  Quarterly: 'Եռամսյակային',
  'Questions that need a founder decision.': 'Հարցեր, որոնք պահանջում են հիմնադիրների որոշում։',
  Queue: 'Հերթ',
  Queued: 'Հերթագրված',
  'Quiet hours': 'Լուռ ժամեր',
  Quorum: 'Քվորում',
  'Quorum fraction': 'Քվորումի բաժին',
  'Quorum not reached': 'Քվորումը չի ապահովվել',
  Rate: 'Փոխարժեք',
  'Rate date': 'Փոխարժեքի ամսաթիվ',
  'Rate limited': 'Հարցումների սահմանաչափը գերազանցված է',
  Ratio: 'Հարաբերակցություն',
  Rationale: 'Հիմնավորում',
  'Re-opening requires a reason': 'Վերաբացելու համար անհրաժեշտ է պատճառ',
  Reactions: 'Արձագանքներ',
  Read: 'Կարդացված',
  'Reading the books…': 'Կարդում ենք հաշվապահական գրանցումները…',
  'Reading the question and searching…': 'Կարդում ենք հարցը և որոնում…',
  Reason: 'Պատճառ',
  'Reason for the change': 'Փոփոխության պատճառ',
  'Reason for the correction': 'Ուղղման պատճառ',
  'Reason for the role change': 'Դերի փոփոխության պատճառ',
  'Reassign tasks': 'Վերաբաշխել առաջադրանքները',
  'Reauthentication required': 'Պահանջվում է կրկնակի նույնականացում',
  'Recalculate with changes…': 'Վերահաշվարկել փոփոխություններով…',
  Recalculations: 'Վերահաշվարկներ',
  'Received into': 'Ստացված է՝ հաշվին',
  Recent: 'Վերջին',
  Reconciled: 'Համադրված',
  Reconciliation: 'Համաձայնեցում',
  Record: 'Գրանցել',
  'Record a decision': 'Գրանցել որոշում',
  'Record a founder advance…': 'Գրանցել հիմնադրի կանխավճար…',
  'Record a manual adjustment': 'Գրանցել ձեռքով ճշգրտում',
  'Record an adjustment…': 'Գրանցել ճշգրտում…',
  'Record an exchange rate': 'Գրանցել փոխարժեք',
  'Record bank balance': 'Գրանցել բանկային մնացորդ',
  'Record correction': 'Գրանցել ուղղում',
  'Record date': 'Գրանցման ամսաթիվ',
  'Record finance entries': 'Գրանցել ֆինանսական գրառումներ',
  'Record income or expense': 'Գրանցել եկամուտ կամ ծախս',
  'Record outcome…': 'Գրանցել արդյունք…',
  'Record payment…': 'Գրանցել վճարում…',
  'Record settlement…': 'Գրանցել մարում…',
  'Record the correction?': 'Գրանցե՞լ ուղղումը',
  'Record this entry?': 'Գրանցե՞լ այս գրառումը',
  'Record…': 'Գրանցել…',
  Recorded: 'Գրանցված',
  'Recorded as owed to the founder until it is classified as reimbursement, contribution or loan.':
    'Գրանցվում է որպես հիմնադրին պարտք, մինչև դասակարգվի որպես փոխհատուցում, ներդրում կամ վարկ։',
  'Recorded by': 'Գրանցող',
  'Recorded entries': 'Գրանցված գրառումներ',
  'Recorded exchange rates': 'Գրանցված փոխարժեքներ',
  'Recorded in the audit log and shown to every founder.':
    'Գրանցվում է աուդիտի մատյանում և ցուցադրվում բոլոր հիմնադիրներին։',
  'Recorded in the audit log and shown to voters.':
    'Գրանցվում է աուդիտի մատյանում և ցուցադրվում քվեարկողներին։',
  'Recorded in the audit log.': 'Գրանցվում է աուդիտի մատյանում։',
  'Recorded with both decisions.': 'Գրանցվում է երկու որոշումների հետ։',
  'Recorded with the version and in the audit log.':
    'Գրանցվում է տարբերակի հետ և աուդիտի մատյանում։',
  'Records something the founders agreed or need to know.':
    'Գրանցում է այն, ինչի շուրջ հիմնադիրները համաձայնել են կամ պետք է իմանան։',
  'Recovery codes': 'Վերականգնման կոդեր',
  Recurrence: 'Կրկնություն',
  Ref: 'Հղում',
  'Refine with filters': 'Ճշգրտել ֆիլտրերով',
  'Reimbursable expense': 'Փոխհատուցվող ծախս',
  Reject: 'Մերժել',
  'Reject…': 'Մերժել…',
  Rejected: 'Մերժված',
  'Related decision': 'Կապված որոշում',
  'Related topic': 'Կապված թեմա',
  'Related topic (optional)': 'Կապված թեմա (ըստ ցանկության)',
  Release: 'Ազատել',
  'Release this cash?': 'Ազատե՞լ այս դրամական միջոցները',
  'Release…': 'Ազատել…',
  Released: 'Ազատված',
  'Reminder before the due time (hours)': 'Հիշեցում ժամկետից առաջ (ժամ)',
  Remove: 'Հեռացնել',
  'Remove dependency': 'Հեռացնել կախվածությունը',
  'Remove from agenda': 'Հեռացնել օրակարգից',
  'Remove key result': 'Հեռացնել հիմնական արդյունքը',
  'Remove this dependency?': 'Հեռացնե՞լ այս կախվածությունը',
  'Remove this key result?': 'Հեռացնե՞լ այս հիմնական արդյունքը',
  'Remove…': 'Հեռացնել…',
  'Renaming changes the label in all reports, including past months. Archiving keeps existing entries but hides the category for new ones.':
    'Վերանվանումը փոխում է անվանումը բոլոր հաշվետվություններում, ներառյալ անցյալ ամիսները։ Արխիվացումը պահպանում է առկա գրառումները, բայց թաքցնում է կատեգորիան նոր գրառումների համար։',
  Reopen: 'Վերաբացել',
  'Reopen task': 'Վերաբացել առաջադրանքը',
  'Reopen this movement?': 'Վերաբացե՞լ այս շարժը',
  'Reopen…': 'Վերաբացել…',
  'Repay by': 'Մարել մինչև',
  Replaces: 'Փոխարինում է',
  Reply: 'Պատասխանել',
  Report: 'Հաշվետվություն',
  'Report a blocker': 'Հայտնել արգելափակման մասին',
  'Report as inaccurate': 'Նշել որպես անճշգրիտ',
  'Report state per founder and period, alphabetical':
    'Հաշվետվության կարգավիճակն ըստ հիմնադրի և ժամանակաշրջանի, այբբենական կարգով',
  'Report this AI output as inaccurate?': 'Նշե՞լ AI-ի այս արդյունքը որպես անճշգրիտ',
  'Reported by me / blocking me': 'Իմ կողմից հաղորդված / ինձ արգելափակող',
  'Reported inaccurate': 'Նշված է որպես ոչ ճշգրիտ',
  Reporters: 'Հաշվետուներ',
  'Reporting currency': 'Հաշվետվության արժույթ',
  'Reporting period': 'Հաշվետու ժամանակահատված',
  'Reporting periods': 'Հաշվետու ժամանակաշրջաններ',
  'Reporting periods, newest first': 'Հաշվետու ժամանակաշրջաններ՝ սկսած ամենանորից',
  'Reporting rules': 'Հաշվետվության կանոններ',
  'Reporting rules, categories and data sources for company finance. None of these settings rewrites recorded entries: reports are recalculated from the original amounts and the historical exchange rates.':
    'Ընկերության ֆինանսների հաշվետվության կանոններ, կատեգորիաներ և տվյալների աղբյուրներ։ Այս կարգավորումներից ոչ մեկը չի վերագրում գրանցված գրառումները. հաշվետվությունները վերահաշվարկվում են սկզբնական գումարներից և պատմական փոխարժեքներից։',
  'Reporting schedule saved.': 'Հաշվետվության ժամանակացույցը պահպանվեց։',
  'Reporting window': 'Հաշվետվության ժամկետ',
  'Reports and dashboards are recalculated with the new rules. Recorded entries and rates do not change. The change is audited.':
    'Հաշվետվություններն ու վահանակները վերահաշվարկվում են նոր կանոններով։ Գրանցված գրառումներն ու փոխարժեքները չեն փոխվում։ Փոփոխությունը գրանցվում է աուդիտի մատյանում։',
  Request: 'Հարցում',
  'Request a new link': 'Պահանջել նոր հղում',
  'request a new one': 'պահանջեք նորը',
  'Request agenda time': 'Պահանջել ժամանակ օրակարգում',
  Requested: 'Պահանջված',
  'Requested by': 'Պահանջող',
  'Requested time': 'Պահանջված ժամանակ',
  Required: 'Պարտադիր',
  'Required — input expected': 'Պարտադիր — սպասվում է մասնակցություն',
  'Required participants are asked for input. Access only lets a member read a restricted topic.':
    'Պարտադիր մասնակիցներից կարծիք է պահանջվում։ Մուտքի իրավունքը միայն թույլ է տալիս անդամին կարդալ սահմանափակ թեման։',
  'Required sections': 'Պարտադիր բաժիններ',
  Resend: 'Կրկին ուղարկել',
  'Resend failed': 'Կրկին ուղարկելը ձախողվեց',
  Reserve: 'Պահուստ',
  'Reserve and distributions could not be loaded': 'Չհաջողվեց բեռնել պահուստը և բաշխումները',
  'Reserve policies could not be loaded': 'Չհաջողվեց բեռնել պահուստի քաղաքականությունները',
  'Reserve policy and cash set aside': 'Պահուստի քաղաքականություն և առանձնացված դրամական միջոցներ',
  'Reserve policy in force': 'Գործող պահուստի քաղաքականություն',
  'Reserve policy versions': 'Պահուստի քաղաքականության տարբերակներ',
  'Reserve required': 'Պահանջվող պահուստ',
  'Reserve rule': 'Պահուստի կանոն',
  'reset password': 'վերականգնել գաղտնաբառը',
  'Reset your password': 'Վերականգնեք ձեր գաղտնաբառը',
  Resolution: 'Լուծում',
  Resolve: 'Լուծել',
  'Resolve blocker': 'Լուծել արգելափակումը',
  'Resolve dispute': 'Լուծել վեճը',
  'Resolve dispute…': 'Լուծել վեճը…',
  'Resolve this blocker?': 'Լուծե՞լ այս արգելափակումը',
  Resolved: 'Լուծված',
  'Response due': 'Պատասխանի ժամկետ',
  'Response expected within (hours)': 'Պատասխանն ակնկալվում է (ժամերի ընթացքում)',
  'Response overdue': 'Պատասխանի ժամկետն անցել է',
  Responsibilities: 'Պատասխանատվություններ',
  Responsibility: 'Պատասխանատվություն',
  'Responsibility period': 'Պատասխանատվության ժամանակահատված',
  'Responsibility periods': 'Պատասխանատվության ժամանակաշրջաններ',
  Restricted: 'Սահմանափակ',
  'Restricted agenda': 'Սահմանափակ օրակարգ',
  'Restricted topics are visible only to the listed participants.':
    'Սահմանափակ թեմաները տեսանելի են միայն նշված մասնակիցներին։',
  'Restrictions could not be loaded': 'Չհաջողվեց բեռնել սահմանափակումները',
  Result: 'Արդյունք',
  'Result (revenue − expenses)': 'Արդյունք (եկամուտ − ծախսեր)',
  Results: 'Արդյունքներ',
  'Results are hidden until the round closes. The tally will be shown once voting has closed.':
    'Արդյունքները թաքցված են մինչև փուլի փակումը։ Հաշվարկը կցուցադրվի քվեարկության ավարտից հետո։',
  Retired: 'Հանված շրջանառությունից',
  'Retired responsibilities stay in history but are no longer tracked.':
    'Դադարեցված պատասխանատվությունները մնում են պատմության մեջ, բայց այլևս չեն հետևվում։',
  Revenue: 'Եկամուտ',
  'Revenue and growth': 'Հասույթ և աճ',
  'Revenue growth scenarios': 'Եկամտի աճի սցենարներ',
  'Revenue multiple': 'Եկամտի բազմապատիկ',
  'Revenue, expenses and cash this month': 'Այս ամսվա եկամուտը, ծախսերը և դրամական միջոցները',
  Reversal: 'Հակադարձում',
  'Reverse adjustment': 'Հակադարձել ճշգրտումը',
  'Reverse adjustment…': 'Հակադարձել ճշգրտումը…',
  'Reverse payment': 'Հակադարձել վճարումը',
  'Reverse payment…': 'Հակադարձել վճարումը…',
  'Reverse settlement': 'Հակադարձել մարումը',
  'Reverse settlement…': 'Հակադարձել մարումը…',
  'Reverse this adjustment?': 'Հակադարձե՞լ այս ճշգրտումը',
  'Reverse this payment?': 'Հակադարձե՞լ այս վճարումը',
  'Reverse this settlement?': 'Հակադարձե՞լ այս մարումը',
  'Reverse…': 'Հակադարձել…',
  Reversed: 'Հակադարձված',
  'Reversed later': 'Հետագայում հակադարձված',
  Reverses: 'Հակադարձում է',
  'Review and grant': 'Դիտարկել և տրամադրել',
  'Review and save…': 'Դիտարկել և պահել…',
  'Review drafts': 'Դիտարկել սևագրերը',
  'Review in the decision form': 'Դիտարկել որոշման ձևում',
  'Review mapping change': 'Դիտարկել համապատասխանեցման փոփոխությունը',
  'Review queue (needs review and possible duplicates)':
    'Դիտարկման հերթ (պահանջում են դիտարկում և հնարավոր կրկնօրինակներ)',
  'Review…': 'Դիտարկել…',
  'Revision history': 'Խմբագրումների պատմություն',
  Revisions: 'Խմբագրումներ',
  Revoke: 'Չեղյալ համարել',
  'Revoke invitation': 'Չեղյալ համարել հրավերը',
  'Revoke invitation?': 'Չեղյա՞լ համարել հրավերը',
  'Revoke permission': 'Հետ կանչել թույլտվությունը',
  'Revoke permission?': 'Հետ կանչե՞լ թույլտվությունը',
  Revoked: 'Չեղյալ համարված',
  Risks: 'Ռիսկեր',
  Role: 'Դեր',
  'Role changes need recent identity confirmation and are audited.':
    'Դերի փոփոխությունները պահանջում են ինքնության վերջերս հաստատում և գրանցվում են աուդիտի մատյանում։',
  'Round awaiting finalization': 'Փուլը սպասում է վերջնականացման',
  'Rounded share': 'Կլորացված բաժին',
  Rounding: 'Կլորացում',
  'Rounding added': 'Ավելացված կլորացում',
  Ru: 'Ռուսերեն',
  'Rule for this vote': 'Այս քվեարկության կանոնը',
  Rules: 'Կանոններ',
  Running: 'Ընթացքում է',
  Runway: 'Ֆինանսական պաշարի ժամկետ',
  Sales: 'Վաճառք',
  'Same as the goal': 'Նույնը, ինչ նպատակը',
  'Save draft': 'Պահել սևագիրը',
  'Save mapping': 'Պահել համապատասխանեցումը',
  'Save reporting rules…': 'Պահել հաշվետվության կանոնները…',
  'Save reporting schedule…': 'Պահել հաշվետվության ժամանակացույցը…',
  'Save rules': 'Պահել կանոնները',
  'Save schedule': 'Պահել ժամանակացույցը',
  'Save settings': 'Պահել կարգավորումները',
  'Save status': 'Պահել կարգավիճակը',
  'Save task and blocker reminders?': 'Պահե՞լ առաջադրանքների և արգելափակումների հիշեցումները',
  'Save task settings…': 'Պահել առաջադրանքների կարգավորումները…',
  'Save this valuation snapshot?': 'Պահե՞լ գնահատման այս պատկերը',
  'Save your changes before finalizing.': 'Պահեք ձեր փոփոխությունները՝ նախքան վերջնականացնելը։',
  'Saved by the workspace': 'Պահպանված է աշխատատիրույթի կողմից',
  Scenario: 'Սցենար',
  'Scenario assumptions': 'Սցենարի ենթադրություններ',
  'Scenario calculator': 'Սցենարների հաշվիչ',
  'Scenario inputs': 'Սցենարի մուտքային տվյալներ',
  'Scenario result': 'Սցենարի արդյունք',
  Scheduled: 'Պլանավորված',
  Search: 'Որոնել',
  'Search failed': 'Որոնումը ձախողվեց',
  'Search results': 'Որոնման արդյունքներ',
  Security: 'Անվտանգություն',
  'See the whole team for this period': 'Տեսնել ամբողջ թիմը այս ժամանակաշրջանի համար',
  'Selected option': 'Ընտրված տարբերակ',
  'Semantic search': 'Իմաստային որոնում',
  Sensitivity: 'Զգայունություն',
  'Sent invitations': 'Ուղարկված հրավերներ',
  'Service account': 'Ծառայողական հաշիվ',
  'Service unavailable': 'Ծառայությունը հասանելի չէ',
  'Set a due date or check “No deadline”.': 'Սահմանեք ժամկետ կամ նշեք «Առանց ժամկետի»։',
  'Set aside cash': 'Առանձնացնել դրամական միջոցներ',
  'Set aside cash…': 'Առանձնացնել դրամական միջոցներ…',
  'Set aside today': 'Առանձնացված այսօր',
  'Set it up now': 'Կարգավորել հիմա',
  'set them in Admin → Finance': 'սահմանեք դրանք՝ Ադմինիստրացիա → Ֆինանսներ բաժնում',
  'Settings could not be loaded': 'Չհաջողվեց բեռնել կարգավորումները',
  Settled: 'Մարված',
  'Settled on': 'Մարման ամսաթիվ',
  Settlement: 'Մարում',
  Settlements: 'Մարումներ',
  'Setup key': 'Կարգավորման բանալի',
  Share: 'Բաժին',
  'Share covered by another founder': 'Այլ հիմնադրի կողմից ծածկված բաժին',
  'Share of': 'Բաժինը՝',
  'Share of operating cash': 'Գործառնական դրամական միջոցների բաժին',
  Shares: 'Բաժիններ',
  'Shares this payment was applied to': 'Բաժիններ, որոնց նկատմամբ կիրառվել է այս վճարումը',
  'Short history': 'Կարճ պատմություն',
  'Short stable identifier, e.g. EXP-HOSTING. Cannot be changed later.':
    'Կարճ կայուն նույնացուցիչ, օրինակ՝ EXP-HOSTING։ Հետագայում հնարավոր չէ փոխել։',
  Show: 'Ցուցադրել',
  'Show cap table as of': 'Ցուցադրել բաժնեմասը՝ առ',
  'Show rates for currency': 'Ցուցադրել փոխարժեքները արժույթի համար',
  'Show rules': 'Ցուցադրել կանոնները',
  'Showing the most recent items only. Narrow the dates to see everything.':
    'Ցուցադրվում են միայն վերջին տարրերը։ Նեղացրեք ամսաթվերը՝ ամբողջը տեսնելու համար։',
  'Shown at the top of the topic. Leave empty to remove it.':
    'Ցուցադրվում է թեմայի վերևում։ Թողեք դատարկ՝ հեռացնելու համար։',
  'sign in': 'մուտք գործել',
  'Sign in': 'Մուտք գործել',
  'Sign in to accept': 'Մուտք գործեք՝ ընդունելու համար',
  'Sign in with a password': 'Մուտք գործել գաղտնաբառով',
  'Sign in with an email link': 'Մուտք գործել էլ. փոստի հղումով',
  'Sign out all other sessions': 'Դուրս գալ մյուս բոլոր սեսիաներից',
  'Sign out all other sessions?': 'Դուրս գա՞լ մյուս բոլոր սեսիաներից',
  'Sign out others': 'Դուրս հանել մյուսներին',
  'Sign out session': 'Ավարտել սեսիան',
  'Sign out this session?': 'Ավարտե՞լ այս սեսիան',
  'Signed in with': 'Մուտք է գործել՝',
  'Signed-in devices': 'Մուտք գործած սարքեր',
  'Signing you in…': 'Մուտք գործում ենք…',
  'Similar topics already exist. Check them before creating a duplicate:':
    'Նմանատիպ թեմաներ արդեն կան։ Ստուգեք դրանք՝ նախքան կրկնօրինակ ստեղծելը․',
  'Simple approval': 'Պարզ հաստատում',
  'Simple approval (vote)': 'Պարզ հաստատում (քվե)',
  Since: 'Սկսած',
  Snapshot: 'Պատկեր',
  'Snapshots could not be loaded': 'Չհաջողվեց բեռնել պատկերները',
  'Some fields need attention — see the messages above.':
    'Որոշ դաշտեր ուշադրություն են պահանջում — տե՛ս վերևի հաղորդագրությունները։',
  'Something is escalated to me': 'Ինչ-որ բան փոխանցվել է ինձ',
  Soon: 'Շուտով',
  Source: 'Աղբյուր',
  'Source name': 'Աղբյուրի անվանում',
  'Source reference': 'Աղբյուրի հղում',
  'Source topic': 'Աղբյուր թեմա',
  Sources: 'Աղբյուրներ',
  'Sources truncated': 'Աղբյուրները կրճատված են',
  'Sources:': 'Աղբյուրներ՝',
  'Specific shares — including covering another founder':
    'Որոշակի բաժիններ — ներառյալ մեկ այլ հիմնադրի մասի ծածկումը',
  Sso: 'SSO',
  Stale: 'Հնացած',
  'Stale bank balance': 'Հնացած բանկային մնացորդ',
  'Stale comparables': 'Հնացած համեմատելի տվյալներ',
  'Stale input': 'Հնացած մուտքային տվյալ',
  'Start → target': 'Սկիզբ → թիրախ',
  'Start a vote': 'Սկսել քվեարկություն',
  'Start as': 'Սկսել որպես',
  'Start in': 'Սկսել',
  'Start meeting': 'Սկսել հանդիպումը',
  'Start meeting…': 'Սկսել հանդիպումը…',
  'Start over': 'Սկսել նորից',
  'Start the meeting?': 'Սկսե՞լ հանդիպումը',
  'Start value': 'Սկզբնական արժեք',
  Started: 'Սկսված',
  Starts: 'Սկսվում է',
  'Starts on': 'Սկսվում է՝',
  State: 'Վիճակ',
  'State the decision (3–10000 characters).': 'Ձևակերպեք որոշումը (3–10000 նիշ)։',
  Statement: 'Քաղվածք',
  'Statement file': 'Քաղվածքի ֆայլ',
  'Statement link': 'Քաղվածքի հղում',
  'Statement title': 'Քաղվածքի վերնագիր',
  Status: 'Կարգավիճակ',
  'Status changed': 'Կարգավիճակը փոխվել է',
  'Status changes appear on the goal timeline.':
    'Կարգավիճակի փոփոխությունները ցուցադրվում են նպատակի ժամանակագրությունում։',
  'Status changes are audited. Departing does not erase equity history, debts or obligations.':
    'Կարգավիճակի փոփոխությունները գրանցվում են աուդիտի մատյանում։ Հեռանալը չի ջնջում բաժնեմասի պատմությունը, պարտքերը կամ պարտավորությունները։',
  'Status history': 'Կարգավիճակի պատմություն',
  'Status:': 'Կարգավիճակ՝',
  Step: 'Քայլ',
  'Still open': 'Դեռ բաց է',
  'Still to pay': 'Դեռ վճարելի',
  Submitted: 'Ներկայացված',
  Succeeded: 'Հաջողված',
  'Suggested action items': 'Առաջարկվող գործողություններ',
  'Suggestion adjusted': 'Առաջարկը ճշգրտված է',
  'Sum of': 'Գումարը',
  'Supersede…': 'Փոխարինել…',
  Superseded: 'Փոխարինված',
  Supersession: 'Փոխարինում',
  'Supporting goals': 'Աջակցող նպատակներ',
  'Suspected duplicate': 'Հավանական կրկնօրինակ',
  'Suspected duplicates': 'Հավանական կրկնօրինակներ',
  Suspended: 'Կասեցված',
  System: 'Համակարգ',
  'Take this item off the agenda?': 'Հանե՞լ այս կետը օրակարգից',
  'Taken by the accountable owner within their mandate.':
    'Ընդունվում է պատասխանատու սեփականատիրոջ կողմից՝ իր լիազորությունների շրջանակում։',
  'Taken from the account.': 'Վերցված է հաշվից։',
  'Target value': 'Թիրախային արժեք',
  Task: 'Առաջադրանք',
  'Task and blocker settings saved.':
    'Առաջադրանքների և արգելափակումների կարգավորումները պահպանվեցին։',
  'Task assigned': 'Առաջադրանքը նշանակված է',
  'Task completed': 'Առաջադրանքն ավարտված է',
  'Task counts per owner, alphabetical (not a ranking)':
    'Առաջադրանքների քանակը ըստ պատասխանատուի՝ այբբենական կարգով (ոչ դասակարգում)',
  'Task due soon': 'Առաջադրանքի ժամկետը մոտենում է',
  'Task overdue': 'Առաջադրանքը ժամկետանց է',
  Tasks: 'Առաջադրանքներ',
  'Tasks and blockers': 'Առաջադրանքներ և արգելափակումներ',
  'Tasks completed': 'Ավարտված առաջադրանքներ',
  Tax: 'Հարկ',
  'Tax treatment': 'Հարկային մոտեցում',
  Taxes: 'Հարկեր',
  Team: 'Թիմ',
  'Team updates': 'Թիմի թարմացումներ',
  'The amount moves out of the suspense account in the journal. To change the treatment later, reverse the classification and classify again.':
    'Գումարը մատյանում դուրս է բերվում անորոշ գումարների հաշվից։ Մոտեցումը հետագայում փոխելու համար հակադարձեք դասակարգումը և դասակարգեք նորից։',
  'The amounts must add up to the total. Leave a founder blank to exclude them.':
    'Գումարների հանրագումարը պետք է հավասար լինի ընդհանուրին։ Թողեք հիմնադրի դաշտը դատարկ՝ նրան բացառելու համար։',
  'The assistant could not be loaded': 'Չհաջողվեց բեռնել օգնականը',
  'The blocked task returns to its previous status once no blocker is open.':
    'Արգելափակված առաջադրանքը վերադառնում է իր նախորդ կարգավիճակին, երբ բաց արգելափակումներ չեն մնում։',
  'The book balance already on the account when you start tracking it. It is posted as an opening entry and needs a statement as evidence.':
    'Հաշվի հաշվապահական մնացորդը այն պահին, երբ սկսում եք հետևել դրան։ Այն գրանցվում է որպես բացման գրառում և պահանջում է քաղվածք՝ որպես ապացույց։',
  'The cap table or the founders changed since these shares were calculated. Edit the draft and save it again to recalculate before approving.':
    'Այս բաժինների հաշվարկից հետո բաժնեմասը կամ հիմնադիրները փոխվել են։ Խմբագրեք սևագիրը և պահեք այն նորից՝ հաստատելուց առաջ վերահաշվարկելու համար։',
  'The comment is replaced by “Comment deleted”. Its earlier versions stay in the edit history as evidence.':
    'Մեկնաբանությունը փոխարինվում է «Մեկնաբանությունը ջնջված է» տեքստով։ Դրա նախորդ տարբերակները մնում են խմբագրումների պատմության մեջ՝ որպես ապացույց։',
  'The company owes the founder the amount as a loan until it is repaid.':
    'Ընկերությունը պարտք է հիմնադրին այդ գումարը որպես փոխառություն՝ մինչև այն վերադարձվի։',
  'The company owes the founder the amount until it is repaid.':
    'Ընկերությունը պարտք է հիմնադրին այդ գումարը՝ մինչև այն վերադարձվի։',
  'The date the multiples describe.': 'Ամսաթիվը, որին վերաբերում են բազմապատկիչները։',
  'The debt could not be loaded': 'Չհաջողվեց բեռնել պարտքը',
  'The decision could not be loaded': 'Չհաջողվեց բեռնել որոշումը',
  'The decision is saved as a draft. It becomes part of the immutable register only when it is finalized. Vote-based decisions are drafted automatically when a vote is finalized.':
    'Որոշումը պահպանվում է որպես սևագիր։ Այն դառնում է անփոփոխ ռեեստրի մաս միայն վերջնականացվելուց հետո։ Քվեարկության վրա հիմնված որոշումների սևագրերն ավտոմատ ստեղծվում են, երբ քվեարկությունը վերջնականացվում է։',
  'The discussion continues in another topic. Choose it.':
    'Քննարկումը շարունակվում է այլ թեմայում։ Ընտրեք այն։',
  'The distribution could not be loaded': 'Չհաջողվեց բեռնել բաշխումը',
  'The draft stays in history as discarded and can no longer be approved.':
    'Սևագիրը մնում է պատմության մեջ որպես մերժված և այլևս չի կարող հաստատվել։',
  'The draft stays visible in the history as discarded. It will not become binding.':
    'Սևագիրը մնում է տեսանելի պատմության մեջ որպես մերժված։ Այն պարտադիր ուժ չի ստանա։',
  'The eight most recent proposals. Older ones stay on the distributions page.':
    'Ութ ամենավերջին առաջարկները։ Ավելի հները մնում են բաշխումների էջում։',
  'The end date must not be before the start date.':
    'Ավարտի ամսաթիվը չպետք է լինի մեկնարկի ամսաթվից շուտ։',
  'The entry could not be loaded': 'Չհաջողվեց բեռնել գրառումը',
  'The figures could not be read': 'Չհաջողվեց կարդալ թվերը',
  'The first line must name the columns:': 'Առաջին տողը պետք է պարունակի սյունակների անվանումները՝',
  'The funding call could not be loaded': 'Չհաջողվեց բեռնել ֆինանսավորման կանչը',
  'The goal could not be loaded': 'Չհաջողվեց բեռնել նպատակը',
  'The item goes back to the queue. Explain what it waits for.':
    'Կետը վերադառնում է հերթ։ Բացատրեք՝ ինչի է սպասում։',
  'The link is removed from this record. The detachment is kept in the audit log.':
    'Կապը հեռացվում է այս գրառումից։ Անջատումը պահպանվում է աուդիտի մատյանում։',
  'The meeting could not be loaded': 'Չհաջողվեց բեռնել հանդիպումը',
  'The member who drives the topic to a decision.': 'Անդամը, ով թեման առաջնորդում է դեպի որոշում։',
  'The movements could not be loaded': 'Չհաջողվեց բեռնել շարժերը',
  'The option stays visible as withdrawn and can no longer be put on a ballot.':
    'Տարբերակը մնում է տեսանելի որպես հետ կանչված և այլևս չի կարող ներառվել քվեաթերթիկում։',
  'the original entry': 'սկզբնական գրառումը',
  'The original is voided by a reversal and a corrected entry is recorded in its place, with the existing evidence carried over. Both stay in the history.':
    'Սկզբնականը չեղարկվում է հակադարձմամբ, և դրա փոխարեն գրանցվում է ուղղված գրառում՝ առկա ապացույցների փոխանցմամբ։ Երկուսն էլ մնում են պատմության մեջ։',
  'The output is marked as reported for everyone and cannot be used as a draft. Say what is wrong so the team can check it.':
    'Արդյունքը բոլորի համար նշվում է որպես բողոքարկված և չի կարող օգտագործվել որպես սևագիր։ Նշեք, թե ինչն է սխալ, որպեսզի թիմը կարողանա ստուգել։',
  'The owner role cannot be changed here.': 'Սեփականատիրոջ դերը այստեղ հնարավոր չէ փոխել։',
  'The P&L could not be loaded': 'Չհաջողվեց բեռնել P&L-ը',
  'The page you are looking for does not exist or has moved.':
    'Ձեր փնտրած էջը գոյություն չունի կամ տեղափոխվել է։',
  'The payer’s own share (anything extra becomes a credit owed to the payer)':
    'Վճարողի սեփական բաժինը (ցանկացած ավելցուկ դառնում է վճարողին հասանելիք պահանջ)',
  'The payment could not be loaded': 'Չհաջողվեց բեռնել վճարումը',
  'The payment is posted to the journal and to each founder’s statement. It can only be undone by a reversal, which stays in the history.':
    'Վճարումը գրանցվում է մատյանում և յուրաքանչյուր հիմնադրի քաղվածքում։ Այն կարող է չեղարկվել միայն հակադարձմամբ, որը մնում է պատմության մեջ։',
  'The period must end on or after its start.':
    'Ժամանակահատվածը պետք է ավարտվի մեկնարկի օրը կամ դրանից հետո։',
  'The previous version stays in the edit history.':
    'Նախորդ տարբերակը մնում է խմբագրումների պատմության մեջ։',
  'The proposal does not apply until it is approved with evidence.':
    'Առաջարկը չի կիրառվում, քանի դեռ չի հաստատվել ապացույցով։',
  'The proposal stays in the history with your reason.':
    'Առաջարկը մնում է պատմության մեջ՝ ձեր նշած պատճառով։',
  'The range is the result. Confidence describes how complete the inputs are.':
    'Արդյունքը միջակայքն է։ Վստահությունը ցույց է տալիս, թե որքան ամբողջական են մուտքային տվյալները։',
  'The records behind this changed after it was generated. Regenerate for a current version.':
    'Հիմքում ընկած գրառումները փոխվել են գեներացումից հետո։ Վերագեներացրեք՝ ընթացիկ տարբերակը ստանալու համար։',
  'The reporting cadence and required sections are an open founder decision. Nothing is applied until you save. The values below are only suggestions.':
    'Հաշվետվության պարբերականությունը և պարտադիր բաժինները հիմնադիրների դեռ չկայացված որոշում են։ Ոչինչ չի կիրառվում, քանի դեռ չեք պահել։ Ստորև նշված արժեքները միայն առաջարկներ են։',
  'The reporting currency, burn window and fiscal year are open founder decisions. Until you save, each currency is shown separately, burn uses the last 3 complete months and the fiscal year starts in January.':
    'Հաշվետվության արժույթը, ծախսման պատուհանը և ֆինանսական տարին հիմնադիրների բաց որոշումներ են։ Քանի դեռ չեք պահպանել, յուրաքանչյուր արժույթ ցուցադրվում է առանձին, ծախսումը հաշվարկվում է վերջին 3 ամբողջական ամիսներով, իսկ ֆինանսական տարին սկսվում է հունվարին։',
  'The request was not accepted': 'Հարցումը չընդունվեց',
  'The reserve is the cash the company always keeps. It is configured by the founders — MFOS has no default — and every version stays in the history. Cash set aside for taxes, payroll or contracts is deducted before anything is distributable.':
    'Պահուստն այն դրամական միջոցներն են, որոնք ընկերությունը միշտ պահում է։ Այն կարգավորում են հիմնադիրները — MFOS-ը լռելյայն արժեք չունի —, և յուրաքանչյուր տարբերակ մնում է պատմության մեջ։ Հարկերի, աշխատավարձի կամ պայմանագրերի համար առանձնացված միջոցները հանվում են, նախքան որևէ բան բաշխելի դառնա։',
  'The round ends without a result. Votes already cast stay in the audit history.':
    'Փուլն ավարտվում է առանց արդյունքի։ Արդեն տրված քվեները մնում են աուդիտի պատմության մեջ։',
  'The session was signed out.': 'Սեսիան դուրս է եկել համակարգից։',
  'The set stays in the history with your reason and can never be used in a valuation.':
    'Հավաքածուն մնում է պատմության մեջ՝ ձեր նշած պատճառով, և երբեք չի կարող օգտագործվել գնահատման մեջ։',
  'The settlement is added to both statements. It can only be undone by a reversal, which stays in the history.':
    'Մարումն ավելացվում է երկու քաղվածքներին էլ։ Այն կարող է չեղարկվել միայն հակադարձմամբ, որը մնում է պատմության մեջ։',
  'The system reads the books and founder records as of today, adds the figures you enter with their source, and applies the approved comparable multiples. The result is saved as a snapshot that never changes.':
    'Համակարգը կարդում է հաշվապահական գրքերը և հիմնադիրների գրառումները այսօրվա դրությամբ, ավելացնում է ձեր մուտքագրած թվերը՝ իրենց աղբյուրով, և կիրառում է հաստատված համադրելի բազմապատկիչները։ Արդյունքը պահպանվում է որպես երբեք չփոփոխվող պատկեր։',
  'The task goes back to “In progress”. The earlier completion stays in the history.':
    'Առաջադրանքը վերադառնում է «Ընթացքում» կարգավիճակին։ Նախկին ավարտը մնում է պատմության մեջ։',
  'The task moves to “Blocked” until every blocker is closed.':
    'Առաջադրանքը տեղափոխվում է «Արգելափակված» կարգավիճակ, մինչև բոլոր արգելափակումները փակվեն։',
  'The topic becomes visible to its audience and participants are notified.':
    'Թեման դառնում է տեսանելի իր լսարանի համար, և մասնակիցները ծանուցվում են։',
  'The topic could not be loaded': 'Չհաջողվեց բեռնել թեման',
  'The valuation could not be loaded': 'Չհաջողվեց բեռնել գնահատումը',
  'These rows were filled in from AI suggestions. Check every title, owner and due date — nothing is created until you select “Create”.':
    'Այս տողերը լրացվել են AI-ի առաջարկներից։ Ստուգեք յուրաքանչյուր վերնագիր, պատասխանատու և ժամկետ — ոչինչ չի ստեղծվում, քանի դեռ չեք ընտրել «Ստեղծել»։',
  'They will not be counted as missing for this period. The excuse and its reason are kept in the audit log and cannot be removed.':
    'Այս ժամանակահատվածի համար նրանք չեն հաշվվի որպես բացակայող։ Ազատումը և դրա պատճառը պահպանվում են աուդիտի մատյանում և չեն կարող հեռացվել։',
  Thinking: 'Մտածում է',
  'This comment was deleted.': 'Այս մեկնաբանությունը ջնջվել է։',
  'This device': 'Այս սարքը',
  'This draft was discarded and is not part of the binding register.':
    'Այս սևագիրը մերժվել է և պարտադիր գրանցամատյանի մաս չէ։',
  'This figure is an estimate': 'Այս թիվը գնահատական է',
  'This goal does not exist or was removed.': 'Այս նպատակը գոյություն չունի կամ հեռացվել է։',
  'This invitation link is incomplete or invalid. Open the link from your invitation email again, or ask the person who invited you to resend it.':
    'Հրավերի այս հղումը թերի է կամ անվավեր։ Կրկին բացեք հղումը հրավերի նամակից կամ խնդրեք ձեզ հրավիրողին այն նորից ուղարկել։',
  'This meeting does not exist or you are not allowed to see it.':
    'Այս հանդիպումը գոյություն չունի, կամ դուք այն դիտելու թույլտվություն չունեք։',
  'This month': 'Այս ամիս',
  'This proposal cannot be saved as it stands — see the checks marked “Blocks distribution” below.':
    'Այս առաջարկը ներկայիս տեսքով հնարավոր չէ պահել — տե՛ս ստորև «Արգելափակում է բաշխումը» նշված ստուգումները։',
  'This task cannot be completed until its prerequisites are done.':
    'Այս առաջադրանքը հնարավոր չէ ավարտել, քանի դեռ դրա նախապայմանները կատարված չեն։',
  'This task has no dependencies.': 'Այս առաջադրանքը կախվածություններ չունի։',
  'This topic is a private draft. Only you can see it until it is published.':
    'Այս թեման անձնական սևագիր է։ Մինչև հրապարակումը այն տեսանելի է միայն ձեզ։',
  'This workspace does not exist or you are no longer a member of it.':
    'Այս աշխատատիրույթը գոյություն չունի, կամ դուք այլևս դրա անդամ չեք։',
  'Thumbs down': 'Հավանություն չեմ տալիս',
  'Thumbs up': 'Հավանում եմ',
  Tie: 'Հավասար ձայներ',
  'Tie no decision': 'Հավասար ձայներ, որոշում չկա',
  'Time budget (minutes)': 'Ժամանակի սահմանաչափ (րոպե)',
  'Time needed (minutes)': 'Անհրաժեշտ ժամանակ (րոպե)',
  'Time not set': 'Ժամը նշված չէ',
  Timeline: 'Ժամանակագրություն',
  Title: 'Վերնագիր',
  To: 'Մինչև',
  Topic: 'Թեմա',
  'Topic option': 'Թեմայի տարբերակ',
  'Topic summary': 'Թեմայի ամփոփում',
  Topics: 'Թեմաներ',
  Total: 'Ընդամենը',
  'Total expenses': 'Ընդհանուր ծախսեր',
  'Total needed': 'Ընդհանուր անհրաժեշտ գումար',
  'Total revenue': 'Ընդհանուր եկամուտ',
  Totals: 'Հանրագումարներ',
  'Toward zero': 'Դեպի զրո',
  Transfer: 'Փոխանցում',
  Treatment: 'Մշակում',
  'Try a different reserve rule': 'Փորձել պահուստի այլ կանոն',
  'Turn off': 'Անջատել',
  'Turn off two-step verification': 'Անջատել երկքայլ ստուգումը',
  'Turn off two-step verification?': 'Անջատե՞լ երկքայլ ստուգումը',
  'Two-step': 'Երկքայլ',
  'Two-step verification': 'Երկքայլ ստուգում',
  'Two-step verification is on. Save your recovery codes now.':
    'Երկքայլ ստուգումը միացված է։ Պահեք ձեր վերականգնման կոդերը հիմա։',
  'Two-step verification was turned off.': 'Երկքայլ ստուգումն անջատվեց։',
  Type: 'Տեսակ',
  'Unanimous of eligible': 'Իրավասուների միաձայնություն',
  Unauthenticated: 'Չնույնականացված',
  'Uncited statement': 'Առանց աղբյուրի պնդում',
  'undefined} readOnly hint="Taken from the account." /> ) : (':
    'undefined} readOnly hint="Վերցված է հաշվից։" /> ) : (',
  Under: 'Պակաս',
  Unit: 'Միավոր',
  'Unit economics': 'Միավորի տնտեսագիտություն',
  Unknown: 'Անհայտ',
  Unlink: 'Անջատել կապը',
  Unpaid: 'Չվճարված',
  'Unpaid funding share': 'Չվճարված ֆինանսավորման բաժին',
  'Unpaid funding shares': 'Չվճարված ֆինանսավորման բաժիններ',
  'Unpaid shares of approved funding calls': 'Հաստատված ֆինանսավորման կանչերի չվճարված բաժիններ',
  Unread: 'Չընթերցված',
  Unreconciled: 'Չհամադրված',
  'Unreconciled movements': 'Չհամադրված շարժեր',
  'Unresolved questions': 'Չլուծված հարցեր',
  'Unsupported media type': 'Չաջակցվող ֆայլի տեսակ',
  Until: 'Մինչև',
  'Until classified, the company owes these amounts to the founder in a suspense account. The classification decides whether they are repaid, counted as capital or as a funding share.':
    'Մինչև դասակարգումը ընկերությունը այս գումարները պարտք է հիմնադրին՝ անորոշ գումարների հաշվում։ Դասակարգումը որոշում է՝ դրանք վերադարձվո՞ւմ են, հաշվվո՞ւմ են որպես կապիտալ, թե՞ որպես ֆինանսավորման մասնաբաժին։',
  'Until deadline': 'Մինչև վերջնաժամկետ',
  'Until finalization': 'Մինչև վերջնականացում',
  Upcoming: 'Առաջիկա',
  Update: 'Թարմացնել',
  'Update contact phone': 'Թարմացնել կոնտակտային հեռախոսը',
  'Update progress…': 'Թարմացնել առաջընթացը…',
  'Update states': 'Թարմացնել վիճակները',
  'Update status': 'Թարմացնել կարգավիճակը',
  'Update submitted': 'Թարմացումը ներկայացված է',
  'Update this period': 'Թարմացնել այս ժամանակահատվածը',
  Updates: 'Թարմացումներ',
  'Updates by founder': 'Թարմացումներ ըստ հիմնադրի',
  Urgent: 'Հրատապ',
  'Use 2–32 capital letters, digits or dashes, starting with a letter or digit.':
    'Օգտագործեք 2–32 մեծատառ, թվանշան կամ գծիկ՝ սկսելով տառով կամ թվանշանով։',
  'Use a 24-hour time such as 18:00.': 'Օգտագործեք 24-ժամյա ձևաչափ, օրինակ՝ 18:00։',
  'Use a three-letter ISO currency code such as EUR, or leave it empty.':
    'Օգտագործեք եռատառ ISO արժույթի կոդ, օրինակ՝ EUR, կամ թողեք դատարկ։',
  'Use a valid date.': 'Օգտագործեք վավեր ամսաթիվ։',
  'Use a whole number from 1 to 10, or leave empty.':
    'Օգտագործեք ամբողջ թիվ 1-ից 10 կամ թողեք դատարկ։',
  'Use a whole number of hours between 0 and 720, or leave empty.':
    'Օգտագործեք ժամերի ամբողջ թիվ 0-ից 720 կամ թողեք դատարկ։',
  'Use at most 32 characters.': 'Օգտագործեք առավելագույնը 32 նիշ։',
  'Use the decision ID (UUID) or leave empty.': 'Օգտագործեք որոշման ID-ն (UUID) կամ թողեք դատարկ։',
  'Use this for movements that are not income or expense, such as transfers between own accounts. The reason is kept and the movement can be reopened.':
    'Օգտագործեք սա այն շարժերի համար, որոնք եկամուտ կամ ծախս չեն, օրինակ՝ փոխանցումներ սեփական հաշիվների միջև։ Պատճառը պահպանվում է, և շարժը կարելի է վերաբացել։',
  'Use this when the blocker was reported by mistake or no longer applies. It stays in the history.':
    'Օգտագործեք սա, երբ արգելափակումը նշվել է սխալմամբ կամ այլևս արդիական չէ։ Այն մնում է պատմության մեջ։',
  'Used for year-to-date figures.': 'Օգտագործվում է տարեսկզբից ի վեր ցուցանիշների համար։',
  User: 'Օգտատեր',
  Utc: 'UTC',
  'Validation failed': 'Վավերացումը ձախողվեց',
  'Valuation date': 'Գնահատման ամսաթիվ',
  'Valuation methods': 'Գնահատման մեթոդներ',
  'Valuation snapshots, newest first': 'Գնահատման ակնթարթային պատկերներ՝ նորերը առաջինը',
  'Valuations could not be loaded': 'Չհաջողվեց բեռնել գնահատումները',
  Value: 'Արժեք',
  Version: 'Տարբերակ',
  'Version conflict': 'Տարբերակների հակասություն',
  'Video call': 'Տեսազանգ',
  'Video call link': 'Տեսազանգի հղում',
  'View audit log': 'Դիտել աուդիտի մատյանը',
  'View company finance': 'Դիտել ընկերության ֆինանսները',
  'View the decision recorded from this vote': 'Դիտել այս քվեարկությունից գրանցված որոշումը',
  Visibility: 'Տեսանելիություն',
  'Visible after submission': 'Տեսանելի ներկայացնելուց հետո',
  'void me.refetch()}> Try again': 'void me.refetch()}> Կրկին փորձել',
  Voided: 'Անվավեր ճանաչված',
  Vote: 'Քվեարկել',
  'Vote changes': 'Քվեի փոփոխություններ',
  'Vote pending': 'Քվեն սպասում է',
  'Vote record': 'Քվեարկության արձանագրություն',
  'Vote reminder': 'Քվեի հիշեցում',
  'Vote requested': 'Քվե է պահանջվում',
  'Vote visibility': 'Քվեների տեսանելիություն',
  Voted: 'Քվեարկել է',
  Voter: 'Քվեարկող',
  'Votes cannot be changed once submitted.': 'Ներկայացված քվեները հնարավոր չէ փոխել։',
  Voting: 'Քվեարկություն',
  'Voting could not be loaded': 'Չհաջողվեց բեռնել քվեարկությունը',
  'Voting deadline': 'Քվեարկության վերջնաժամկետ',
  'Voting deadline reminder': 'Քվեարկության ժամկետի հիշեցում',
  'Voting method': 'Քվեարկության եղանակ',
  'Voting policy': 'Քվեարկության կանոնակարգ',
  'Voting rules are versioned. A new version applies only after it is approved with evidence (a finalized decision or an external approval reference). Rounds keep the version they opened under.':
    'Քվեարկության կանոններն ունեն տարբերակներ։ Նոր տարբերակը կիրառվում է միայն ապացույցով հաստատվելուց հետո (վերջնականացված որոշում կամ արտաքին հաստատման հղում)։ Փուլերը պահպանում են այն տարբերակը, որով բացվել են։',
  'Voting weight': 'Քվեի կշիռ',
  Waiting: 'Սպասում է',
  'Waiting for': 'Սպասում է',
  'Waiting for (member)': 'Սպասում է (անդամին)',
  'Waiting for me': 'Սպասում է ինձ',
  'Waiting on me': 'Սպասում է ինձ',
  'Waiting since': 'Սպասում է սկսած',
  'Waits for': 'Սպասում է',
  Warning: 'Զգուշացում',
  Watcher: 'Հետևող',
  'Watcher (notified only)': 'Դիտորդ (միայն ծանուցվում է)',
  Watching: 'Հետևում եմ',
  'We could not load your session': 'Չհաջողվեց բեռնել ձեր սեսիան',
  'We will email you a one-time link that signs you in without a password.':
    'Մենք ձեզ էլ. փոստով կուղարկենք միանգամյա հղում, որը թույլ կտա մուտք գործել առանց գաղտնաբառի։',
  Weekly: 'Շաբաթական',
  'Weekly digest': 'Շաբաթական ամփոփում',
  'Weekly founder updates': 'Հիմնադիրների շաբաթական թարմացումներ',
  'Weekly update': 'Շաբաթական թարմացում',
  'Weekly update due': 'Շաբաթական թարմացման ժամկետ',
  'Weekly update history': 'Շաբաթական թարմացումների պատմություն',
  'Weekly update status': 'Շաբաթական թարմացման կարգավիճակ',
  'Weekly updates': 'Շաբաթական թարմացումներ',
  'Weekly updates are not configured or not visible to you.':
    'Շաբաթական թարմացումները կարգավորված չեն կամ ձեզ տեսանելի չեն։',
  'Weekly updates are not switched on.': 'Շաբաթական թարմացումները միացված չեն։',
  Weight: 'Կշիռ',
  'Weight (1–10)': 'Կշիռ (1–10)',
  'What blocks this distribution today': 'Ինչն է այսօր արգելափակում այս բաշխումը',
  'What changed since the previous month': 'Ինչ է փոխվել նախորդ ամսվա համեմատ',
  'What drives the base value': 'Ինչն է որոշում բազային արժեքը',
  'What exactly was decided.': 'Կոնկրետ ինչ է որոշվել։',
  'What is blocking the work?': 'Ինչն է արգելափակում աշխատանքը',
  'What is stopping you and who you need.': 'Ինչն է ձեզ խանգարում և ում օգնության կարիքն ունեք։',
  'What lowered confidence': 'Ինչն է նվազեցրել վստահությունը',
  'What should be decided or achieved. Required to publish.':
    'Ինչ պետք է որոշվի կամ ձեռք բերվի։ Պարտադիր է հրապարակման համար։',
  'What should be discussed?': 'Ի՞նչ պետք է քննարկվի',
  'What the founder is accountable for, e.g. “Publish the weekly sales report”.':
    'Այն, ինչի համար պատասխանատու է հիմնադիրը, օրինակ՝ «Հրապարակել շաբաթական վաճառքի հաշվետվությունը»։',
  'What the meeting must achieve.': 'Ինչի պետք է հասնի հանդիպումը։',
  'What the money is for': 'Ինչի համար է գումարը',
  'What was delivered or learned.': 'Ինչ է կատարվել կամ սովորվել։',
  'What you commit to for the next period — it is shown next to your next update.':
    'Ինչ եք պարտավորվում անել հաջորդ ժամանակահատվածում — սա կցուցադրվի ձեր հաջորդ թարմացման կողքին։',
  'What you completed this period. Link the tasks that show it.':
    'Ինչ եք ավարտել այս ժամանակահատվածում։ Կապեք այն ցույց տվող առաջադրանքները։',
  'What you said you would do': 'Ինչ էիք խոստացել անել',
  When: 'Երբ',
  'When someone does not vote': 'Երբ որևէ մեկը չի քվեարկում',
  'When the vote produces a decision, a decision draft is created for review.':
    'Երբ քվեարկությունը հանգեցնում է որոշման, ստեղծվում է որոշման սևագիր՝ վերանայման համար։',
  Where: 'Որտեղ',
  'Who is blocked': 'Ով է արգելափակված',
  'Who owes whom': 'Ով ում է պարտք',
  'Who paid': 'Ով է վճարել',
  'Who reported': 'Ով է զեկուցել',
  'Who reported in each period. These are facts (submitted, late, missing, excused), not a ranking.':
    'Ով է զեկուցել յուրաքանչյուր ժամանակահատվածում։ Սրանք փաստեր են (ներկայացված, ուշացած, բացակայող, ազատված), ոչ թե վարկանիշ։',
  Why: 'Ինչու',
  'Why it matters': 'Ինչու է սա կարևոր',
  'Why it needs a meeting': 'Ինչու է անհրաժեշտ հանդիպում',
  'Why recalculate': 'Ինչու վերահաշվարկել',
  'Why the assumptions differ from the defaults':
    'Ինչու են ենթադրությունները տարբերվում լռելյայններից',
  'Why this result': 'Ինչու այս արդյունքը',
  Withdraw: 'Հետ կանչել',
  'Withdraw option': 'Հետ կանչել տարբերակը',
  'Withdraw request…': 'Հետ կանչել հարցումը…',
  'Withdraw…': 'Հետ կանչել…',
  Withdrawn: 'Հետ կանչված',
  Words: 'Բառեր',
  'Work by owner': 'Աշխատանք ըստ պատասխանատուի',
  Workspace: 'Աշխատատիրույթ',
  'Workspace not available': 'Աշխատատիրույթը հասանելի չէ',
  'Workspaces could not be loaded': 'Չհաջողվեց բեռնել աշխատատիրույթները',
  'Write and save the minutes before finalizing.':
    'Գրեք և պահեք արձանագրությունը մինչև վերջնականացումը։',
  'Write my update': 'Գրել իմ թարմացումը',
  'Write off': 'Դուրսգրում',
  'Write-off (by decision)': 'Դուրսգրում (որոշմամբ)',
  'Written by the system': 'Գրված է համակարգի կողմից',
  'Year to date': 'Տարեսկզբից ի վեր',
  'Yearly growth': 'Տարեկան աճ',
  'You are invited': 'Դուք հրավիրված եք',
  'You are not a member of any workspace. Ask a workspace owner to send you an invitation, then open the link from your email.':
    'Դուք որևէ աշխատատիրույթի անդամ չեք։ Խնդրեք աշխատատիրույթի սեփականատիրոջը ձեզ հրավեր ուղարկել, ապա բացեք հղումը ձեր էլ. փոստից։',
  'You are not a participant of this restricted topic.': 'Դուք այս սահմանափակ թեմայի մասնակից չեք։',
  'You are voting': 'Դուք քվեարկում եք',
  'You don’t have access': 'Դուք մուտքի իրավունք չունեք',
  'You have no funding shares, debts or credits.':
    'Դուք չունեք ֆինանսավորման բաժիններ, պարտքեր կամ պահանջներ։',
  'You have no open tasks or active goals to link. Completed work can be linked from its task.':
    'Դուք չունեք կապելու համար բաց առաջադրանքներ կամ ակտիվ նպատակներ։ Ավարտված աշխատանքը կարելի է կապել իր առաջադրանքից։',
  'You may be asked to confirm your identity again before it is recorded.':
    'Մինչև գրանցումը ձեզնից կարող է կրկին պահանջվել հաստատել ձեր ինքնությունը։',
  'Your account has no password or authenticator app. Sign out and sign in again with a magic link, then retry the action within 10 minutes.':
    'Ձեր հաշիվը չունի գաղտնաբառ կամ նույնականացման հավելված։ Դուրս եկեք և կրկին մուտք գործեք կախարդական հղումով, ապա 10 րոպեի ընթացքում կրկին փորձեք գործողությունը։',
  'Your account requires a code from your authenticator app at sign-in.':
    'Մուտք գործելիս ձեր հաշիվը պահանջում է կոդ նույնականացման հավելվածից։',
  'Your account will be protected by your password or email links only. Workspaces that require two-step verification will block sensitive work until you turn it on again.':
    'Ձեր հաշիվը կպաշտպանվի միայն գաղտնաբառով կամ էլ. փոստի հղումներով։ Երկքայլ ստուգում պահանջող աշխատատիրույթները կարգելափակեն զգայուն աշխատանքը, մինչև այն նորից միացնեք։',
  'Your current recovery codes will stop working immediately.':
    'Ձեր ընթացիկ վերականգնման կոդերն անմիջապես կդադարեն գործել։',
  'Your name': 'Ձեր անունը',
  'Your password was updated. Sign in with your new password.':
    'Ձեր գաղտնաբառը թարմացվեց։ Մուտք գործեք նոր գաղտնաբառով։',
  'Your question': 'Ձեր հարցը',
  'Your submitted update': 'Ձեր ներկայացված թարմացումը',
  'Your vote is pending': 'Ձեր քվեն սպասման մեջ է',
  'Your vote:': 'Ձեր քվեն՝',
  'Your role in this workspace does not include this area. Ask a workspace owner if you need access.':
    'Այս աշխատատիրույթում ձեր դերը չի ներառում այս բաժինը։ Եթե մուտք է պետք, դիմեք աշխատատիրույթի սեփականատիրոջը։',
  'None given.': 'Նշված չէ։',
  'The AI assistant is not available.': 'ԱԲ օգնականը հասանելի չէ։',
  Generating: 'Ստեղծվում է',
  'Working…': 'Աշխատում է…',
  Regenerate: 'Վերաստեղծել',
  'Sending…': 'Ուղարկվում է…',
  'Send reset link': 'Ուղարկել վերակայման հղումը',
  'Email me a link': 'Ուղարկել ինձ հղում էլ. փոստով',
  'Verifying…': 'Ստուգվում է…',
  'Verify and sign in': 'Ստուգել և մուտք գործել',
  'Saving…': 'Պահպանվում է…',
  'Set new password': 'Սահմանել նոր գաղտնաբառ',
  'View or amend my update': 'Դիտել կամ փոփոխել իմ թարմացումը',
  'Creating…': 'Ստեղծվում է…',
  'Create action': 'Ստեղծել գործողություն',
  'Not set': 'Սահմանված չէ',
  'Save decision draft': 'Պահպանել որոշման սևագիրը',
  'Recalculating…': 'Վերահաշվարկվում է…',
  'Recalculate with today’s figures': 'Վերահաշվարկել այսօրվա թվերով',
  'Approval needs the current figures: recalculate first.':
    'Հաստատման համար անհրաժեշտ են ընթացիկ թվերը. նախ վերահաշվարկեք։',
  'Approval is blocked by the checks above.': 'Հաստատումն արգելափակված է վերևի ստուգումներով։',
  'The proposal is marked cancelled and kept in the history.':
    'Առաջարկը նշվում է որպես չեղարկված և պահպանվում է պատմության մեջ։',
  'Approving…': 'Հաստատվում է…',
  'Approve and declare': 'Հաստատել և հայտարարել',
  'No cash is set aside today.': 'Այսօր առանձնացված դրամական միջոցներ չկան։',
  'Load older distributions': 'Բեռնել ավելի հին բաշխումները',
  'Declared to me': 'Ինձ հայտարարված',
  'Calculating…': 'Հաշվարկվում է…',
  'Preview the calculation': 'Նախադիտել հաշվարկը',
  'Save proposal': 'Պահպանել առաջարկը',
  'Recording…': 'Գրանցվում է…',
  'Record payment': 'Գրանցել վճարումը',
  'Withdraw this reserve policy proposal?': 'Հետ կանչե՞լ պահուստի քաղաքականության այս առաջարկը',
  'Reject this reserve policy version?': 'Մերժե՞լ պահուստի քաղաքականության այս տարբերակը',
  'Withdraw proposal': 'Հետ կանչել առաջարկը',
  'Reject version': 'Մերժել տարբերակը',
  'Proposal withdrawn.': 'Առաջարկը հետ է կանչվել։',
  'Version rejected.': 'Տարբերակը մերժվել է։',
  'Proposing…': 'Առաջարկվում է…',
  Propose: 'Առաջարկել',
  'Approve policy': 'Հաստատել քաղաքականությունը',
  'Set aside': 'Առանձնացնել',
  Calculate: 'Հաշվարկել',
  'Choose a finalized decision': 'Ընտրեք վերջնականացված որոշում',
  'No decision cited': 'Որոշում նշված չէ',
  'Load older decisions': 'Բեռնել ավելի հին որոշումները',
  'Choose the finalized founder decision that approves this version.':
    'Ընտրեք հիմնադիրների վերջնականացված որոշումը, որը հաստատում է այս տարբերակը։',
  'Create draft': 'Ստեղծել սևագիր',
  'Change the reporting schedule?': 'Փոխե՞լ հաշվետվությունների ժամանակացույցը',
  'Start weekly updates?': 'Սկսե՞լ շաբաթական թարմացումները',
  'Enter a title and an http(s) link.': 'Մուտքագրեք վերնագիր և http(s) հղում։',
  'Record balance': 'Գրանցել մնացորդը',
  'A closed account accepts no new entries and cannot be reopened.':
    'Փակված հաշիվը նոր գրառումներ չի ընդունում և չի կարող վերաբացվել։',
  'Close account': 'Փակել հաշիվը',
  Save: 'Պահպանել',
  'Load more': 'Բեռնել ավելին',
  'Record rate': 'Գրանցել փոխարժեքը',
  'Press “Add evidence link” to attach the link you entered.':
    'Սեղմեք «Ավելացնել ապացույցի հղում»՝ մուտքագրված հղումը կցելու համար։',
  'Adding…': 'Ավելացվում է…',
  'Add category': 'Ավելացնել կատեգորիա',
  'Explain the change (at least a few words).': 'Բացատրեք փոփոխությունը (առնվազն մի քանի բառով)։',
  'Save category': 'Պահպանել կատեգորիան',
  'Save as draft': 'Պահպանել որպես սևագիր',
  'No bank movements match these filters.': 'Այս ֆիլտրերին համապատասխանող բանկային շարժեր չկան։',
  'Confirm this is a duplicate?': 'Հաստատե՞լ, որ սա կրկնօրինակ է',
  'Keep as a separate movement?': 'Պահե՞լ որպես առանձին շարժ',
  'The line is excluded as a duplicate of an earlier movement on the same day with the same amount.':
    'Տողը բացառվում է որպես նույն օրվա և նույն գումարով ավելի վաղ շարժի կրկնօրինակ։',
  'The line goes to the review queue as a genuine movement.':
    'Տողն ուղարկվում է վերանայման հերթ որպես իրական շարժ։',
  'Mark as duplicate': 'Նշել որպես կրկնօրինակ',
  'Marked as duplicate.': 'Նշվել է որպես կրկնօրինակ։',
  'Kept as a separate movement.': 'Պահպանվել է որպես առանձին շարժ։',
  'Bank movement': 'Բանկային շարժ',
  'Matching…': 'Համապատասխանեցվում է…',
  'Match and reconcile': 'Համապատասխանեցնել և համադրել',
  'Customer or payer': 'Հաճախորդ կամ վճարող',
  'Vendor or payee': 'Մատակարար կամ ստացող',
  'Record and reconcile': 'Գրանցել և համադրել',
  'Importing…': 'Ներմուծվում է…',
  Import: 'Ներմուծել',
  Uncategorised: 'Առանց կատեգորիայի',
  'Discard draft…': 'Հրաժարվել սևագրից…',
  'Void…': 'Անվավեր ճանաչել…',
  'Discard this draft?': 'Հրաժարվե՞լ այս սևագրից',
  'Void this entry?': 'Անվավեր ճանաչե՞լ այս գրառումը',
  'The draft is marked void and kept in the history. Nothing was posted yet.':
    'Սևագիրը նշվում է որպես անվավեր և պահպանվում է պատմության մեջ։ Դեռ ոչինչ չի հաշվառվել։',
  'Void entry': 'Անվավեր ճանաչել գրառումը',
  'Draft discarded.': 'Սևագիրը չեղարկվել է։',
  'Entry voided by reversal.': 'Գրառումն անվավեր է ճանաչվել հակադարձմամբ։',
  'Correct entry': 'Ուղղել գրառումը',
  'Correct this entry': 'Ուղղել այս գրառումը',
  'Review correction…': 'Վերանայել ուղղումը…',
  'No categories yet — a finance manager adds them under Admin → Finance.':
    'Կատեգորիաներ դեռ չկան — ֆինանսների կառավարիչը դրանք ավելացնում է Ադմինիստրացիա → Ֆինանսներ բաժնում։',
  'Received on account': 'Ստացվել է հաշվին',
  'Paid from account': 'Վճարվել է հաշվից',
  'No company accounts yet — add one under Finance → Cash & FX.':
    'Ընկերության հաշիվներ դեռ չկան — ավելացրեք Ֆինանսներ → Դրամական միջոցներ և փոխարժեքներ բաժնում։',
  'No entries match these filters.': 'Այս ֆիլտրերին համապատասխանող գրառումներ չկան։',
  'No category yet': 'Կատեգորիա դեռ չկա',
  'No evidence': 'Ապացույց չկա',
  'Save phone': 'Պահպանել հեռախոսը',
  'Create founder profile': 'Ստեղծել հիմնադրի պրոֆիլ',
  'Edit responsibility': 'Խմբագրել պատասխանատվությունը',
  'Choose a different status.': 'Ընտրեք այլ կարգավիճակ։',
  'Record adjustment': 'Գրանցել ճշգրտում',
  'Paid personally (not via a company account)': 'Վճարվել է անձամբ (ոչ ընկերության հաշվով)',
  'On demand': 'Ըստ պահանջի',
  'Settlement recorded — the debt is fully settled.':
    'Մարումը գրանցվել է — պարտքն ամբողջությամբ մարված է։',
  'Record settlement': 'Գրանցել մարումը',
  'I am owed': 'Ինձ պարտք են',
  'Owed to me': 'Ինձ պարտք են',
  'What I owe': 'Իմ պարտքերը',
  'What is owed to me': 'Ինձ հասանելիք պարտքերը',
  'Choose the call': 'Ընտրեք կանչը',
  'Repayable on demand.': 'Վերադարձվում է ըստ պահանջի։',
  Classify: 'Դասակարգել',
  'Load older entries': 'Բեռնել ավելի հին գրառումները',
  'Open dispute': 'Բաց վեճ',
  'Dispute raised.': 'Վեճը բարձրացվել է։',
  'Note added.': 'Նշումն ավելացվել է։',
  'Dispute resolved': 'Վեճը լուծված է',
  'What is wrong and why': 'Ինչն է սխալ և ինչու',
  'Raise dispute': 'Բարձրացնել վեճ',
  'Add note': 'Ավելացնել նշում',
  'Explain how the dispute was resolved.': 'Բացատրեք, թե ինչպես է լուծվել վեճը։',
  'The draft is marked cancelled and kept in the history.':
    'Սևագիրը նշվում է որպես չեղարկված և պահպանվում է պատմության մեջ։',
  'Not approved yet': 'Դեռ հաստատված չէ',
  'Custom amount per founder': 'Անհատական գումար յուրաքանչյուր հիմնադրի համար',
  'By ownership on the record date': 'Ըստ սեփականության՝ գրանցման ամսաթվի դրությամբ',
  'Approve call': 'Հաստատել կանչը',
  'Funding call closed.': 'Ֆինանսավորման կանչը փակվել է։',
  'Closing…': 'Փակվում է…',
  'Close call': 'Փակել կանչը',
  'Save draft and preview shares': 'Պահպանել սևագիրը և նախադիտել բաժինները',
  'Record a founder advance to the company': 'Գրանցել հիմնադրի կանխավճարն ընկերությանը',
  'Money a founder lent to the company outside a funding call. The company owes it back to the founder until it is repaid.':
    'Գումար, որը հիմնադիրը փոխառել է ընկերությանը ֆինանսավորման կանչից դուրս։ Ընկերությունը պարտք է այն հիմնադրին, մինչև այն վերադարձվի։',
  'Restore from archive…': 'Վերականգնել արխիվից…',
  'Archive…': 'Արխիվացնել…',
  'Restore this goal?': 'Վերականգնե՞լ այս նպատակը',
  'Archive this goal?': 'Արխիվացնե՞լ այս նպատակը',
  'The goal appears in lists again.': 'Նպատակը կրկին կհայտնվի ցանկերում։',
  'Archived goals are hidden from lists but keep their links and history.':
    'Արխիվացված նպատակները թաքցվում են ցանկերից, բայց պահպանում են իրենց կապերն ու պատմությունը։',
  'Restore goal': 'Վերականգնել նպատակը',
  'Archive goal': 'Արխիվացնել նպատակը',
  'Required when a goal is missed or cancelled.':
    'Պարտադիր է, երբ նպատակը չի իրականացվել կամ չեղարկվել է։',
  'Save goal': 'Պահպանել նպատակը',
  'Add key result': 'Ավելացնել հիմնական արդյունք',
  'Save key result': 'Պահպանել հիմնական արդյունքը',
  'Linking…': 'Կապվում է…',
  'Link to this goal': 'Կապել այս նպատակին',
  'Create goal': 'Ստեղծել նպատակ',
  Attachment: 'Կցորդ',
  'Attaching…': 'Կցվում է…',
  'Attach link': 'Կցել հղում',
  'Linked decision': 'Կապված որոշում',
  'Withdraw version': 'Հետ կանչել տարբերակը',
  'Submitting…': 'Ուղարկվում է…',
  'Propose version': 'Առաջարկել տարբերակ',
  'Send invitation': 'Ուղարկել հրավեր',
  'Joining…': 'Միանում է…',
  'Signing out…': 'Դուրս է գալիս…',
  'Sign out': 'Դուրս գալ',
  'Creating account…': 'Հաշիվը ստեղծվում է…',
  'Create account and join': 'Ստեղծել հաշիվ և միանալ',
  'Filling…': 'Լրացվում է…',
  'Fill the agenda': 'Լրացնել օրակարգը',
  'Required for this outcome.': 'Պարտադիր է այս արդյունքի համար։',
  'The topic stays in the queue for a later meeting.':
    'Թեման մնում է հերթում՝ հետագա հանդիպման համար։',
  'Deferred items that came from a request return to the queue.':
    'Հարցումից եկած հետաձգված կետերը վերադառնում են հերթ։',
  'Record outcome': 'Գրանցել արդյունքը',
  'Create task': 'Ստեղծել առաջադրանք',
  'Schedule…': 'Նշանակել…',
  'Reschedule…': 'Վերանշանակել…',
  'Schedule the meeting': 'Նշանակել հանդիպումը',
  'Reschedule the meeting': 'Վերանշանակել հանդիպումը',
  'Save time': 'Պահպանել ժամը',
  'Save details': 'Պահպանել մանրամասները',
  'Save attendance': 'Պահպանել մասնակցությունը',
  'Save minutes': 'Պահպանել արձանագրությունը',
  'Add to the queue': 'Ավելացնել հերթում',
  'Queue item': 'Հերթի կետ',
  'Create meeting': 'Ստեղծել հանդիպում',
  'Change the title or role first.': 'Նախ փոխեք վերնագիրը կամ դերը։',
  'Save changes': 'Պահպանել փոփոխությունները',
  'Load more notifications': 'Բեռնել ավելի շատ ծանուցումներ',
  'The member': 'Անդամը',
  'Confirming…': 'Հաստատվում է…',
  Confirm: 'Հաստատել',
  'Counts for every founder.': 'Հաշվվում է յուրաքանչյուր հիմնադրի համար։',
  'Counts for your obligations.': 'Հաշվվում է ձեր պարտավորությունների համար։',
  'Searching…': 'Որոնվում է…',
  Ask: 'Հարցնել',
  'Nothing found.': 'Ոչինչ չի գտնվել։',
  'Read with AI help — check the filters': 'Կարդացվել է ԱԲ-ի օգնությամբ — ստուգեք զտիչները',
  'Read by built-in rules': 'Կարդացվել է ներկառուցված կանոններով',
  'Any time': 'Ցանկացած ժամանակ',
  'Unknown device': 'Անհայտ սարք',
  Verified: 'Հաստատված',
  'Not verified': 'Չհաստատված',
  'Preparing…': 'Նախապատրաստվում է…',
  'Set up authenticator app': 'Կարգավորել նույնականացման հավելվածը',
  'Verify and turn on': 'Ստուգել և միացնել',
  'Changing…': 'Փոխվում է…',
  'Change password': 'Փոխել գաղտնաբառը',
  'Your workspace requires': 'Ձեր աշխատատիրույթը պահանջում է',
  'No blockers': 'Արգելափակումներ չկան',
  'Deadline not set': 'Վերջնաժամկետը սահմանված չէ',
  'Evidence must be an http(s) link.': 'Ապացույցը պետք է լինի http(s) հղում։',
  'Choose the new owner.': 'Ընտրեք նոր սեփականատիրոջը։',
  'Reporting…': 'Հաղորդվում է…',
  'Report blocker': 'Հաղորդել արգելափակման մասին',
  'Loading tasks…': 'Առաջադրանքները բեռնվում են…',
  'Choose an open task': 'Ընտրեք բաց առաջադրանք',
  'Posting…': 'Հրապարակվում է…',
  'Post comment': 'Հրապարակել մեկնաբանությունը',
  Nobody: 'Ոչ ոք',
  'Load newer comments': 'Բեռնել ավելի նոր մեկնաբանություններ',
  'Mention at most 20 members.': 'Նշեք առավելագույնը 20 անդամ։',
  'Write a comment (up to 20000 characters).': 'Գրեք մեկնաբանություն (մինչև 20000 նիշ)։',
  'Post reply': 'Հրապարակել պատասխանը',
  'Unmark key argument': 'Հանել հիմնական փաստարկի նշումը',
  'Mark as key argument': 'Նշել որպես հիմնական փաստարկ',
  'Save comment': 'Պահպանել մեկնաբանությունը',
  'Propose option': 'Առաջարկել տարբերակ',
  'Save option': 'Պահպանել տարբերակը',
  Following: 'Հետևում եք',
  Follow: 'Հետևել',
  'No context yet.': 'Համատեքստ դեռ չկա։',
  'Not described yet.': 'Դեռ նկարագրված չէ։',
  'This status needs a reason of at least 3 characters.':
    'Այս կարգավիճակի համար անհրաժեշտ է առնվազն 3 նիշից բաղկացած պատճառ։',
  'A reason must have at least 3 characters.': 'Պատճառը պետք է պարունակի առնվազն 3 նիշ։',
  'Required for this status. Recorded in the history.':
    'Պարտադիր է այս կարգավիճակի համար։ Գրանցվում է պատմության մեջ։',
  'Optional. Recorded in the history.': 'Ըստ ցանկության։ Գրանցվում է պատմության մեջ։',
  'Save participants': 'Պահպանել մասնակիցներին',
  'Load older periods': 'Բեռնել ավելի հին ժամանակահատվածներ',
  Untitled: 'Անանուն',
  'Continue draft': 'Շարունակել սևագիրը',
  'Current version': 'Ընթացիկ տարբերակ',
  'Submit amendment…': 'Ուղարկել փոփոխությունը…',
  'Submit update…': 'Ուղարկել թարմացումը…',
  'Submit this amendment?': 'Ուղարկե՞լ այս փոփոխությունը',
  'Submit your update?': 'Ուղարկե՞լ ձեր թարմացումը',
  'Submit amendment': 'Ուղարկել փոփոխությունը',
  'Submit update': 'Ուղարկել թարմացումը',
  'You are not expected to report for this period.':
    'Այս ժամանակահատվածի համար ձեզնից հաշվետվություն չի սպասվում։',
  'Amend your update': 'Փոփոխել ձեր թարմացումը',
  'Your update': 'Ձեր թարմացումը',
  'Withdraw this proposed set?': 'Հետ կանչե՞լ այս առաջարկված հավաքածուն',
  'Reject this proposed set?': 'Մերժե՞լ այս առաջարկված հավաքածուն',
  'Withdraw set': 'Հետ կանչել հավաքածուն',
  'Reject set': 'Մերժել հավաքածուն',
  'Approve set': 'Հաստատել հավաքածուն',
  'Changed (reason given)': 'Փոփոխված (պատճառը նշված է)',
  Defaults: 'Լռելյայն արժեքներ',
  'Percent, e.g. 25 or 12.5.': 'Տոկոս, օրինակ՝ 25 կամ 12.5։',
  'No approved set — not applied': 'Հաստատված հավաքածու չկա — չի կիրառվում',
  'Do not apply': 'Չկիրառել',
  'Required because an assumption was changed. Stored with the snapshot.':
    'Պարտադիր է, քանի որ ենթադրությունը փոփոխվել է։ Պահվում է պատկերի հետ։',
  'Only needed when you change an assumption.': 'Անհրաժեշտ է միայն ենթադրությունը փոխելիս։',
  'Load older snapshots': 'Բեռնել ավելի հին պատկերներ',
  'Starting…': 'Մեկնարկվում է…',
  'Start voting': 'Սկսել քվեարկությունը',
  'Save draft round': 'Պահպանել փուլի սևագիրը',
  'Unknown option': 'Անհայտ տարբերակ',
  'Final result': 'Վերջնական արդյունք',
  'Current tally': 'Ընթացիկ հաշվարկ',
  Met: 'Կատարված',
  'Not met': 'Չկատարված',
  'The eligible voter list is fixed when the round opens.':
    'Քվեարկելու իրավունք ունեցողների ցանկը ֆիքսվում է փուլի բացման պահին։',
  'No eligible voters were recorded.': 'Քվեարկելու իրավունք ունեցողներ չեն գրանցվել։',
  'Not voted': 'Չի քվեարկել',
  'Choose how you vote.': 'Ընտրեք, թե ինչպես եք քվեարկում։',
  'Check your vote.': 'Ստուգեք ձեր քվեն։',
  'Change your vote': 'Փոխել ձեր քվեն',
  'Your vote': 'Ձեր քվեն',
  'Review vote change': 'Դիտել քվեի փոփոխությունը',
  'Review and submit vote': 'Դիտել և ուղարկել քվեն',
  'Change your vote?': 'Փոխե՞լ ձեր քվեն',
  'Submit your vote?': 'Ուղարկե՞լ ձեր քվեն',
  'Change vote': 'Փոխել քվեն',
  'Submit vote': 'Ուղարկել քվեն',
  'Reopen with a new deadline': 'Վերաբացել նոր վերջնաժամկետով',
  'Extend deadline': 'Երկարաձգել վերջնաժամկետը',
  member: 'անդամ',
  Deactivate: 'Ապաակտիվացնել',
  Reactivate: 'Վերաակտիվացնել',
  'Reason:': 'Պատճառ:',
  'Deactivate member': 'Ապաակտիվացնել անդամին',
  'Reactivate member': 'Վերաակտիվացնել անդամին',
  'They will lose access to this workspace immediately. Their history, votes, debts and records are kept.':
    'Նրանք անմիջապես կկորցնեն մուտքը այս աշխատատիրույթ։ Նրանց պատմությունը, քվեները, պարտքերը և գրառումները պահպանվում են։',
  'They will regain access with their current role.':
    'Նրանք կվերականգնեն մուտքը իրենց ներկայիս դերով։',
  'Funding call closed; unpaid shares are now debts to the company.':
    'Ֆինանսավորման կանչը փակվել է. չվճարված բաժիններն այժմ պարտքեր են ընկերությանը։',
  'Money a founder paid into a company account for this call. Paying someone else’s share records that founder’s debt to the payer; anything beyond the shares becomes a credit owed to the payer — it is never redistributed silently.':
    'Գումար, որը հիմնադիրը վճարել է ընկերության հաշվին այս կանչի համար։ Ուրիշի բաժինը վճարելիս գրանցվում է այդ հիմնադրի պարտքը վճարողին. բաժիններից ավելին դառնում է վճարողին հասանելիք կրեդիտ — այն երբեք լուռ չի վերաբաշխվում։',
  'This period is closed; no more submissions are accepted.':
    'Այս ժամանակահատվածը փակված է. նոր ուղարկումներ այլևս չեն ընդունվում։',
  'Percent, e.g. 62.5; may be negative.': 'Տոկոս, օրինակ՝ 62.5. կարող է լինել բացասական։',
};
